/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * API виробничої системи
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppsBomApiCreateAssemblyEndpoint400,
  AppsBomApiCreateAssemblyEndpoint409,
  AppsBomApiCreateComponentEndpoint400,
  AppsBomApiCreateComponentEndpoint409,
  AppsBomApiCreateGroupEndpoint400,
  AppsBomApiCreateGroupEndpoint409,
  AppsBomApiCreatePartEndpoint400,
  AppsBomApiCreatePartEndpoint409,
  AppsBomApiCreateProjectEndpoint400,
  AppsBomApiCreateProjectEndpoint409,
  AppsBomApiCreateUnitEndpoint400,
  AppsBomApiCreateUnitEndpoint409,
  AppsBomApiDeleteAssemblyEndpoint409,
  AppsBomApiDeleteComponentEndpoint409,
  AppsBomApiDeleteGroupEndpoint409,
  AppsBomApiDeletePartEndpoint409,
  AppsBomApiDeleteProjectEndpoint404,
  AppsBomApiDeleteProjectEndpoint409,
  AppsBomApiDeleteUnitEndpoint409,
  AppsBomApiGetGlobalNomenclatureTreeParams,
  AppsBomApiGetStructureTreeParams,
  AppsBomApiImportAiKit403,
  AppsBomApiImportCommitImport400,
  AppsBomApiImportCommitImport404,
  AppsBomApiImportCommitImport409,
  AppsBomApiImportLinkProjectDrawings404,
  AppsBomApiImportPreviewImport400,
  AppsBomApiImportPreviewImport404,
  AppsBomApiImportPreviewImport409,
  AppsBomApiImportUploadDrawingFiles400,
  AppsBomApiImportUploadDrawingFiles404,
  AppsBomApiImportUploadDrawingFilesBody,
  AppsBomApiListAssembliesAvailabilityParams,
  AppsBomApiListDrawingFilesParams,
  AppsBomApiListDrawingSheetsParams,
  AppsBomApiListGroupsParams,
  AppsBomApiListPartsAvailabilityParams,
  AppsBomApiListUnitsParams,
  AppsBomApiUpdateAssemblyEndpoint400,
  AppsBomApiUpdateAssemblyEndpoint409,
  AppsBomApiUpdateComponentEndpoint400,
  AppsBomApiUpdateComponentEndpoint409,
  AppsBomApiUpdateGroupEndpoint400,
  AppsBomApiUpdateGroupEndpoint409,
  AppsBomApiUpdatePartEndpoint400,
  AppsBomApiUpdatePartEndpoint409,
  AppsBomApiUpdateProjectEndpoint400,
  AppsBomApiUpdateProjectEndpoint404,
  AppsBomApiUpdateProjectEndpoint409,
  AppsBomApiUpdateUnitEndpoint400,
  AppsBomApiUpdateUnitEndpoint409,
  AppsCatalogApiDeleteMaterial409,
  AppsCatalogApiListMaterialsParams,
  AppsCoreApiCreatePositionEndpoint400,
  AppsCoreApiCreatePositionEndpoint409,
  AppsCoreApiCreateUserEndpoint400,
  AppsCoreApiCreateUserEndpoint409,
  AppsCoreApiDeletePositionEndpoint409,
  AppsCoreApiListPositionsEndpointParams,
  AppsCoreApiListUsersEndpointParams,
  AppsCoreApiUpdatePositionEndpoint400,
  AppsCoreApiUpdatePositionEndpoint409,
  AppsCoreApiUpdateUserEndpoint400,
  AppsCoreApiUpdateUserEndpoint409,
  AppsInventoryApiDeleteReceipt409,
  AppsInventoryApiGetStockOriginsParams,
  AppsInventoryApiListLotsParams,
  AppsInventoryApiListMaterialStockLotsParams,
  AppsInventoryApiListMsiParams,
  AppsInventoryApiListReceiptsGlobalParams,
  AppsInventoryApiListStockParams,
  AppsInventoryApiUnpostReceiptEndpoint409,
  AppsReportsApiStockMovementsParams,
  AppsWarehouseApiListGoodsReceiptsParams,
  AppsWarehouseApiListTransfersParams,
  AppsWarehouseApiListWarehousesParams,
  AppsWorkordersApiCreateOperationEndpoint400,
  AppsWorkordersApiCreateOperationEndpoint409,
  AppsWorkordersApiDeleteOperationEndpoint409,
  AppsWorkordersApiDeleteWorkOrder409,
  AppsWorkordersApiListCutPlanSources200Item,
  AppsWorkordersApiListMaterialIssuesGlobalParams,
  AppsWorkordersApiListOperationsParams,
  AppsWorkordersApiListProductionReportsGlobalParams,
  AppsWorkordersApiListWorkOrdersParams,
  AppsWorkordersApiPostMaterialIssueGlobal400,
  AppsWorkordersApiUpdateOperationEndpoint400,
  AppsWorkordersApiUpdateOperationEndpoint409,
  AssemblyAvailability,
  AssemblyComponentCreate,
  AssemblyComponentOut,
  AssemblyComponentUpdate,
  AssemblyCreate,
  AssemblyOut,
  AssemblySchema,
  AssemblyUpdate,
  CommitOut,
  CutPlanLineOut,
  CutPlanPlacementOut,
  CutPlanReplaceIn,
  CutPlanReplaceResult,
  DeficitsResponse,
  DeletePreflightOut,
  DrawingFileOut,
  DrawingSheetOut,
  DrawingUploadOut,
  FillFromAssembliesIn,
  FillFromAssembliesOut,
  GlobalNomenclatureTreeOut,
  GoodsReceiptCreateIn,
  GoodsReceiptDraftCreateIn,
  GoodsReceiptOut,
  GoodsReceiptUpdateIn,
  ImportRequest,
  IssueLineOut,
  IssueLineUpdate,
  LinkDrawingsOut,
  LoginPayload,
  MaterialCreate,
  MaterialIssueDraftCreateIn,
  MaterialIssueOut,
  MaterialIssueUpdateIn,
  MaterialOut,
  MaterialUpdate,
  NomenclatureGroupCreate,
  NomenclatureGroupOut,
  NomenclatureGroupUpdate,
  OperationCreate,
  OperationOut,
  OperationUpdate,
  OutputLineCreate,
  OutputLineOut,
  OutputLineUpdate,
  PaginatedMaterialStockItems,
  PaginatedMaterialStockLots,
  PaginatedStockLots,
  PaginatedWorkOrders,
  PartAvailability,
  PartCreate,
  PartOut,
  PartSchema,
  PartStockByWarehouse,
  PartUpdate,
  PendingWOOut,
  PositionCreate,
  PositionOut,
  PositionUpdate,
  PostIn,
  PreviewOut,
  ProductionReportDraftCreateIn,
  ProductionReportOut,
  ProductionReportUpdateIn,
  ProjectCreate,
  ProjectSchema,
  ProjectUpdate,
  StockListResponse,
  StockMovementsReportOut,
  StockOriginsResponse,
  StockReceiptLineCreate,
  StockReceiptLineOut,
  StockReceiptLineUpdate,
  StockReceiptOut,
  StockReceiptUpdate,
  StructureTreeOut,
  TaskLineBulkFromMaterialIn,
  TaskLineBulkFromMaterialOut,
  TaskLineCreate,
  TaskLineOut,
  TaskLineUpdate,
  TransferIn,
  TransferOut,
  TransferPatch,
  UnitOfMeasureCreate,
  UnitOfMeasureOut,
  UnitOfMeasureUpdate,
  UnpostIn,
  UsedInAssemblyOut,
  UsedInPartOut,
  UserCreate,
  UserOut,
  UserUpdate,
  WarehouseIn,
  WarehouseOut,
  WarehousePatch,
  WorkOrderCreate,
  WorkOrderOut,
  WorkOrderProgressOut,
  WorkOrderUpdate
} from './.';

import { customFetch } from '../fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Health
 */
export type appsCoreApiHealthResponse200 = {
  data: void
  status: 200
}

export type appsCoreApiHealthResponseSuccess = (appsCoreApiHealthResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiHealthResponse = (appsCoreApiHealthResponseSuccess)

export const getAppsCoreApiHealthUrl = () => {




  return `/api/health`
}

export const appsCoreApiHealth = async ( options?: RequestInit): Promise<appsCoreApiHealthResponse> => {

  return customFetch<appsCoreApiHealthResponse>(getAppsCoreApiHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCoreApiHealthQueryKey = () => {
    return [
    `/api/health`
    ] as const;
    }


export const getAppsCoreApiHealthQueryOptions = <TData = Awaited<ReturnType<typeof appsCoreApiHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCoreApiHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCoreApiHealth>>> = ({ signal }) => appsCoreApiHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCoreApiHealthQueryResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiHealth>>>
export type AppsCoreApiHealthQueryError = unknown


export function useAppsCoreApiHealth<TData = Awaited<ReturnType<typeof appsCoreApiHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiHealth>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiHealth<TData = Awaited<ReturnType<typeof appsCoreApiHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiHealth>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiHealth<TData = Awaited<ReturnType<typeof appsCoreApiHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health
 */

export function useAppsCoreApiHealth<TData = Awaited<ReturnType<typeof appsCoreApiHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCoreApiHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Auth Login
 */
export type appsCoreApiAuthLoginResponse200 = {
  data: void
  status: 200
}

export type appsCoreApiAuthLoginResponseSuccess = (appsCoreApiAuthLoginResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiAuthLoginResponse = (appsCoreApiAuthLoginResponseSuccess)

export const getAppsCoreApiAuthLoginUrl = () => {




  return `/api/auth/login`
}

export const appsCoreApiAuthLogin = async (loginPayload: LoginPayload, options?: RequestInit): Promise<appsCoreApiAuthLoginResponse> => {

  return customFetch<appsCoreApiAuthLoginResponse>(getAppsCoreApiAuthLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loginPayload,)
  }
);}




export const getAppsCoreApiAuthLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogin>>, TError,{data: LoginPayload}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogin>>, TError,{data: LoginPayload}, TContext> => {

const mutationKey = ['appsCoreApiAuthLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiAuthLogin>>, {data: LoginPayload}> = (props) => {
          const {data} = props ?? {};

          return  appsCoreApiAuthLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiAuthLogin>>>
    export type AppsCoreApiAuthLoginMutationBody = LoginPayload
    export type AppsCoreApiAuthLoginMutationError = unknown

    /**
 * @summary Auth Login
 */
export const useAppsCoreApiAuthLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogin>>, TError,{data: LoginPayload}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiAuthLogin>>,
        TError,
        {data: LoginPayload},
        TContext
      > => {
      return useMutation(getAppsCoreApiAuthLoginMutationOptions(options), queryClient);
    }

/**
 * @summary Auth Logout
 */
export type appsCoreApiAuthLogoutResponse200 = {
  data: void
  status: 200
}

export type appsCoreApiAuthLogoutResponseSuccess = (appsCoreApiAuthLogoutResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiAuthLogoutResponse = (appsCoreApiAuthLogoutResponseSuccess)

export const getAppsCoreApiAuthLogoutUrl = () => {




  return `/api/auth/logout`
}

export const appsCoreApiAuthLogout = async ( options?: RequestInit): Promise<appsCoreApiAuthLogoutResponse> => {

  return customFetch<appsCoreApiAuthLogoutResponse>(getAppsCoreApiAuthLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsCoreApiAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogout>>, TError,void, TContext> => {

const mutationKey = ['appsCoreApiAuthLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiAuthLogout>>, void> = () => {


          return  appsCoreApiAuthLogout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiAuthLogout>>>

    export type AppsCoreApiAuthLogoutMutationError = unknown

    /**
 * @summary Auth Logout
 */
export const useAppsCoreApiAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiAuthLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAppsCoreApiAuthLogoutMutationOptions(options), queryClient);
    }

/**
 * @summary Auth Me
 */
export type appsCoreApiAuthMeResponse200 = {
  data: void
  status: 200
}

export type appsCoreApiAuthMeResponseSuccess = (appsCoreApiAuthMeResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiAuthMeResponse = (appsCoreApiAuthMeResponseSuccess)

export const getAppsCoreApiAuthMeUrl = () => {




  return `/api/auth/me`
}

export const appsCoreApiAuthMe = async ( options?: RequestInit): Promise<appsCoreApiAuthMeResponse> => {

  return customFetch<appsCoreApiAuthMeResponse>(getAppsCoreApiAuthMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCoreApiAuthMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getAppsCoreApiAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCoreApiAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCoreApiAuthMe>>> = ({ signal }) => appsCoreApiAuthMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCoreApiAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiAuthMe>>>
export type AppsCoreApiAuthMeQueryError = unknown


export function useAppsCoreApiAuthMe<TData = Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiAuthMe>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiAuthMe<TData = Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiAuthMe>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiAuthMe<TData = Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Auth Me
 */

export function useAppsCoreApiAuthMe<TData = Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCoreApiAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Auth Csrf
 */
export type appsCoreApiAuthCsrfResponse200 = {
  data: void
  status: 200
}

export type appsCoreApiAuthCsrfResponseSuccess = (appsCoreApiAuthCsrfResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiAuthCsrfResponse = (appsCoreApiAuthCsrfResponseSuccess)

export const getAppsCoreApiAuthCsrfUrl = () => {




  return `/api/auth/csrf`
}

export const appsCoreApiAuthCsrf = async ( options?: RequestInit): Promise<appsCoreApiAuthCsrfResponse> => {

  return customFetch<appsCoreApiAuthCsrfResponse>(getAppsCoreApiAuthCsrfUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCoreApiAuthCsrfQueryKey = () => {
    return [
    `/api/auth/csrf`
    ] as const;
    }


export const getAppsCoreApiAuthCsrfQueryOptions = <TData = Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCoreApiAuthCsrfQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>> = ({ signal }) => appsCoreApiAuthCsrf({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCoreApiAuthCsrfQueryResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>>
export type AppsCoreApiAuthCsrfQueryError = unknown


export function useAppsCoreApiAuthCsrf<TData = Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiAuthCsrf<TData = Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiAuthCsrf<TData = Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Auth Csrf
 */

export function useAppsCoreApiAuthCsrf<TData = Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiAuthCsrf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCoreApiAuthCsrfQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Users Endpoint
 */
export type appsCoreApiListUsersEndpointResponse200 = {
  data: UserOut[]
  status: 200
}

export type appsCoreApiListUsersEndpointResponseSuccess = (appsCoreApiListUsersEndpointResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiListUsersEndpointResponse = (appsCoreApiListUsersEndpointResponseSuccess)

export const getAppsCoreApiListUsersEndpointUrl = (params?: AppsCoreApiListUsersEndpointParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/?${stringifiedParams}` : `/api/users/`
}

export const appsCoreApiListUsersEndpoint = async (params?: AppsCoreApiListUsersEndpointParams, options?: RequestInit): Promise<appsCoreApiListUsersEndpointResponse> => {

  return customFetch<appsCoreApiListUsersEndpointResponse>(getAppsCoreApiListUsersEndpointUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCoreApiListUsersEndpointQueryKey = (params?: AppsCoreApiListUsersEndpointParams,) => {
    return [
    `/api/users/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsCoreApiListUsersEndpointQueryOptions = <TData = Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError = unknown>(params?: AppsCoreApiListUsersEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCoreApiListUsersEndpointQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>> = ({ signal }) => appsCoreApiListUsersEndpoint(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCoreApiListUsersEndpointQueryResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>>
export type AppsCoreApiListUsersEndpointQueryError = unknown


export function useAppsCoreApiListUsersEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError = unknown>(
 params: undefined |  AppsCoreApiListUsersEndpointParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiListUsersEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListUsersEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiListUsersEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListUsersEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Users Endpoint
 */

export function useAppsCoreApiListUsersEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListUsersEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListUsersEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCoreApiListUsersEndpointQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create User Endpoint
 */
export type appsCoreApiCreateUserEndpointResponse200 = {
  data: UserOut
  status: 200
}

export type appsCoreApiCreateUserEndpointResponse400 = {
  data: AppsCoreApiCreateUserEndpoint400
  status: 400
}

export type appsCoreApiCreateUserEndpointResponse409 = {
  data: AppsCoreApiCreateUserEndpoint409
  status: 409
}

export type appsCoreApiCreateUserEndpointResponseSuccess = (appsCoreApiCreateUserEndpointResponse200) & {
  headers: Headers;
};
export type appsCoreApiCreateUserEndpointResponseError = (appsCoreApiCreateUserEndpointResponse400 | appsCoreApiCreateUserEndpointResponse409) & {
  headers: Headers;
};

export type appsCoreApiCreateUserEndpointResponse = (appsCoreApiCreateUserEndpointResponseSuccess | appsCoreApiCreateUserEndpointResponseError)

export const getAppsCoreApiCreateUserEndpointUrl = () => {




  return `/api/users/`
}

export const appsCoreApiCreateUserEndpoint = async (userCreate: UserCreate, options?: RequestInit): Promise<appsCoreApiCreateUserEndpointResponse> => {

  return customFetch<appsCoreApiCreateUserEndpointResponse>(getAppsCoreApiCreateUserEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userCreate,)
  }
);}




export const getAppsCoreApiCreateUserEndpointMutationOptions = <TError = AppsCoreApiCreateUserEndpoint400 | AppsCoreApiCreateUserEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>, TError,{data: UserCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>, TError,{data: UserCreate}, TContext> => {

const mutationKey = ['appsCoreApiCreateUserEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>, {data: UserCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsCoreApiCreateUserEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiCreateUserEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>>
    export type AppsCoreApiCreateUserEndpointMutationBody = UserCreate
    export type AppsCoreApiCreateUserEndpointMutationError = AppsCoreApiCreateUserEndpoint400 | AppsCoreApiCreateUserEndpoint409

    /**
 * @summary Create User Endpoint
 */
export const useAppsCoreApiCreateUserEndpoint = <TError = AppsCoreApiCreateUserEndpoint400 | AppsCoreApiCreateUserEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>, TError,{data: UserCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiCreateUserEndpoint>>,
        TError,
        {data: UserCreate},
        TContext
      > => {
      return useMutation(getAppsCoreApiCreateUserEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update User Endpoint
 */
export type appsCoreApiUpdateUserEndpointResponse200 = {
  data: UserOut
  status: 200
}

export type appsCoreApiUpdateUserEndpointResponse400 = {
  data: AppsCoreApiUpdateUserEndpoint400
  status: 400
}

export type appsCoreApiUpdateUserEndpointResponse409 = {
  data: AppsCoreApiUpdateUserEndpoint409
  status: 409
}

export type appsCoreApiUpdateUserEndpointResponseSuccess = (appsCoreApiUpdateUserEndpointResponse200) & {
  headers: Headers;
};
export type appsCoreApiUpdateUserEndpointResponseError = (appsCoreApiUpdateUserEndpointResponse400 | appsCoreApiUpdateUserEndpointResponse409) & {
  headers: Headers;
};

export type appsCoreApiUpdateUserEndpointResponse = (appsCoreApiUpdateUserEndpointResponseSuccess | appsCoreApiUpdateUserEndpointResponseError)

export const getAppsCoreApiUpdateUserEndpointUrl = (userId: number,) => {




  return `/api/users/${userId}`
}

export const appsCoreApiUpdateUserEndpoint = async (userId: number,
    userUpdate: UserUpdate, options?: RequestInit): Promise<appsCoreApiUpdateUserEndpointResponse> => {

  return customFetch<appsCoreApiUpdateUserEndpointResponse>(getAppsCoreApiUpdateUserEndpointUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userUpdate,)
  }
);}




export const getAppsCoreApiUpdateUserEndpointMutationOptions = <TError = AppsCoreApiUpdateUserEndpoint400 | AppsCoreApiUpdateUserEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>, TError,{userId: number;data: UserUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>, TError,{userId: number;data: UserUpdate}, TContext> => {

const mutationKey = ['appsCoreApiUpdateUserEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>, {userId: number;data: UserUpdate}> = (props) => {
          const {userId,data} = props ?? {};

          return  appsCoreApiUpdateUserEndpoint(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiUpdateUserEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>>
    export type AppsCoreApiUpdateUserEndpointMutationBody = UserUpdate
    export type AppsCoreApiUpdateUserEndpointMutationError = AppsCoreApiUpdateUserEndpoint400 | AppsCoreApiUpdateUserEndpoint409

    /**
 * @summary Update User Endpoint
 */
export const useAppsCoreApiUpdateUserEndpoint = <TError = AppsCoreApiUpdateUserEndpoint400 | AppsCoreApiUpdateUserEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>, TError,{userId: number;data: UserUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiUpdateUserEndpoint>>,
        TError,
        {userId: number;data: UserUpdate},
        TContext
      > => {
      return useMutation(getAppsCoreApiUpdateUserEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Positions Endpoint
 */
export type appsCoreApiListPositionsEndpointResponse200 = {
  data: PositionOut[]
  status: 200
}

export type appsCoreApiListPositionsEndpointResponseSuccess = (appsCoreApiListPositionsEndpointResponse200) & {
  headers: Headers;
};
;

export type appsCoreApiListPositionsEndpointResponse = (appsCoreApiListPositionsEndpointResponseSuccess)

export const getAppsCoreApiListPositionsEndpointUrl = (params?: AppsCoreApiListPositionsEndpointParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/positions?${stringifiedParams}` : `/api/positions`
}

export const appsCoreApiListPositionsEndpoint = async (params?: AppsCoreApiListPositionsEndpointParams, options?: RequestInit): Promise<appsCoreApiListPositionsEndpointResponse> => {

  return customFetch<appsCoreApiListPositionsEndpointResponse>(getAppsCoreApiListPositionsEndpointUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCoreApiListPositionsEndpointQueryKey = (params?: AppsCoreApiListPositionsEndpointParams,) => {
    return [
    `/api/positions`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsCoreApiListPositionsEndpointQueryOptions = <TData = Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError = unknown>(params?: AppsCoreApiListPositionsEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCoreApiListPositionsEndpointQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>> = ({ signal }) => appsCoreApiListPositionsEndpoint(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCoreApiListPositionsEndpointQueryResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>>
export type AppsCoreApiListPositionsEndpointQueryError = unknown


export function useAppsCoreApiListPositionsEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError = unknown>(
 params: undefined |  AppsCoreApiListPositionsEndpointParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiListPositionsEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListPositionsEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>,
          TError,
          Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCoreApiListPositionsEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListPositionsEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Positions Endpoint
 */

export function useAppsCoreApiListPositionsEndpoint<TData = Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError = unknown>(
 params?: AppsCoreApiListPositionsEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCoreApiListPositionsEndpoint>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCoreApiListPositionsEndpointQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Position Endpoint
 */
export type appsCoreApiCreatePositionEndpointResponse200 = {
  data: PositionOut
  status: 200
}

export type appsCoreApiCreatePositionEndpointResponse400 = {
  data: AppsCoreApiCreatePositionEndpoint400
  status: 400
}

export type appsCoreApiCreatePositionEndpointResponse409 = {
  data: AppsCoreApiCreatePositionEndpoint409
  status: 409
}

export type appsCoreApiCreatePositionEndpointResponseSuccess = (appsCoreApiCreatePositionEndpointResponse200) & {
  headers: Headers;
};
export type appsCoreApiCreatePositionEndpointResponseError = (appsCoreApiCreatePositionEndpointResponse400 | appsCoreApiCreatePositionEndpointResponse409) & {
  headers: Headers;
};

export type appsCoreApiCreatePositionEndpointResponse = (appsCoreApiCreatePositionEndpointResponseSuccess | appsCoreApiCreatePositionEndpointResponseError)

export const getAppsCoreApiCreatePositionEndpointUrl = () => {




  return `/api/positions`
}

export const appsCoreApiCreatePositionEndpoint = async (positionCreate: PositionCreate, options?: RequestInit): Promise<appsCoreApiCreatePositionEndpointResponse> => {

  return customFetch<appsCoreApiCreatePositionEndpointResponse>(getAppsCoreApiCreatePositionEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      positionCreate,)
  }
);}




export const getAppsCoreApiCreatePositionEndpointMutationOptions = <TError = AppsCoreApiCreatePositionEndpoint400 | AppsCoreApiCreatePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>, TError,{data: PositionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>, TError,{data: PositionCreate}, TContext> => {

const mutationKey = ['appsCoreApiCreatePositionEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>, {data: PositionCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsCoreApiCreatePositionEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiCreatePositionEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>>
    export type AppsCoreApiCreatePositionEndpointMutationBody = PositionCreate
    export type AppsCoreApiCreatePositionEndpointMutationError = AppsCoreApiCreatePositionEndpoint400 | AppsCoreApiCreatePositionEndpoint409

    /**
 * @summary Create Position Endpoint
 */
export const useAppsCoreApiCreatePositionEndpoint = <TError = AppsCoreApiCreatePositionEndpoint400 | AppsCoreApiCreatePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>, TError,{data: PositionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiCreatePositionEndpoint>>,
        TError,
        {data: PositionCreate},
        TContext
      > => {
      return useMutation(getAppsCoreApiCreatePositionEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update Position Endpoint
 */
export type appsCoreApiUpdatePositionEndpointResponse200 = {
  data: PositionOut
  status: 200
}

export type appsCoreApiUpdatePositionEndpointResponse400 = {
  data: AppsCoreApiUpdatePositionEndpoint400
  status: 400
}

export type appsCoreApiUpdatePositionEndpointResponse409 = {
  data: AppsCoreApiUpdatePositionEndpoint409
  status: 409
}

export type appsCoreApiUpdatePositionEndpointResponseSuccess = (appsCoreApiUpdatePositionEndpointResponse200) & {
  headers: Headers;
};
export type appsCoreApiUpdatePositionEndpointResponseError = (appsCoreApiUpdatePositionEndpointResponse400 | appsCoreApiUpdatePositionEndpointResponse409) & {
  headers: Headers;
};

export type appsCoreApiUpdatePositionEndpointResponse = (appsCoreApiUpdatePositionEndpointResponseSuccess | appsCoreApiUpdatePositionEndpointResponseError)

export const getAppsCoreApiUpdatePositionEndpointUrl = (positionId: number,) => {




  return `/api/positions/${positionId}`
}

export const appsCoreApiUpdatePositionEndpoint = async (positionId: number,
    positionUpdate: PositionUpdate, options?: RequestInit): Promise<appsCoreApiUpdatePositionEndpointResponse> => {

  return customFetch<appsCoreApiUpdatePositionEndpointResponse>(getAppsCoreApiUpdatePositionEndpointUrl(positionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      positionUpdate,)
  }
);}




export const getAppsCoreApiUpdatePositionEndpointMutationOptions = <TError = AppsCoreApiUpdatePositionEndpoint400 | AppsCoreApiUpdatePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>, TError,{positionId: number;data: PositionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>, TError,{positionId: number;data: PositionUpdate}, TContext> => {

const mutationKey = ['appsCoreApiUpdatePositionEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>, {positionId: number;data: PositionUpdate}> = (props) => {
          const {positionId,data} = props ?? {};

          return  appsCoreApiUpdatePositionEndpoint(positionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiUpdatePositionEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>>
    export type AppsCoreApiUpdatePositionEndpointMutationBody = PositionUpdate
    export type AppsCoreApiUpdatePositionEndpointMutationError = AppsCoreApiUpdatePositionEndpoint400 | AppsCoreApiUpdatePositionEndpoint409

    /**
 * @summary Update Position Endpoint
 */
export const useAppsCoreApiUpdatePositionEndpoint = <TError = AppsCoreApiUpdatePositionEndpoint400 | AppsCoreApiUpdatePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>, TError,{positionId: number;data: PositionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiUpdatePositionEndpoint>>,
        TError,
        {positionId: number;data: PositionUpdate},
        TContext
      > => {
      return useMutation(getAppsCoreApiUpdatePositionEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Position Endpoint
 */
export type appsCoreApiDeletePositionEndpointResponse204 = {
  data: void
  status: 204
}

export type appsCoreApiDeletePositionEndpointResponse409 = {
  data: AppsCoreApiDeletePositionEndpoint409
  status: 409
}

export type appsCoreApiDeletePositionEndpointResponseSuccess = (appsCoreApiDeletePositionEndpointResponse204) & {
  headers: Headers;
};
export type appsCoreApiDeletePositionEndpointResponseError = (appsCoreApiDeletePositionEndpointResponse409) & {
  headers: Headers;
};

export type appsCoreApiDeletePositionEndpointResponse = (appsCoreApiDeletePositionEndpointResponseSuccess | appsCoreApiDeletePositionEndpointResponseError)

export const getAppsCoreApiDeletePositionEndpointUrl = (positionId: number,) => {




  return `/api/positions/${positionId}`
}

export const appsCoreApiDeletePositionEndpoint = async (positionId: number, options?: RequestInit): Promise<appsCoreApiDeletePositionEndpointResponse> => {

  return customFetch<appsCoreApiDeletePositionEndpointResponse>(getAppsCoreApiDeletePositionEndpointUrl(positionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsCoreApiDeletePositionEndpointMutationOptions = <TError = AppsCoreApiDeletePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>, TError,{positionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>, TError,{positionId: number}, TContext> => {

const mutationKey = ['appsCoreApiDeletePositionEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>, {positionId: number}> = (props) => {
          const {positionId} = props ?? {};

          return  appsCoreApiDeletePositionEndpoint(positionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCoreApiDeletePositionEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>>

    export type AppsCoreApiDeletePositionEndpointMutationError = AppsCoreApiDeletePositionEndpoint409

    /**
 * @summary Delete Position Endpoint
 */
export const useAppsCoreApiDeletePositionEndpoint = <TError = AppsCoreApiDeletePositionEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>, TError,{positionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCoreApiDeletePositionEndpoint>>,
        TError,
        {positionId: number},
        TContext
      > => {
      return useMutation(getAppsCoreApiDeletePositionEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Projects
 */
export type appsBomApiListProjectsResponse200 = {
  data: ProjectSchema[]
  status: 200
}

export type appsBomApiListProjectsResponseSuccess = (appsBomApiListProjectsResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListProjectsResponse = (appsBomApiListProjectsResponseSuccess)

export const getAppsBomApiListProjectsUrl = () => {




  return `/api/projects`
}

export const appsBomApiListProjects = async ( options?: RequestInit): Promise<appsBomApiListProjectsResponse> => {

  return customFetch<appsBomApiListProjectsResponse>(getAppsBomApiListProjectsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListProjectsQueryKey = () => {
    return [
    `/api/projects`
    ] as const;
    }


export const getAppsBomApiListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListProjects>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListProjects>>> = ({ signal }) => appsBomApiListProjects({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListProjects>>>
export type AppsBomApiListProjectsQueryError = unknown


export function useAppsBomApiListProjects<TData = Awaited<ReturnType<typeof appsBomApiListProjects>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListProjects>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListProjects<TData = Awaited<ReturnType<typeof appsBomApiListProjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListProjects>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListProjects<TData = Awaited<ReturnType<typeof appsBomApiListProjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Projects
 */

export function useAppsBomApiListProjects<TData = Awaited<ReturnType<typeof appsBomApiListProjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Project Endpoint
 */
export type appsBomApiCreateProjectEndpointResponse201 = {
  data: ProjectSchema
  status: 201
}

export type appsBomApiCreateProjectEndpointResponse400 = {
  data: AppsBomApiCreateProjectEndpoint400
  status: 400
}

export type appsBomApiCreateProjectEndpointResponse409 = {
  data: AppsBomApiCreateProjectEndpoint409
  status: 409
}

export type appsBomApiCreateProjectEndpointResponseSuccess = (appsBomApiCreateProjectEndpointResponse201) & {
  headers: Headers;
};
export type appsBomApiCreateProjectEndpointResponseError = (appsBomApiCreateProjectEndpointResponse400 | appsBomApiCreateProjectEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreateProjectEndpointResponse = (appsBomApiCreateProjectEndpointResponseSuccess | appsBomApiCreateProjectEndpointResponseError)

export const getAppsBomApiCreateProjectEndpointUrl = () => {




  return `/api/projects`
}

export const appsBomApiCreateProjectEndpoint = async (projectCreate: ProjectCreate, options?: RequestInit): Promise<appsBomApiCreateProjectEndpointResponse> => {

  return customFetch<appsBomApiCreateProjectEndpointResponse>(getAppsBomApiCreateProjectEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      projectCreate,)
  }
);}




export const getAppsBomApiCreateProjectEndpointMutationOptions = <TError = AppsBomApiCreateProjectEndpoint400 | AppsBomApiCreateProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>, TError,{data: ProjectCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>, TError,{data: ProjectCreate}, TContext> => {

const mutationKey = ['appsBomApiCreateProjectEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>, {data: ProjectCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsBomApiCreateProjectEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreateProjectEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>>
    export type AppsBomApiCreateProjectEndpointMutationBody = ProjectCreate
    export type AppsBomApiCreateProjectEndpointMutationError = AppsBomApiCreateProjectEndpoint400 | AppsBomApiCreateProjectEndpoint409

    /**
 * @summary Create Project Endpoint
 */
export const useAppsBomApiCreateProjectEndpoint = <TError = AppsBomApiCreateProjectEndpoint400 | AppsBomApiCreateProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>, TError,{data: ProjectCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreateProjectEndpoint>>,
        TError,
        {data: ProjectCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreateProjectEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Get Project
 */
export type appsBomApiGetProjectResponse200 = {
  data: ProjectSchema
  status: 200
}

export type appsBomApiGetProjectResponseSuccess = (appsBomApiGetProjectResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetProjectResponse = (appsBomApiGetProjectResponseSuccess)

export const getAppsBomApiGetProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

export const appsBomApiGetProject = async (projectId: number, options?: RequestInit): Promise<appsBomApiGetProjectResponse> => {

  return customFetch<appsBomApiGetProjectResponse>(getAppsBomApiGetProjectUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetProjectQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}`
    ] as const;
    }


export const getAppsBomApiGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetProject>>, TError = unknown>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetProjectQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetProject>>> = ({ signal }) => appsBomApiGetProject(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetProject>>>
export type AppsBomApiGetProjectQueryError = unknown


export function useAppsBomApiGetProject<TData = Awaited<ReturnType<typeof appsBomApiGetProject>>, TError = unknown>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetProject>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetProject<TData = Awaited<ReturnType<typeof appsBomApiGetProject>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetProject>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetProject<TData = Awaited<ReturnType<typeof appsBomApiGetProject>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Project
 */

export function useAppsBomApiGetProject<TData = Awaited<ReturnType<typeof appsBomApiGetProject>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetProjectQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Project Endpoint
 */
export type appsBomApiUpdateProjectEndpointResponse200 = {
  data: ProjectSchema
  status: 200
}

export type appsBomApiUpdateProjectEndpointResponse400 = {
  data: AppsBomApiUpdateProjectEndpoint400
  status: 400
}

export type appsBomApiUpdateProjectEndpointResponse404 = {
  data: AppsBomApiUpdateProjectEndpoint404
  status: 404
}

export type appsBomApiUpdateProjectEndpointResponse409 = {
  data: AppsBomApiUpdateProjectEndpoint409
  status: 409
}

export type appsBomApiUpdateProjectEndpointResponseSuccess = (appsBomApiUpdateProjectEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdateProjectEndpointResponseError = (appsBomApiUpdateProjectEndpointResponse400 | appsBomApiUpdateProjectEndpointResponse404 | appsBomApiUpdateProjectEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdateProjectEndpointResponse = (appsBomApiUpdateProjectEndpointResponseSuccess | appsBomApiUpdateProjectEndpointResponseError)

export const getAppsBomApiUpdateProjectEndpointUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

export const appsBomApiUpdateProjectEndpoint = async (projectId: number,
    projectUpdate: ProjectUpdate, options?: RequestInit): Promise<appsBomApiUpdateProjectEndpointResponse> => {

  return customFetch<appsBomApiUpdateProjectEndpointResponse>(getAppsBomApiUpdateProjectEndpointUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      projectUpdate,)
  }
);}




export const getAppsBomApiUpdateProjectEndpointMutationOptions = <TError = AppsBomApiUpdateProjectEndpoint400 | AppsBomApiUpdateProjectEndpoint404 | AppsBomApiUpdateProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>, TError,{projectId: number;data: ProjectUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>, TError,{projectId: number;data: ProjectUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdateProjectEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>, {projectId: number;data: ProjectUpdate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  appsBomApiUpdateProjectEndpoint(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdateProjectEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>>
    export type AppsBomApiUpdateProjectEndpointMutationBody = ProjectUpdate
    export type AppsBomApiUpdateProjectEndpointMutationError = AppsBomApiUpdateProjectEndpoint400 | AppsBomApiUpdateProjectEndpoint404 | AppsBomApiUpdateProjectEndpoint409

    /**
 * @summary Update Project Endpoint
 */
export const useAppsBomApiUpdateProjectEndpoint = <TError = AppsBomApiUpdateProjectEndpoint400 | AppsBomApiUpdateProjectEndpoint404 | AppsBomApiUpdateProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>, TError,{projectId: number;data: ProjectUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdateProjectEndpoint>>,
        TError,
        {projectId: number;data: ProjectUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdateProjectEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Project Endpoint
 */
export type appsBomApiDeleteProjectEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeleteProjectEndpointResponse404 = {
  data: AppsBomApiDeleteProjectEndpoint404
  status: 404
}

export type appsBomApiDeleteProjectEndpointResponse409 = {
  data: AppsBomApiDeleteProjectEndpoint409
  status: 409
}

export type appsBomApiDeleteProjectEndpointResponseSuccess = (appsBomApiDeleteProjectEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeleteProjectEndpointResponseError = (appsBomApiDeleteProjectEndpointResponse404 | appsBomApiDeleteProjectEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeleteProjectEndpointResponse = (appsBomApiDeleteProjectEndpointResponseSuccess | appsBomApiDeleteProjectEndpointResponseError)

export const getAppsBomApiDeleteProjectEndpointUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

export const appsBomApiDeleteProjectEndpoint = async (projectId: number, options?: RequestInit): Promise<appsBomApiDeleteProjectEndpointResponse> => {

  return customFetch<appsBomApiDeleteProjectEndpointResponse>(getAppsBomApiDeleteProjectEndpointUrl(projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeleteProjectEndpointMutationOptions = <TError = AppsBomApiDeleteProjectEndpoint404 | AppsBomApiDeleteProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>, TError,{projectId: number}, TContext> => {

const mutationKey = ['appsBomApiDeleteProjectEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>, {projectId: number}> = (props) => {
          const {projectId} = props ?? {};

          return  appsBomApiDeleteProjectEndpoint(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeleteProjectEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>>

    export type AppsBomApiDeleteProjectEndpointMutationError = AppsBomApiDeleteProjectEndpoint404 | AppsBomApiDeleteProjectEndpoint409

    /**
 * @summary Delete Project Endpoint
 */
export const useAppsBomApiDeleteProjectEndpoint = <TError = AppsBomApiDeleteProjectEndpoint404 | AppsBomApiDeleteProjectEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeleteProjectEndpoint>>,
        TError,
        {projectId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeleteProjectEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Parts
 */
export type appsBomApiListPartsResponse200 = {
  data: PartSchema[]
  status: 200
}

export type appsBomApiListPartsResponseSuccess = (appsBomApiListPartsResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListPartsResponse = (appsBomApiListPartsResponseSuccess)

export const getAppsBomApiListPartsUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/parts`
}

export const appsBomApiListParts = async (projectId: number, options?: RequestInit): Promise<appsBomApiListPartsResponse> => {

  return customFetch<appsBomApiListPartsResponse>(getAppsBomApiListPartsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListPartsQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/parts`
    ] as const;
    }


export const getAppsBomApiListPartsQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListParts>>, TError = unknown>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListPartsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListParts>>> = ({ signal }) => appsBomApiListParts(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListPartsQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListParts>>>
export type AppsBomApiListPartsQueryError = unknown


export function useAppsBomApiListParts<TData = Awaited<ReturnType<typeof appsBomApiListParts>>, TError = unknown>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListParts>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListParts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListParts<TData = Awaited<ReturnType<typeof appsBomApiListParts>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListParts>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListParts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListParts<TData = Awaited<ReturnType<typeof appsBomApiListParts>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Parts
 */

export function useAppsBomApiListParts<TData = Awaited<ReturnType<typeof appsBomApiListParts>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListParts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListPartsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Assemblies
 */
export type appsBomApiListAssembliesResponse200 = {
  data: AssemblySchema[]
  status: 200
}

export type appsBomApiListAssembliesResponseSuccess = (appsBomApiListAssembliesResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListAssembliesResponse = (appsBomApiListAssembliesResponseSuccess)

export const getAppsBomApiListAssembliesUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/assemblies`
}

export const appsBomApiListAssemblies = async (projectId: number, options?: RequestInit): Promise<appsBomApiListAssembliesResponse> => {

  return customFetch<appsBomApiListAssembliesResponse>(getAppsBomApiListAssembliesUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListAssembliesQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/assemblies`
    ] as const;
    }


export const getAppsBomApiListAssembliesQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError = unknown>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListAssembliesQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListAssemblies>>> = ({ signal }) => appsBomApiListAssemblies(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListAssembliesQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListAssemblies>>>
export type AppsBomApiListAssembliesQueryError = unknown


export function useAppsBomApiListAssemblies<TData = Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError = unknown>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssemblies>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssemblies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssemblies<TData = Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssemblies>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssemblies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssemblies<TData = Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assemblies
 */

export function useAppsBomApiListAssemblies<TData = Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssemblies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListAssembliesQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Parts Availability
 */
export type appsBomApiListPartsAvailabilityResponse200 = {
  data: PartAvailability[]
  status: 200
}

export type appsBomApiListPartsAvailabilityResponseSuccess = (appsBomApiListPartsAvailabilityResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListPartsAvailabilityResponse = (appsBomApiListPartsAvailabilityResponseSuccess)

export const getAppsBomApiListPartsAvailabilityUrl = (projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/parts-availability?${stringifiedParams}` : `/api/projects/${projectId}/parts-availability`
}

export const appsBomApiListPartsAvailability = async (projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams, options?: RequestInit): Promise<appsBomApiListPartsAvailabilityResponse> => {

  return customFetch<appsBomApiListPartsAvailabilityResponse>(getAppsBomApiListPartsAvailabilityUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListPartsAvailabilityQueryKey = (projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams,) => {
    return [
    `/api/projects/${projectId}/parts-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListPartsAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError = unknown>(projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListPartsAvailabilityQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>> = ({ signal }) => appsBomApiListPartsAvailability(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListPartsAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>>
export type AppsBomApiListPartsAvailabilityQueryError = unknown


export function useAppsBomApiListPartsAvailability<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsBomApiListPartsAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsAvailability<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsAvailability<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Parts Availability
 */

export function useAppsBomApiListPartsAvailability<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListPartsAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListPartsAvailabilityQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Assemblies Availability
 */
export type appsBomApiListAssembliesAvailabilityResponse200 = {
  data: AssemblyAvailability[]
  status: 200
}

export type appsBomApiListAssembliesAvailabilityResponseSuccess = (appsBomApiListAssembliesAvailabilityResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListAssembliesAvailabilityResponse = (appsBomApiListAssembliesAvailabilityResponseSuccess)

export const getAppsBomApiListAssembliesAvailabilityUrl = (projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/assemblies-availability?${stringifiedParams}` : `/api/projects/${projectId}/assemblies-availability`
}

export const appsBomApiListAssembliesAvailability = async (projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams, options?: RequestInit): Promise<appsBomApiListAssembliesAvailabilityResponse> => {

  return customFetch<appsBomApiListAssembliesAvailabilityResponse>(getAppsBomApiListAssembliesAvailabilityUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListAssembliesAvailabilityQueryKey = (projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams,) => {
    return [
    `/api/projects/${projectId}/assemblies-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListAssembliesAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError = unknown>(projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListAssembliesAvailabilityQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>> = ({ signal }) => appsBomApiListAssembliesAvailability(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListAssembliesAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>>
export type AppsBomApiListAssembliesAvailabilityQueryError = unknown


export function useAppsBomApiListAssembliesAvailability<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsBomApiListAssembliesAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesAvailability<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesAvailability<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assemblies Availability
 */

export function useAppsBomApiListAssembliesAvailability<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListAssembliesAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListAssembliesAvailabilityQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Наявні штуки деталей, згруповані по складах — колонка «Склад» у плані
видачі наряду зварювальника.
 * @summary List Parts Availability By Warehouse
 */
export type appsBomApiListPartsAvailabilityByWarehouseResponse200 = {
  data: PartStockByWarehouse[]
  status: 200
}

export type appsBomApiListPartsAvailabilityByWarehouseResponseSuccess = (appsBomApiListPartsAvailabilityByWarehouseResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListPartsAvailabilityByWarehouseResponse = (appsBomApiListPartsAvailabilityByWarehouseResponseSuccess)

export const getAppsBomApiListPartsAvailabilityByWarehouseUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/parts-availability-by-warehouse`
}

export const appsBomApiListPartsAvailabilityByWarehouse = async (projectId: number, options?: RequestInit): Promise<appsBomApiListPartsAvailabilityByWarehouseResponse> => {

  return customFetch<appsBomApiListPartsAvailabilityByWarehouseResponse>(getAppsBomApiListPartsAvailabilityByWarehouseUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListPartsAvailabilityByWarehouseQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/parts-availability-by-warehouse`
    ] as const;
    }


export const getAppsBomApiListPartsAvailabilityByWarehouseQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError = unknown>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListPartsAvailabilityByWarehouseQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>> = ({ signal }) => appsBomApiListPartsAvailabilityByWarehouse(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListPartsAvailabilityByWarehouseQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>>
export type AppsBomApiListPartsAvailabilityByWarehouseQueryError = unknown


export function useAppsBomApiListPartsAvailabilityByWarehouse<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError = unknown>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsAvailabilityByWarehouse<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsAvailabilityByWarehouse<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Parts Availability By Warehouse
 */

export function useAppsBomApiListPartsAvailabilityByWarehouse<TData = Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsAvailabilityByWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListPartsAvailabilityByWarehouseQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Structure Tree
 */
export type appsBomApiGetStructureTreeResponse200 = {
  data: StructureTreeOut
  status: 200
}

export type appsBomApiGetStructureTreeResponseSuccess = (appsBomApiGetStructureTreeResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetStructureTreeResponse = (appsBomApiGetStructureTreeResponseSuccess)

export const getAppsBomApiGetStructureTreeUrl = (projectId: number,
    params?: AppsBomApiGetStructureTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/structure-tree/?${stringifiedParams}` : `/api/projects/${projectId}/structure-tree/`
}

export const appsBomApiGetStructureTree = async (projectId: number,
    params?: AppsBomApiGetStructureTreeParams, options?: RequestInit): Promise<appsBomApiGetStructureTreeResponse> => {

  return customFetch<appsBomApiGetStructureTreeResponse>(getAppsBomApiGetStructureTreeUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetStructureTreeQueryKey = (projectId: number,
    params?: AppsBomApiGetStructureTreeParams,) => {
    return [
    `/api/projects/${projectId}/structure-tree/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiGetStructureTreeQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError = unknown>(projectId: number,
    params?: AppsBomApiGetStructureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetStructureTreeQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>> = ({ signal }) => appsBomApiGetStructureTree(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetStructureTreeQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>>
export type AppsBomApiGetStructureTreeQueryError = unknown


export function useAppsBomApiGetStructureTree<TData = Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsBomApiGetStructureTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetStructureTree>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetStructureTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetStructureTree<TData = Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiGetStructureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetStructureTree>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetStructureTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetStructureTree<TData = Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiGetStructureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Structure Tree
 */

export function useAppsBomApiGetStructureTree<TData = Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiGetStructureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetStructureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetStructureTreeQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Aggregate all projects' nomenclature + the global Material catalog.

Powers the cross-project Nomenclature page (1C-style folders + recursive
BOM expansion). Mutations stay on the per-project endpoints.
 * @summary Get Global Nomenclature Tree
 */
export type appsBomApiGetGlobalNomenclatureTreeResponse200 = {
  data: GlobalNomenclatureTreeOut
  status: 200
}

export type appsBomApiGetGlobalNomenclatureTreeResponseSuccess = (appsBomApiGetGlobalNomenclatureTreeResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetGlobalNomenclatureTreeResponse = (appsBomApiGetGlobalNomenclatureTreeResponseSuccess)

export const getAppsBomApiGetGlobalNomenclatureTreeUrl = (params?: AppsBomApiGetGlobalNomenclatureTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/global-nomenclature-tree/?${stringifiedParams}` : `/api/global-nomenclature-tree/`
}

export const appsBomApiGetGlobalNomenclatureTree = async (params?: AppsBomApiGetGlobalNomenclatureTreeParams, options?: RequestInit): Promise<appsBomApiGetGlobalNomenclatureTreeResponse> => {

  return customFetch<appsBomApiGetGlobalNomenclatureTreeResponse>(getAppsBomApiGetGlobalNomenclatureTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetGlobalNomenclatureTreeQueryKey = (params?: AppsBomApiGetGlobalNomenclatureTreeParams,) => {
    return [
    `/api/global-nomenclature-tree/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiGetGlobalNomenclatureTreeQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError = unknown>(params?: AppsBomApiGetGlobalNomenclatureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetGlobalNomenclatureTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>> = ({ signal }) => appsBomApiGetGlobalNomenclatureTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetGlobalNomenclatureTreeQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>>
export type AppsBomApiGetGlobalNomenclatureTreeQueryError = unknown


export function useAppsBomApiGetGlobalNomenclatureTree<TData = Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError = unknown>(
 params: undefined |  AppsBomApiGetGlobalNomenclatureTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetGlobalNomenclatureTree<TData = Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError = unknown>(
 params?: AppsBomApiGetGlobalNomenclatureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetGlobalNomenclatureTree<TData = Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError = unknown>(
 params?: AppsBomApiGetGlobalNomenclatureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Global Nomenclature Tree
 */

export function useAppsBomApiGetGlobalNomenclatureTree<TData = Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError = unknown>(
 params?: AppsBomApiGetGlobalNomenclatureTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGlobalNomenclatureTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetGlobalNomenclatureTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Part
 */
export type appsBomApiGetPartResponse200 = {
  data: PartOut
  status: 200
}

export type appsBomApiGetPartResponseSuccess = (appsBomApiGetPartResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetPartResponse = (appsBomApiGetPartResponseSuccess)

export const getAppsBomApiGetPartUrl = (projectId: number,
    partId: number,) => {




  return `/api/projects/${projectId}/parts/${partId}/`
}

export const appsBomApiGetPart = async (projectId: number,
    partId: number, options?: RequestInit): Promise<appsBomApiGetPartResponse> => {

  return customFetch<appsBomApiGetPartResponse>(getAppsBomApiGetPartUrl(projectId,partId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetPartQueryKey = (projectId: number,
    partId: number,) => {
    return [
    `/api/projects/${projectId}/parts/${partId}/`
    ] as const;
    }


export const getAppsBomApiGetPartQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetPart>>, TError = unknown>(projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetPartQueryKey(projectId,partId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetPart>>> = ({ signal }) => appsBomApiGetPart(projectId,partId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId && partId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetPartQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetPart>>>
export type AppsBomApiGetPartQueryError = unknown


export function useAppsBomApiGetPart<TData = Awaited<ReturnType<typeof appsBomApiGetPart>>, TError = unknown>(
 projectId: number,
    partId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetPart>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetPart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetPart<TData = Awaited<ReturnType<typeof appsBomApiGetPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetPart>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetPart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetPart<TData = Awaited<ReturnType<typeof appsBomApiGetPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Part
 */

export function useAppsBomApiGetPart<TData = Awaited<ReturnType<typeof appsBomApiGetPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetPartQueryOptions(projectId,partId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Part Endpoint
 */
export type appsBomApiUpdatePartEndpointResponse200 = {
  data: PartOut
  status: 200
}

export type appsBomApiUpdatePartEndpointResponse400 = {
  data: AppsBomApiUpdatePartEndpoint400
  status: 400
}

export type appsBomApiUpdatePartEndpointResponse409 = {
  data: AppsBomApiUpdatePartEndpoint409
  status: 409
}

export type appsBomApiUpdatePartEndpointResponseSuccess = (appsBomApiUpdatePartEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdatePartEndpointResponseError = (appsBomApiUpdatePartEndpointResponse400 | appsBomApiUpdatePartEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdatePartEndpointResponse = (appsBomApiUpdatePartEndpointResponseSuccess | appsBomApiUpdatePartEndpointResponseError)

export const getAppsBomApiUpdatePartEndpointUrl = (projectId: number,
    partId: number,) => {




  return `/api/projects/${projectId}/parts/${partId}/`
}

export const appsBomApiUpdatePartEndpoint = async (projectId: number,
    partId: number,
    partUpdate: PartUpdate, options?: RequestInit): Promise<appsBomApiUpdatePartEndpointResponse> => {

  return customFetch<appsBomApiUpdatePartEndpointResponse>(getAppsBomApiUpdatePartEndpointUrl(projectId,partId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partUpdate,)
  }
);}




export const getAppsBomApiUpdatePartEndpointMutationOptions = <TError = AppsBomApiUpdatePartEndpoint400 | AppsBomApiUpdatePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>, TError,{projectId: number;partId: number;data: PartUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>, TError,{projectId: number;partId: number;data: PartUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdatePartEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>, {projectId: number;partId: number;data: PartUpdate}> = (props) => {
          const {projectId,partId,data} = props ?? {};

          return  appsBomApiUpdatePartEndpoint(projectId,partId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdatePartEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>>
    export type AppsBomApiUpdatePartEndpointMutationBody = PartUpdate
    export type AppsBomApiUpdatePartEndpointMutationError = AppsBomApiUpdatePartEndpoint400 | AppsBomApiUpdatePartEndpoint409

    /**
 * @summary Update Part Endpoint
 */
export const useAppsBomApiUpdatePartEndpoint = <TError = AppsBomApiUpdatePartEndpoint400 | AppsBomApiUpdatePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>, TError,{projectId: number;partId: number;data: PartUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdatePartEndpoint>>,
        TError,
        {projectId: number;partId: number;data: PartUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdatePartEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Part Endpoint
 */
export type appsBomApiDeletePartEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeletePartEndpointResponse409 = {
  data: AppsBomApiDeletePartEndpoint409
  status: 409
}

export type appsBomApiDeletePartEndpointResponseSuccess = (appsBomApiDeletePartEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeletePartEndpointResponseError = (appsBomApiDeletePartEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeletePartEndpointResponse = (appsBomApiDeletePartEndpointResponseSuccess | appsBomApiDeletePartEndpointResponseError)

export const getAppsBomApiDeletePartEndpointUrl = (projectId: number,
    partId: number,) => {




  return `/api/projects/${projectId}/parts/${partId}/`
}

export const appsBomApiDeletePartEndpoint = async (projectId: number,
    partId: number, options?: RequestInit): Promise<appsBomApiDeletePartEndpointResponse> => {

  return customFetch<appsBomApiDeletePartEndpointResponse>(getAppsBomApiDeletePartEndpointUrl(projectId,partId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeletePartEndpointMutationOptions = <TError = AppsBomApiDeletePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>, TError,{projectId: number;partId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>, TError,{projectId: number;partId: number}, TContext> => {

const mutationKey = ['appsBomApiDeletePartEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>, {projectId: number;partId: number}> = (props) => {
          const {projectId,partId} = props ?? {};

          return  appsBomApiDeletePartEndpoint(projectId,partId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeletePartEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>>

    export type AppsBomApiDeletePartEndpointMutationError = AppsBomApiDeletePartEndpoint409

    /**
 * @summary Delete Part Endpoint
 */
export const useAppsBomApiDeletePartEndpoint = <TError = AppsBomApiDeletePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>, TError,{projectId: number;partId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeletePartEndpoint>>,
        TError,
        {projectId: number;partId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeletePartEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Create Part Endpoint
 */
export type appsBomApiCreatePartEndpointResponse201 = {
  data: PartOut
  status: 201
}

export type appsBomApiCreatePartEndpointResponse400 = {
  data: AppsBomApiCreatePartEndpoint400
  status: 400
}

export type appsBomApiCreatePartEndpointResponse409 = {
  data: AppsBomApiCreatePartEndpoint409
  status: 409
}

export type appsBomApiCreatePartEndpointResponseSuccess = (appsBomApiCreatePartEndpointResponse201) & {
  headers: Headers;
};
export type appsBomApiCreatePartEndpointResponseError = (appsBomApiCreatePartEndpointResponse400 | appsBomApiCreatePartEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreatePartEndpointResponse = (appsBomApiCreatePartEndpointResponseSuccess | appsBomApiCreatePartEndpointResponseError)

export const getAppsBomApiCreatePartEndpointUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/parts/`
}

export const appsBomApiCreatePartEndpoint = async (projectId: number,
    partCreate: PartCreate, options?: RequestInit): Promise<appsBomApiCreatePartEndpointResponse> => {

  return customFetch<appsBomApiCreatePartEndpointResponse>(getAppsBomApiCreatePartEndpointUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partCreate,)
  }
);}




export const getAppsBomApiCreatePartEndpointMutationOptions = <TError = AppsBomApiCreatePartEndpoint400 | AppsBomApiCreatePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>, TError,{projectId: number;data: PartCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>, TError,{projectId: number;data: PartCreate}, TContext> => {

const mutationKey = ['appsBomApiCreatePartEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>, {projectId: number;data: PartCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  appsBomApiCreatePartEndpoint(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreatePartEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>>
    export type AppsBomApiCreatePartEndpointMutationBody = PartCreate
    export type AppsBomApiCreatePartEndpointMutationError = AppsBomApiCreatePartEndpoint400 | AppsBomApiCreatePartEndpoint409

    /**
 * @summary Create Part Endpoint
 */
export const useAppsBomApiCreatePartEndpoint = <TError = AppsBomApiCreatePartEndpoint400 | AppsBomApiCreatePartEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>, TError,{projectId: number;data: PartCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreatePartEndpoint>>,
        TError,
        {projectId: number;data: PartCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreatePartEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Get Assembly
 */
export type appsBomApiGetAssemblyResponse200 = {
  data: AssemblyOut
  status: 200
}

export type appsBomApiGetAssemblyResponseSuccess = (appsBomApiGetAssemblyResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetAssemblyResponse = (appsBomApiGetAssemblyResponseSuccess)

export const getAppsBomApiGetAssemblyUrl = (projectId: number,
    assemblyId: number,) => {




  return `/api/projects/${projectId}/assemblies/${assemblyId}/`
}

export const appsBomApiGetAssembly = async (projectId: number,
    assemblyId: number, options?: RequestInit): Promise<appsBomApiGetAssemblyResponse> => {

  return customFetch<appsBomApiGetAssemblyResponse>(getAppsBomApiGetAssemblyUrl(projectId,assemblyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetAssemblyQueryKey = (projectId: number,
    assemblyId: number,) => {
    return [
    `/api/projects/${projectId}/assemblies/${assemblyId}/`
    ] as const;
    }


export const getAppsBomApiGetAssemblyQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError = unknown>(projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetAssemblyQueryKey(projectId,assemblyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetAssembly>>> = ({ signal }) => appsBomApiGetAssembly(projectId,assemblyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId && assemblyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetAssemblyQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetAssembly>>>
export type AppsBomApiGetAssemblyQueryError = unknown


export function useAppsBomApiGetAssembly<TData = Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetAssembly>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetAssembly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetAssembly<TData = Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetAssembly>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetAssembly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetAssembly<TData = Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assembly
 */

export function useAppsBomApiGetAssembly<TData = Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetAssemblyQueryOptions(projectId,assemblyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Assembly Endpoint
 */
export type appsBomApiUpdateAssemblyEndpointResponse200 = {
  data: AssemblyOut
  status: 200
}

export type appsBomApiUpdateAssemblyEndpointResponse400 = {
  data: AppsBomApiUpdateAssemblyEndpoint400
  status: 400
}

export type appsBomApiUpdateAssemblyEndpointResponse409 = {
  data: AppsBomApiUpdateAssemblyEndpoint409
  status: 409
}

export type appsBomApiUpdateAssemblyEndpointResponseSuccess = (appsBomApiUpdateAssemblyEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdateAssemblyEndpointResponseError = (appsBomApiUpdateAssemblyEndpointResponse400 | appsBomApiUpdateAssemblyEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdateAssemblyEndpointResponse = (appsBomApiUpdateAssemblyEndpointResponseSuccess | appsBomApiUpdateAssemblyEndpointResponseError)

export const getAppsBomApiUpdateAssemblyEndpointUrl = (projectId: number,
    assemblyId: number,) => {




  return `/api/projects/${projectId}/assemblies/${assemblyId}/`
}

export const appsBomApiUpdateAssemblyEndpoint = async (projectId: number,
    assemblyId: number,
    assemblyUpdate: AssemblyUpdate, options?: RequestInit): Promise<appsBomApiUpdateAssemblyEndpointResponse> => {

  return customFetch<appsBomApiUpdateAssemblyEndpointResponse>(getAppsBomApiUpdateAssemblyEndpointUrl(projectId,assemblyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assemblyUpdate,)
  }
);}




export const getAppsBomApiUpdateAssemblyEndpointMutationOptions = <TError = AppsBomApiUpdateAssemblyEndpoint400 | AppsBomApiUpdateAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdateAssemblyEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>, {projectId: number;assemblyId: number;data: AssemblyUpdate}> = (props) => {
          const {projectId,assemblyId,data} = props ?? {};

          return  appsBomApiUpdateAssemblyEndpoint(projectId,assemblyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdateAssemblyEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>>
    export type AppsBomApiUpdateAssemblyEndpointMutationBody = AssemblyUpdate
    export type AppsBomApiUpdateAssemblyEndpointMutationError = AppsBomApiUpdateAssemblyEndpoint400 | AppsBomApiUpdateAssemblyEndpoint409

    /**
 * @summary Update Assembly Endpoint
 */
export const useAppsBomApiUpdateAssemblyEndpoint = <TError = AppsBomApiUpdateAssemblyEndpoint400 | AppsBomApiUpdateAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdateAssemblyEndpoint>>,
        TError,
        {projectId: number;assemblyId: number;data: AssemblyUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdateAssemblyEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Assembly Endpoint
 */
export type appsBomApiDeleteAssemblyEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeleteAssemblyEndpointResponse409 = {
  data: AppsBomApiDeleteAssemblyEndpoint409
  status: 409
}

export type appsBomApiDeleteAssemblyEndpointResponseSuccess = (appsBomApiDeleteAssemblyEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeleteAssemblyEndpointResponseError = (appsBomApiDeleteAssemblyEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeleteAssemblyEndpointResponse = (appsBomApiDeleteAssemblyEndpointResponseSuccess | appsBomApiDeleteAssemblyEndpointResponseError)

export const getAppsBomApiDeleteAssemblyEndpointUrl = (projectId: number,
    assemblyId: number,) => {




  return `/api/projects/${projectId}/assemblies/${assemblyId}/`
}

export const appsBomApiDeleteAssemblyEndpoint = async (projectId: number,
    assemblyId: number, options?: RequestInit): Promise<appsBomApiDeleteAssemblyEndpointResponse> => {

  return customFetch<appsBomApiDeleteAssemblyEndpointResponse>(getAppsBomApiDeleteAssemblyEndpointUrl(projectId,assemblyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeleteAssemblyEndpointMutationOptions = <TError = AppsBomApiDeleteAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number}, TContext> => {

const mutationKey = ['appsBomApiDeleteAssemblyEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>, {projectId: number;assemblyId: number}> = (props) => {
          const {projectId,assemblyId} = props ?? {};

          return  appsBomApiDeleteAssemblyEndpoint(projectId,assemblyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeleteAssemblyEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>>

    export type AppsBomApiDeleteAssemblyEndpointMutationError = AppsBomApiDeleteAssemblyEndpoint409

    /**
 * @summary Delete Assembly Endpoint
 */
export const useAppsBomApiDeleteAssemblyEndpoint = <TError = AppsBomApiDeleteAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>, TError,{projectId: number;assemblyId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeleteAssemblyEndpoint>>,
        TError,
        {projectId: number;assemblyId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeleteAssemblyEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Create Assembly Endpoint
 */
export type appsBomApiCreateAssemblyEndpointResponse201 = {
  data: AssemblyOut
  status: 201
}

export type appsBomApiCreateAssemblyEndpointResponse400 = {
  data: AppsBomApiCreateAssemblyEndpoint400
  status: 400
}

export type appsBomApiCreateAssemblyEndpointResponse409 = {
  data: AppsBomApiCreateAssemblyEndpoint409
  status: 409
}

export type appsBomApiCreateAssemblyEndpointResponseSuccess = (appsBomApiCreateAssemblyEndpointResponse201) & {
  headers: Headers;
};
export type appsBomApiCreateAssemblyEndpointResponseError = (appsBomApiCreateAssemblyEndpointResponse400 | appsBomApiCreateAssemblyEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreateAssemblyEndpointResponse = (appsBomApiCreateAssemblyEndpointResponseSuccess | appsBomApiCreateAssemblyEndpointResponseError)

export const getAppsBomApiCreateAssemblyEndpointUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/assemblies/`
}

export const appsBomApiCreateAssemblyEndpoint = async (projectId: number,
    assemblyCreate: AssemblyCreate, options?: RequestInit): Promise<appsBomApiCreateAssemblyEndpointResponse> => {

  return customFetch<appsBomApiCreateAssemblyEndpointResponse>(getAppsBomApiCreateAssemblyEndpointUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assemblyCreate,)
  }
);}




export const getAppsBomApiCreateAssemblyEndpointMutationOptions = <TError = AppsBomApiCreateAssemblyEndpoint400 | AppsBomApiCreateAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>, TError,{projectId: number;data: AssemblyCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>, TError,{projectId: number;data: AssemblyCreate}, TContext> => {

const mutationKey = ['appsBomApiCreateAssemblyEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>, {projectId: number;data: AssemblyCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  appsBomApiCreateAssemblyEndpoint(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreateAssemblyEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>>
    export type AppsBomApiCreateAssemblyEndpointMutationBody = AssemblyCreate
    export type AppsBomApiCreateAssemblyEndpointMutationError = AppsBomApiCreateAssemblyEndpoint400 | AppsBomApiCreateAssemblyEndpoint409

    /**
 * @summary Create Assembly Endpoint
 */
export const useAppsBomApiCreateAssemblyEndpoint = <TError = AppsBomApiCreateAssemblyEndpoint400 | AppsBomApiCreateAssemblyEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>, TError,{projectId: number;data: AssemblyCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreateAssemblyEndpoint>>,
        TError,
        {projectId: number;data: AssemblyCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreateAssemblyEndpointMutationOptions(options), queryClient);
    }

/**
 * Parent assemblies that include this Part as a component, with the
per-parent quantity. Used by the inspector «Використовується у» section.
 * @summary List Assemblies Using Part
 */
export type appsBomApiListAssembliesUsingPartResponse200 = {
  data: UsedInAssemblyOut[]
  status: 200
}

export type appsBomApiListAssembliesUsingPartResponseSuccess = (appsBomApiListAssembliesUsingPartResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListAssembliesUsingPartResponse = (appsBomApiListAssembliesUsingPartResponseSuccess)

export const getAppsBomApiListAssembliesUsingPartUrl = (projectId: number,
    partId: number,) => {




  return `/api/projects/${projectId}/parts/${partId}/used-in/`
}

export const appsBomApiListAssembliesUsingPart = async (projectId: number,
    partId: number, options?: RequestInit): Promise<appsBomApiListAssembliesUsingPartResponse> => {

  return customFetch<appsBomApiListAssembliesUsingPartResponse>(getAppsBomApiListAssembliesUsingPartUrl(projectId,partId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListAssembliesUsingPartQueryKey = (projectId: number,
    partId: number,) => {
    return [
    `/api/projects/${projectId}/parts/${partId}/used-in/`
    ] as const;
    }


export const getAppsBomApiListAssembliesUsingPartQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError = unknown>(projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListAssembliesUsingPartQueryKey(projectId,partId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>> = ({ signal }) => appsBomApiListAssembliesUsingPart(projectId,partId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId && partId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListAssembliesUsingPartQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>>
export type AppsBomApiListAssembliesUsingPartQueryError = unknown


export function useAppsBomApiListAssembliesUsingPart<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError = unknown>(
 projectId: number,
    partId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesUsingPart<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesUsingPart<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assemblies Using Part
 */

export function useAppsBomApiListAssembliesUsingPart<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError = unknown>(
 projectId: number,
    partId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListAssembliesUsingPartQueryOptions(projectId,partId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Parent assemblies that include this Assembly as a sub-component.
 * @summary List Assemblies Using Assembly
 */
export type appsBomApiListAssembliesUsingAssemblyResponse200 = {
  data: UsedInAssemblyOut[]
  status: 200
}

export type appsBomApiListAssembliesUsingAssemblyResponseSuccess = (appsBomApiListAssembliesUsingAssemblyResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListAssembliesUsingAssemblyResponse = (appsBomApiListAssembliesUsingAssemblyResponseSuccess)

export const getAppsBomApiListAssembliesUsingAssemblyUrl = (projectId: number,
    assemblyId: number,) => {




  return `/api/projects/${projectId}/assemblies/${assemblyId}/used-in/`
}

export const appsBomApiListAssembliesUsingAssembly = async (projectId: number,
    assemblyId: number, options?: RequestInit): Promise<appsBomApiListAssembliesUsingAssemblyResponse> => {

  return customFetch<appsBomApiListAssembliesUsingAssemblyResponse>(getAppsBomApiListAssembliesUsingAssemblyUrl(projectId,assemblyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListAssembliesUsingAssemblyQueryKey = (projectId: number,
    assemblyId: number,) => {
    return [
    `/api/projects/${projectId}/assemblies/${assemblyId}/used-in/`
    ] as const;
    }


export const getAppsBomApiListAssembliesUsingAssemblyQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError = unknown>(projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListAssembliesUsingAssemblyQueryKey(projectId,assemblyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>> = ({ signal }) => appsBomApiListAssembliesUsingAssembly(projectId,assemblyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId && assemblyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListAssembliesUsingAssemblyQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>>
export type AppsBomApiListAssembliesUsingAssemblyQueryError = unknown


export function useAppsBomApiListAssembliesUsingAssembly<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesUsingAssembly<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListAssembliesUsingAssembly<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assemblies Using Assembly
 */

export function useAppsBomApiListAssembliesUsingAssembly<TData = Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError = unknown>(
 projectId: number,
    assemblyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListAssembliesUsingAssembly>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListAssembliesUsingAssemblyQueryOptions(projectId,assemblyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Parts in this project that have `material_id` as their material.
 * @summary List Parts Using Material
 */
export type appsBomApiListPartsUsingMaterialResponse200 = {
  data: UsedInPartOut[]
  status: 200
}

export type appsBomApiListPartsUsingMaterialResponseSuccess = (appsBomApiListPartsUsingMaterialResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListPartsUsingMaterialResponse = (appsBomApiListPartsUsingMaterialResponseSuccess)

export const getAppsBomApiListPartsUsingMaterialUrl = (projectId: number,
    materialId: number,) => {




  return `/api/projects/${projectId}/materials/${materialId}/used-in/`
}

export const appsBomApiListPartsUsingMaterial = async (projectId: number,
    materialId: number, options?: RequestInit): Promise<appsBomApiListPartsUsingMaterialResponse> => {

  return customFetch<appsBomApiListPartsUsingMaterialResponse>(getAppsBomApiListPartsUsingMaterialUrl(projectId,materialId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListPartsUsingMaterialQueryKey = (projectId: number,
    materialId: number,) => {
    return [
    `/api/projects/${projectId}/materials/${materialId}/used-in/`
    ] as const;
    }


export const getAppsBomApiListPartsUsingMaterialQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError = unknown>(projectId: number,
    materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListPartsUsingMaterialQueryKey(projectId,materialId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>> = ({ signal }) => appsBomApiListPartsUsingMaterial(projectId,materialId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId && materialId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListPartsUsingMaterialQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>>
export type AppsBomApiListPartsUsingMaterialQueryError = unknown


export function useAppsBomApiListPartsUsingMaterial<TData = Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError = unknown>(
 projectId: number,
    materialId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsUsingMaterial<TData = Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError = unknown>(
 projectId: number,
    materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListPartsUsingMaterial<TData = Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError = unknown>(
 projectId: number,
    materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Parts Using Material
 */

export function useAppsBomApiListPartsUsingMaterial<TData = Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError = unknown>(
 projectId: number,
    materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListPartsUsingMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListPartsUsingMaterialQueryOptions(projectId,materialId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Component Endpoint
 */
export type appsBomApiCreateComponentEndpointResponse201 = {
  data: AssemblyComponentOut
  status: 201
}

export type appsBomApiCreateComponentEndpointResponse400 = {
  data: AppsBomApiCreateComponentEndpoint400
  status: 400
}

export type appsBomApiCreateComponentEndpointResponse409 = {
  data: AppsBomApiCreateComponentEndpoint409
  status: 409
}

export type appsBomApiCreateComponentEndpointResponseSuccess = (appsBomApiCreateComponentEndpointResponse201) & {
  headers: Headers;
};
export type appsBomApiCreateComponentEndpointResponseError = (appsBomApiCreateComponentEndpointResponse400 | appsBomApiCreateComponentEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreateComponentEndpointResponse = (appsBomApiCreateComponentEndpointResponseSuccess | appsBomApiCreateComponentEndpointResponseError)

export const getAppsBomApiCreateComponentEndpointUrl = (projectId: number,
    assemblyId: number,) => {




  return `/api/projects/${projectId}/assemblies/${assemblyId}/components/`
}

export const appsBomApiCreateComponentEndpoint = async (projectId: number,
    assemblyId: number,
    assemblyComponentCreate: AssemblyComponentCreate, options?: RequestInit): Promise<appsBomApiCreateComponentEndpointResponse> => {

  return customFetch<appsBomApiCreateComponentEndpointResponse>(getAppsBomApiCreateComponentEndpointUrl(projectId,assemblyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assemblyComponentCreate,)
  }
);}




export const getAppsBomApiCreateComponentEndpointMutationOptions = <TError = AppsBomApiCreateComponentEndpoint400 | AppsBomApiCreateComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyComponentCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyComponentCreate}, TContext> => {

const mutationKey = ['appsBomApiCreateComponentEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>, {projectId: number;assemblyId: number;data: AssemblyComponentCreate}> = (props) => {
          const {projectId,assemblyId,data} = props ?? {};

          return  appsBomApiCreateComponentEndpoint(projectId,assemblyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreateComponentEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>>
    export type AppsBomApiCreateComponentEndpointMutationBody = AssemblyComponentCreate
    export type AppsBomApiCreateComponentEndpointMutationError = AppsBomApiCreateComponentEndpoint400 | AppsBomApiCreateComponentEndpoint409

    /**
 * @summary Create Component Endpoint
 */
export const useAppsBomApiCreateComponentEndpoint = <TError = AppsBomApiCreateComponentEndpoint400 | AppsBomApiCreateComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>, TError,{projectId: number;assemblyId: number;data: AssemblyComponentCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreateComponentEndpoint>>,
        TError,
        {projectId: number;assemblyId: number;data: AssemblyComponentCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreateComponentEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update Component Endpoint
 */
export type appsBomApiUpdateComponentEndpointResponse200 = {
  data: AssemblyComponentOut
  status: 200
}

export type appsBomApiUpdateComponentEndpointResponse400 = {
  data: AppsBomApiUpdateComponentEndpoint400
  status: 400
}

export type appsBomApiUpdateComponentEndpointResponse409 = {
  data: AppsBomApiUpdateComponentEndpoint409
  status: 409
}

export type appsBomApiUpdateComponentEndpointResponseSuccess = (appsBomApiUpdateComponentEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdateComponentEndpointResponseError = (appsBomApiUpdateComponentEndpointResponse400 | appsBomApiUpdateComponentEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdateComponentEndpointResponse = (appsBomApiUpdateComponentEndpointResponseSuccess | appsBomApiUpdateComponentEndpointResponseError)

export const getAppsBomApiUpdateComponentEndpointUrl = (projectId: number,
    componentId: number,) => {




  return `/api/projects/${projectId}/assembly-components/${componentId}/`
}

export const appsBomApiUpdateComponentEndpoint = async (projectId: number,
    componentId: number,
    assemblyComponentUpdate: AssemblyComponentUpdate, options?: RequestInit): Promise<appsBomApiUpdateComponentEndpointResponse> => {

  return customFetch<appsBomApiUpdateComponentEndpointResponse>(getAppsBomApiUpdateComponentEndpointUrl(projectId,componentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assemblyComponentUpdate,)
  }
);}




export const getAppsBomApiUpdateComponentEndpointMutationOptions = <TError = AppsBomApiUpdateComponentEndpoint400 | AppsBomApiUpdateComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>, TError,{projectId: number;componentId: number;data: AssemblyComponentUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>, TError,{projectId: number;componentId: number;data: AssemblyComponentUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdateComponentEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>, {projectId: number;componentId: number;data: AssemblyComponentUpdate}> = (props) => {
          const {projectId,componentId,data} = props ?? {};

          return  appsBomApiUpdateComponentEndpoint(projectId,componentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdateComponentEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>>
    export type AppsBomApiUpdateComponentEndpointMutationBody = AssemblyComponentUpdate
    export type AppsBomApiUpdateComponentEndpointMutationError = AppsBomApiUpdateComponentEndpoint400 | AppsBomApiUpdateComponentEndpoint409

    /**
 * @summary Update Component Endpoint
 */
export const useAppsBomApiUpdateComponentEndpoint = <TError = AppsBomApiUpdateComponentEndpoint400 | AppsBomApiUpdateComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>, TError,{projectId: number;componentId: number;data: AssemblyComponentUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdateComponentEndpoint>>,
        TError,
        {projectId: number;componentId: number;data: AssemblyComponentUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdateComponentEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Component Endpoint
 */
export type appsBomApiDeleteComponentEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeleteComponentEndpointResponse409 = {
  data: AppsBomApiDeleteComponentEndpoint409
  status: 409
}

export type appsBomApiDeleteComponentEndpointResponseSuccess = (appsBomApiDeleteComponentEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeleteComponentEndpointResponseError = (appsBomApiDeleteComponentEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeleteComponentEndpointResponse = (appsBomApiDeleteComponentEndpointResponseSuccess | appsBomApiDeleteComponentEndpointResponseError)

export const getAppsBomApiDeleteComponentEndpointUrl = (projectId: number,
    componentId: number,) => {




  return `/api/projects/${projectId}/assembly-components/${componentId}/`
}

export const appsBomApiDeleteComponentEndpoint = async (projectId: number,
    componentId: number, options?: RequestInit): Promise<appsBomApiDeleteComponentEndpointResponse> => {

  return customFetch<appsBomApiDeleteComponentEndpointResponse>(getAppsBomApiDeleteComponentEndpointUrl(projectId,componentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeleteComponentEndpointMutationOptions = <TError = AppsBomApiDeleteComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>, TError,{projectId: number;componentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>, TError,{projectId: number;componentId: number}, TContext> => {

const mutationKey = ['appsBomApiDeleteComponentEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>, {projectId: number;componentId: number}> = (props) => {
          const {projectId,componentId} = props ?? {};

          return  appsBomApiDeleteComponentEndpoint(projectId,componentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeleteComponentEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>>

    export type AppsBomApiDeleteComponentEndpointMutationError = AppsBomApiDeleteComponentEndpoint409

    /**
 * @summary Delete Component Endpoint
 */
export const useAppsBomApiDeleteComponentEndpoint = <TError = AppsBomApiDeleteComponentEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>, TError,{projectId: number;componentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeleteComponentEndpoint>>,
        TError,
        {projectId: number;componentId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeleteComponentEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Groups
 */
export type appsBomApiListGroupsResponse200 = {
  data: NomenclatureGroupOut[]
  status: 200
}

export type appsBomApiListGroupsResponseSuccess = (appsBomApiListGroupsResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListGroupsResponse = (appsBomApiListGroupsResponseSuccess)

export const getAppsBomApiListGroupsUrl = (params?: AppsBomApiListGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/nomenclature-groups/?${stringifiedParams}` : `/api/nomenclature-groups/`
}

export const appsBomApiListGroups = async (params?: AppsBomApiListGroupsParams, options?: RequestInit): Promise<appsBomApiListGroupsResponse> => {

  return customFetch<appsBomApiListGroupsResponse>(getAppsBomApiListGroupsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListGroupsQueryKey = (params?: AppsBomApiListGroupsParams,) => {
    return [
    `/api/nomenclature-groups/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListGroupsQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListGroups>>, TError = unknown>(params?: AppsBomApiListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListGroups>>> = ({ signal }) => appsBomApiListGroups(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListGroups>>>
export type AppsBomApiListGroupsQueryError = unknown


export function useAppsBomApiListGroups<TData = Awaited<ReturnType<typeof appsBomApiListGroups>>, TError = unknown>(
 params: undefined |  AppsBomApiListGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListGroups>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListGroups<TData = Awaited<ReturnType<typeof appsBomApiListGroups>>, TError = unknown>(
 params?: AppsBomApiListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListGroups>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListGroups<TData = Awaited<ReturnType<typeof appsBomApiListGroups>>, TError = unknown>(
 params?: AppsBomApiListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Groups
 */

export function useAppsBomApiListGroups<TData = Awaited<ReturnType<typeof appsBomApiListGroups>>, TError = unknown>(
 params?: AppsBomApiListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Group Endpoint
 */
export type appsBomApiCreateGroupEndpointResponse201 = {
  data: NomenclatureGroupOut
  status: 201
}

export type appsBomApiCreateGroupEndpointResponse400 = {
  data: AppsBomApiCreateGroupEndpoint400
  status: 400
}

export type appsBomApiCreateGroupEndpointResponse409 = {
  data: AppsBomApiCreateGroupEndpoint409
  status: 409
}

export type appsBomApiCreateGroupEndpointResponseSuccess = (appsBomApiCreateGroupEndpointResponse201) & {
  headers: Headers;
};
export type appsBomApiCreateGroupEndpointResponseError = (appsBomApiCreateGroupEndpointResponse400 | appsBomApiCreateGroupEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreateGroupEndpointResponse = (appsBomApiCreateGroupEndpointResponseSuccess | appsBomApiCreateGroupEndpointResponseError)

export const getAppsBomApiCreateGroupEndpointUrl = () => {




  return `/api/nomenclature-groups/`
}

export const appsBomApiCreateGroupEndpoint = async (nomenclatureGroupCreate: NomenclatureGroupCreate, options?: RequestInit): Promise<appsBomApiCreateGroupEndpointResponse> => {

  return customFetch<appsBomApiCreateGroupEndpointResponse>(getAppsBomApiCreateGroupEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nomenclatureGroupCreate,)
  }
);}




export const getAppsBomApiCreateGroupEndpointMutationOptions = <TError = AppsBomApiCreateGroupEndpoint400 | AppsBomApiCreateGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>, TError,{data: NomenclatureGroupCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>, TError,{data: NomenclatureGroupCreate}, TContext> => {

const mutationKey = ['appsBomApiCreateGroupEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>, {data: NomenclatureGroupCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsBomApiCreateGroupEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreateGroupEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>>
    export type AppsBomApiCreateGroupEndpointMutationBody = NomenclatureGroupCreate
    export type AppsBomApiCreateGroupEndpointMutationError = AppsBomApiCreateGroupEndpoint400 | AppsBomApiCreateGroupEndpoint409

    /**
 * @summary Create Group Endpoint
 */
export const useAppsBomApiCreateGroupEndpoint = <TError = AppsBomApiCreateGroupEndpoint400 | AppsBomApiCreateGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>, TError,{data: NomenclatureGroupCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreateGroupEndpoint>>,
        TError,
        {data: NomenclatureGroupCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreateGroupEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Get Group
 */
export type appsBomApiGetGroupResponse200 = {
  data: NomenclatureGroupOut
  status: 200
}

export type appsBomApiGetGroupResponseSuccess = (appsBomApiGetGroupResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetGroupResponse = (appsBomApiGetGroupResponseSuccess)

export const getAppsBomApiGetGroupUrl = (groupId: number,) => {




  return `/api/nomenclature-groups/${groupId}/`
}

export const appsBomApiGetGroup = async (groupId: number, options?: RequestInit): Promise<appsBomApiGetGroupResponse> => {

  return customFetch<appsBomApiGetGroupResponse>(getAppsBomApiGetGroupUrl(groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetGroupQueryKey = (groupId: number,) => {
    return [
    `/api/nomenclature-groups/${groupId}/`
    ] as const;
    }


export const getAppsBomApiGetGroupQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError = unknown>(groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetGroupQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetGroup>>> = ({ signal }) => appsBomApiGetGroup(groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetGroupQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetGroup>>>
export type AppsBomApiGetGroupQueryError = unknown


export function useAppsBomApiGetGroup<TData = Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError = unknown>(
 groupId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetGroup>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetGroup<TData = Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError = unknown>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetGroup>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetGroup<TData = Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError = unknown>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Group
 */

export function useAppsBomApiGetGroup<TData = Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError = unknown>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Group Endpoint
 */
export type appsBomApiUpdateGroupEndpointResponse200 = {
  data: NomenclatureGroupOut
  status: 200
}

export type appsBomApiUpdateGroupEndpointResponse400 = {
  data: AppsBomApiUpdateGroupEndpoint400
  status: 400
}

export type appsBomApiUpdateGroupEndpointResponse409 = {
  data: AppsBomApiUpdateGroupEndpoint409
  status: 409
}

export type appsBomApiUpdateGroupEndpointResponseSuccess = (appsBomApiUpdateGroupEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdateGroupEndpointResponseError = (appsBomApiUpdateGroupEndpointResponse400 | appsBomApiUpdateGroupEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdateGroupEndpointResponse = (appsBomApiUpdateGroupEndpointResponseSuccess | appsBomApiUpdateGroupEndpointResponseError)

export const getAppsBomApiUpdateGroupEndpointUrl = (groupId: number,) => {




  return `/api/nomenclature-groups/${groupId}/`
}

export const appsBomApiUpdateGroupEndpoint = async (groupId: number,
    nomenclatureGroupUpdate: NomenclatureGroupUpdate, options?: RequestInit): Promise<appsBomApiUpdateGroupEndpointResponse> => {

  return customFetch<appsBomApiUpdateGroupEndpointResponse>(getAppsBomApiUpdateGroupEndpointUrl(groupId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nomenclatureGroupUpdate,)
  }
);}




export const getAppsBomApiUpdateGroupEndpointMutationOptions = <TError = AppsBomApiUpdateGroupEndpoint400 | AppsBomApiUpdateGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>, TError,{groupId: number;data: NomenclatureGroupUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>, TError,{groupId: number;data: NomenclatureGroupUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdateGroupEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>, {groupId: number;data: NomenclatureGroupUpdate}> = (props) => {
          const {groupId,data} = props ?? {};

          return  appsBomApiUpdateGroupEndpoint(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdateGroupEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>>
    export type AppsBomApiUpdateGroupEndpointMutationBody = NomenclatureGroupUpdate
    export type AppsBomApiUpdateGroupEndpointMutationError = AppsBomApiUpdateGroupEndpoint400 | AppsBomApiUpdateGroupEndpoint409

    /**
 * @summary Update Group Endpoint
 */
export const useAppsBomApiUpdateGroupEndpoint = <TError = AppsBomApiUpdateGroupEndpoint400 | AppsBomApiUpdateGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>, TError,{groupId: number;data: NomenclatureGroupUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdateGroupEndpoint>>,
        TError,
        {groupId: number;data: NomenclatureGroupUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdateGroupEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Group Endpoint
 */
export type appsBomApiDeleteGroupEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeleteGroupEndpointResponse409 = {
  data: AppsBomApiDeleteGroupEndpoint409
  status: 409
}

export type appsBomApiDeleteGroupEndpointResponseSuccess = (appsBomApiDeleteGroupEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeleteGroupEndpointResponseError = (appsBomApiDeleteGroupEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeleteGroupEndpointResponse = (appsBomApiDeleteGroupEndpointResponseSuccess | appsBomApiDeleteGroupEndpointResponseError)

export const getAppsBomApiDeleteGroupEndpointUrl = (groupId: number,) => {




  return `/api/nomenclature-groups/${groupId}/`
}

export const appsBomApiDeleteGroupEndpoint = async (groupId: number, options?: RequestInit): Promise<appsBomApiDeleteGroupEndpointResponse> => {

  return customFetch<appsBomApiDeleteGroupEndpointResponse>(getAppsBomApiDeleteGroupEndpointUrl(groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeleteGroupEndpointMutationOptions = <TError = AppsBomApiDeleteGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>, TError,{groupId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>, TError,{groupId: number}, TContext> => {

const mutationKey = ['appsBomApiDeleteGroupEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>, {groupId: number}> = (props) => {
          const {groupId} = props ?? {};

          return  appsBomApiDeleteGroupEndpoint(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeleteGroupEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>>

    export type AppsBomApiDeleteGroupEndpointMutationError = AppsBomApiDeleteGroupEndpoint409

    /**
 * @summary Delete Group Endpoint
 */
export const useAppsBomApiDeleteGroupEndpoint = <TError = AppsBomApiDeleteGroupEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>, TError,{groupId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeleteGroupEndpoint>>,
        TError,
        {groupId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeleteGroupEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Units
 */
export type appsBomApiListUnitsResponse200 = {
  data: UnitOfMeasureOut[]
  status: 200
}

export type appsBomApiListUnitsResponseSuccess = (appsBomApiListUnitsResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListUnitsResponse = (appsBomApiListUnitsResponseSuccess)

export const getAppsBomApiListUnitsUrl = (params?: AppsBomApiListUnitsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/units-of-measure/?${stringifiedParams}` : `/api/units-of-measure/`
}

export const appsBomApiListUnits = async (params?: AppsBomApiListUnitsParams, options?: RequestInit): Promise<appsBomApiListUnitsResponse> => {

  return customFetch<appsBomApiListUnitsResponse>(getAppsBomApiListUnitsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListUnitsQueryKey = (params?: AppsBomApiListUnitsParams,) => {
    return [
    `/api/units-of-measure/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListUnitsQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListUnits>>, TError = unknown>(params?: AppsBomApiListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListUnitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListUnits>>> = ({ signal }) => appsBomApiListUnits(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListUnits>>>
export type AppsBomApiListUnitsQueryError = unknown


export function useAppsBomApiListUnits<TData = Awaited<ReturnType<typeof appsBomApiListUnits>>, TError = unknown>(
 params: undefined |  AppsBomApiListUnitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListUnits>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListUnits<TData = Awaited<ReturnType<typeof appsBomApiListUnits>>, TError = unknown>(
 params?: AppsBomApiListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListUnits>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListUnits<TData = Awaited<ReturnType<typeof appsBomApiListUnits>>, TError = unknown>(
 params?: AppsBomApiListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Units
 */

export function useAppsBomApiListUnits<TData = Awaited<ReturnType<typeof appsBomApiListUnits>>, TError = unknown>(
 params?: AppsBomApiListUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListUnits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListUnitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Unit Endpoint
 */
export type appsBomApiCreateUnitEndpointResponse200 = {
  data: UnitOfMeasureOut
  status: 200
}

export type appsBomApiCreateUnitEndpointResponse400 = {
  data: AppsBomApiCreateUnitEndpoint400
  status: 400
}

export type appsBomApiCreateUnitEndpointResponse409 = {
  data: AppsBomApiCreateUnitEndpoint409
  status: 409
}

export type appsBomApiCreateUnitEndpointResponseSuccess = (appsBomApiCreateUnitEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiCreateUnitEndpointResponseError = (appsBomApiCreateUnitEndpointResponse400 | appsBomApiCreateUnitEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiCreateUnitEndpointResponse = (appsBomApiCreateUnitEndpointResponseSuccess | appsBomApiCreateUnitEndpointResponseError)

export const getAppsBomApiCreateUnitEndpointUrl = () => {




  return `/api/units-of-measure/`
}

export const appsBomApiCreateUnitEndpoint = async (unitOfMeasureCreate: UnitOfMeasureCreate, options?: RequestInit): Promise<appsBomApiCreateUnitEndpointResponse> => {

  return customFetch<appsBomApiCreateUnitEndpointResponse>(getAppsBomApiCreateUnitEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unitOfMeasureCreate,)
  }
);}




export const getAppsBomApiCreateUnitEndpointMutationOptions = <TError = AppsBomApiCreateUnitEndpoint400 | AppsBomApiCreateUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>, TError,{data: UnitOfMeasureCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>, TError,{data: UnitOfMeasureCreate}, TContext> => {

const mutationKey = ['appsBomApiCreateUnitEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>, {data: UnitOfMeasureCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsBomApiCreateUnitEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiCreateUnitEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>>
    export type AppsBomApiCreateUnitEndpointMutationBody = UnitOfMeasureCreate
    export type AppsBomApiCreateUnitEndpointMutationError = AppsBomApiCreateUnitEndpoint400 | AppsBomApiCreateUnitEndpoint409

    /**
 * @summary Create Unit Endpoint
 */
export const useAppsBomApiCreateUnitEndpoint = <TError = AppsBomApiCreateUnitEndpoint400 | AppsBomApiCreateUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>, TError,{data: UnitOfMeasureCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiCreateUnitEndpoint>>,
        TError,
        {data: UnitOfMeasureCreate},
        TContext
      > => {
      return useMutation(getAppsBomApiCreateUnitEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update Unit Endpoint
 */
export type appsBomApiUpdateUnitEndpointResponse200 = {
  data: UnitOfMeasureOut
  status: 200
}

export type appsBomApiUpdateUnitEndpointResponse400 = {
  data: AppsBomApiUpdateUnitEndpoint400
  status: 400
}

export type appsBomApiUpdateUnitEndpointResponse409 = {
  data: AppsBomApiUpdateUnitEndpoint409
  status: 409
}

export type appsBomApiUpdateUnitEndpointResponseSuccess = (appsBomApiUpdateUnitEndpointResponse200) & {
  headers: Headers;
};
export type appsBomApiUpdateUnitEndpointResponseError = (appsBomApiUpdateUnitEndpointResponse400 | appsBomApiUpdateUnitEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiUpdateUnitEndpointResponse = (appsBomApiUpdateUnitEndpointResponseSuccess | appsBomApiUpdateUnitEndpointResponseError)

export const getAppsBomApiUpdateUnitEndpointUrl = (unitId: number,) => {




  return `/api/units-of-measure/${unitId}`
}

export const appsBomApiUpdateUnitEndpoint = async (unitId: number,
    unitOfMeasureUpdate: UnitOfMeasureUpdate, options?: RequestInit): Promise<appsBomApiUpdateUnitEndpointResponse> => {

  return customFetch<appsBomApiUpdateUnitEndpointResponse>(getAppsBomApiUpdateUnitEndpointUrl(unitId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unitOfMeasureUpdate,)
  }
);}




export const getAppsBomApiUpdateUnitEndpointMutationOptions = <TError = AppsBomApiUpdateUnitEndpoint400 | AppsBomApiUpdateUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>, TError,{unitId: number;data: UnitOfMeasureUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>, TError,{unitId: number;data: UnitOfMeasureUpdate}, TContext> => {

const mutationKey = ['appsBomApiUpdateUnitEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>, {unitId: number;data: UnitOfMeasureUpdate}> = (props) => {
          const {unitId,data} = props ?? {};

          return  appsBomApiUpdateUnitEndpoint(unitId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiUpdateUnitEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>>
    export type AppsBomApiUpdateUnitEndpointMutationBody = UnitOfMeasureUpdate
    export type AppsBomApiUpdateUnitEndpointMutationError = AppsBomApiUpdateUnitEndpoint400 | AppsBomApiUpdateUnitEndpoint409

    /**
 * @summary Update Unit Endpoint
 */
export const useAppsBomApiUpdateUnitEndpoint = <TError = AppsBomApiUpdateUnitEndpoint400 | AppsBomApiUpdateUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>, TError,{unitId: number;data: UnitOfMeasureUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiUpdateUnitEndpoint>>,
        TError,
        {unitId: number;data: UnitOfMeasureUpdate},
        TContext
      > => {
      return useMutation(getAppsBomApiUpdateUnitEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Unit Endpoint
 */
export type appsBomApiDeleteUnitEndpointResponse204 = {
  data: void
  status: 204
}

export type appsBomApiDeleteUnitEndpointResponse409 = {
  data: AppsBomApiDeleteUnitEndpoint409
  status: 409
}

export type appsBomApiDeleteUnitEndpointResponseSuccess = (appsBomApiDeleteUnitEndpointResponse204) & {
  headers: Headers;
};
export type appsBomApiDeleteUnitEndpointResponseError = (appsBomApiDeleteUnitEndpointResponse409) & {
  headers: Headers;
};

export type appsBomApiDeleteUnitEndpointResponse = (appsBomApiDeleteUnitEndpointResponseSuccess | appsBomApiDeleteUnitEndpointResponseError)

export const getAppsBomApiDeleteUnitEndpointUrl = (unitId: number,) => {




  return `/api/units-of-measure/${unitId}`
}

export const appsBomApiDeleteUnitEndpoint = async (unitId: number, options?: RequestInit): Promise<appsBomApiDeleteUnitEndpointResponse> => {

  return customFetch<appsBomApiDeleteUnitEndpointResponse>(getAppsBomApiDeleteUnitEndpointUrl(unitId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsBomApiDeleteUnitEndpointMutationOptions = <TError = AppsBomApiDeleteUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>, TError,{unitId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>, TError,{unitId: number}, TContext> => {

const mutationKey = ['appsBomApiDeleteUnitEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>, {unitId: number}> = (props) => {
          const {unitId} = props ?? {};

          return  appsBomApiDeleteUnitEndpoint(unitId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiDeleteUnitEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>>

    export type AppsBomApiDeleteUnitEndpointMutationError = AppsBomApiDeleteUnitEndpoint409

    /**
 * @summary Delete Unit Endpoint
 */
export const useAppsBomApiDeleteUnitEndpoint = <TError = AppsBomApiDeleteUnitEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>, TError,{unitId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiDeleteUnitEndpoint>>,
        TError,
        {unitId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiDeleteUnitEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Drawing Files
 */
export type appsBomApiListDrawingFilesResponse200 = {
  data: DrawingFileOut[]
  status: 200
}

export type appsBomApiListDrawingFilesResponseSuccess = (appsBomApiListDrawingFilesResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListDrawingFilesResponse = (appsBomApiListDrawingFilesResponseSuccess)

export const getAppsBomApiListDrawingFilesUrl = (projectId: number,
    params?: AppsBomApiListDrawingFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/drawing-files/?${stringifiedParams}` : `/api/projects/${projectId}/drawing-files/`
}

export const appsBomApiListDrawingFiles = async (projectId: number,
    params?: AppsBomApiListDrawingFilesParams, options?: RequestInit): Promise<appsBomApiListDrawingFilesResponse> => {

  return customFetch<appsBomApiListDrawingFilesResponse>(getAppsBomApiListDrawingFilesUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListDrawingFilesQueryKey = (projectId: number,
    params?: AppsBomApiListDrawingFilesParams,) => {
    return [
    `/api/projects/${projectId}/drawing-files/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListDrawingFilesQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError = unknown>(projectId: number,
    params?: AppsBomApiListDrawingFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListDrawingFilesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>> = ({ signal }) => appsBomApiListDrawingFiles(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListDrawingFilesQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>>
export type AppsBomApiListDrawingFilesQueryError = unknown


export function useAppsBomApiListDrawingFiles<TData = Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsBomApiListDrawingFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListDrawingFiles<TData = Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListDrawingFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListDrawingFiles<TData = Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListDrawingFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Drawing Files
 */

export function useAppsBomApiListDrawingFiles<TData = Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError = unknown>(
 projectId: number,
    params?: AppsBomApiListDrawingFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListDrawingFilesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Attach PDF drawings to a project, one DrawingSheet per page.

Rendering a preview for every page is slow enough to feel like a hang on a
large file, so the client is expected to send files one or a few at a time
and show its own progress rather than posting the whole package at once.

A file already attached under the same name is skipped: re-uploading a
package after adding one drawing to it should not duplicate the rest.
 * @summary Upload Drawing Files
 */
export type appsBomApiImportUploadDrawingFilesResponse201 = {
  data: DrawingUploadOut
  status: 201
}

export type appsBomApiImportUploadDrawingFilesResponse400 = {
  data: AppsBomApiImportUploadDrawingFiles400
  status: 400
}

export type appsBomApiImportUploadDrawingFilesResponse404 = {
  data: AppsBomApiImportUploadDrawingFiles404
  status: 404
}

export type appsBomApiImportUploadDrawingFilesResponseSuccess = (appsBomApiImportUploadDrawingFilesResponse201) & {
  headers: Headers;
};
export type appsBomApiImportUploadDrawingFilesResponseError = (appsBomApiImportUploadDrawingFilesResponse400 | appsBomApiImportUploadDrawingFilesResponse404) & {
  headers: Headers;
};

export type appsBomApiImportUploadDrawingFilesResponse = (appsBomApiImportUploadDrawingFilesResponseSuccess | appsBomApiImportUploadDrawingFilesResponseError)

export const getAppsBomApiImportUploadDrawingFilesUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/drawing-files/`
}

export const appsBomApiImportUploadDrawingFiles = async (projectId: number,
    appsBomApiImportUploadDrawingFilesBody: AppsBomApiImportUploadDrawingFilesBody, options?: RequestInit): Promise<appsBomApiImportUploadDrawingFilesResponse> => {
    const formData = new FormData();
appsBomApiImportUploadDrawingFilesBody.files.forEach(value => formData.append(`files`, value));

  return customFetch<appsBomApiImportUploadDrawingFilesResponse>(getAppsBomApiImportUploadDrawingFilesUrl(projectId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}




export const getAppsBomApiImportUploadDrawingFilesMutationOptions = <TError = AppsBomApiImportUploadDrawingFiles400 | AppsBomApiImportUploadDrawingFiles404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>, TError,{projectId: number;data: AppsBomApiImportUploadDrawingFilesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>, TError,{projectId: number;data: AppsBomApiImportUploadDrawingFilesBody}, TContext> => {

const mutationKey = ['appsBomApiImportUploadDrawingFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>, {projectId: number;data: AppsBomApiImportUploadDrawingFilesBody}> = (props) => {
          const {projectId,data} = props ?? {};

          return  appsBomApiImportUploadDrawingFiles(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiImportUploadDrawingFilesMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>>
    export type AppsBomApiImportUploadDrawingFilesMutationBody = AppsBomApiImportUploadDrawingFilesBody
    export type AppsBomApiImportUploadDrawingFilesMutationError = AppsBomApiImportUploadDrawingFiles400 | AppsBomApiImportUploadDrawingFiles404

    /**
 * @summary Upload Drawing Files
 */
export const useAppsBomApiImportUploadDrawingFiles = <TError = AppsBomApiImportUploadDrawingFiles400 | AppsBomApiImportUploadDrawingFiles404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>, TError,{projectId: number;data: AppsBomApiImportUploadDrawingFilesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiImportUploadDrawingFiles>>,
        TError,
        {projectId: number;data: AppsBomApiImportUploadDrawingFilesBody},
        TContext
      > => {
      return useMutation(getAppsBomApiImportUploadDrawingFilesMutationOptions(options), queryClient);
    }

/**
 * @summary List Drawing Sheets
 */
export type appsBomApiListDrawingSheetsResponse200 = {
  data: DrawingSheetOut[]
  status: 200
}

export type appsBomApiListDrawingSheetsResponseSuccess = (appsBomApiListDrawingSheetsResponse200) & {
  headers: Headers;
};
;

export type appsBomApiListDrawingSheetsResponse = (appsBomApiListDrawingSheetsResponseSuccess)

export const getAppsBomApiListDrawingSheetsUrl = (fileId: number,
    params?: AppsBomApiListDrawingSheetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drawing-files/${fileId}/sheets/?${stringifiedParams}` : `/api/drawing-files/${fileId}/sheets/`
}

export const appsBomApiListDrawingSheets = async (fileId: number,
    params?: AppsBomApiListDrawingSheetsParams, options?: RequestInit): Promise<appsBomApiListDrawingSheetsResponse> => {

  return customFetch<appsBomApiListDrawingSheetsResponse>(getAppsBomApiListDrawingSheetsUrl(fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiListDrawingSheetsQueryKey = (fileId: number,
    params?: AppsBomApiListDrawingSheetsParams,) => {
    return [
    `/api/drawing-files/${fileId}/sheets/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsBomApiListDrawingSheetsQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError = unknown>(fileId: number,
    params?: AppsBomApiListDrawingSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiListDrawingSheetsQueryKey(fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>> = ({ signal }) => appsBomApiListDrawingSheets(fileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(fileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiListDrawingSheetsQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>>
export type AppsBomApiListDrawingSheetsQueryError = unknown


export function useAppsBomApiListDrawingSheets<TData = Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError = unknown>(
 fileId: number,
    params: undefined |  AppsBomApiListDrawingSheetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListDrawingSheets<TData = Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError = unknown>(
 fileId: number,
    params?: AppsBomApiListDrawingSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiListDrawingSheets<TData = Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError = unknown>(
 fileId: number,
    params?: AppsBomApiListDrawingSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Drawing Sheets
 */

export function useAppsBomApiListDrawingSheets<TData = Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError = unknown>(
 fileId: number,
    params?: AppsBomApiListDrawingSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiListDrawingSheets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiListDrawingSheetsQueryOptions(fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Drawing Sheet
 */
export type appsBomApiGetDrawingSheetResponse200 = {
  data: DrawingSheetOut
  status: 200
}

export type appsBomApiGetDrawingSheetResponseSuccess = (appsBomApiGetDrawingSheetResponse200) & {
  headers: Headers;
};
;

export type appsBomApiGetDrawingSheetResponse = (appsBomApiGetDrawingSheetResponseSuccess)

export const getAppsBomApiGetDrawingSheetUrl = (sheetId: number,) => {




  return `/api/drawing-sheets/${sheetId}/`
}

export const appsBomApiGetDrawingSheet = async (sheetId: number, options?: RequestInit): Promise<appsBomApiGetDrawingSheetResponse> => {

  return customFetch<appsBomApiGetDrawingSheetResponse>(getAppsBomApiGetDrawingSheetUrl(sheetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiGetDrawingSheetQueryKey = (sheetId: number,) => {
    return [
    `/api/drawing-sheets/${sheetId}/`
    ] as const;
    }


export const getAppsBomApiGetDrawingSheetQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError = unknown>(sheetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiGetDrawingSheetQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>> = ({ signal }) => appsBomApiGetDrawingSheet(sheetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(sheetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiGetDrawingSheetQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>>
export type AppsBomApiGetDrawingSheetQueryError = unknown


export function useAppsBomApiGetDrawingSheet<TData = Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError = unknown>(
 sheetId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetDrawingSheet<TData = Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError = unknown>(
 sheetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiGetDrawingSheet<TData = Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError = unknown>(
 sheetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Drawing Sheet
 */

export function useAppsBomApiGetDrawingSheet<TData = Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError = unknown>(
 sheetId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiGetDrawingSheet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiGetDrawingSheetQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Point parts and marks at the drawing pages their import named.
 * @summary Link Project Drawings
 */
export type appsBomApiImportLinkProjectDrawingsResponse200 = {
  data: LinkDrawingsOut
  status: 200
}

export type appsBomApiImportLinkProjectDrawingsResponse404 = {
  data: AppsBomApiImportLinkProjectDrawings404
  status: 404
}

export type appsBomApiImportLinkProjectDrawingsResponseSuccess = (appsBomApiImportLinkProjectDrawingsResponse200) & {
  headers: Headers;
};
export type appsBomApiImportLinkProjectDrawingsResponseError = (appsBomApiImportLinkProjectDrawingsResponse404) & {
  headers: Headers;
};

export type appsBomApiImportLinkProjectDrawingsResponse = (appsBomApiImportLinkProjectDrawingsResponseSuccess | appsBomApiImportLinkProjectDrawingsResponseError)

export const getAppsBomApiImportLinkProjectDrawingsUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/link-drawings/`
}

export const appsBomApiImportLinkProjectDrawings = async (projectId: number, options?: RequestInit): Promise<appsBomApiImportLinkProjectDrawingsResponse> => {

  return customFetch<appsBomApiImportLinkProjectDrawingsResponse>(getAppsBomApiImportLinkProjectDrawingsUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsBomApiImportLinkProjectDrawingsMutationOptions = <TError = AppsBomApiImportLinkProjectDrawings404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>, TError,{projectId: number}, TContext> => {

const mutationKey = ['appsBomApiImportLinkProjectDrawings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>, {projectId: number}> = (props) => {
          const {projectId} = props ?? {};

          return  appsBomApiImportLinkProjectDrawings(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiImportLinkProjectDrawingsMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>>

    export type AppsBomApiImportLinkProjectDrawingsMutationError = AppsBomApiImportLinkProjectDrawings404

    /**
 * @summary Link Project Drawings
 */
export const useAppsBomApiImportLinkProjectDrawings = <TError = AppsBomApiImportLinkProjectDrawings404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiImportLinkProjectDrawings>>,
        TError,
        {projectId: number},
        TContext
      > => {
      return useMutation(getAppsBomApiImportLinkProjectDrawingsMutationOptions(options), queryClient);
    }

/**
 * ZIP for the chat model: instructions, prompt, JSON Schema, example.
 * @summary Ai Kit
 */
export type appsBomApiImportAiKitResponse200 = {
  data: void
  status: 200
}

export type appsBomApiImportAiKitResponse403 = {
  data: AppsBomApiImportAiKit403
  status: 403
}

export type appsBomApiImportAiKitResponseSuccess = (appsBomApiImportAiKitResponse200) & {
  headers: Headers;
};
export type appsBomApiImportAiKitResponseError = (appsBomApiImportAiKitResponse403) & {
  headers: Headers;
};

export type appsBomApiImportAiKitResponse = (appsBomApiImportAiKitResponseSuccess | appsBomApiImportAiKitResponseError)

export const getAppsBomApiImportAiKitUrl = () => {




  return `/api/bom-imports/ai-kit`
}

export const appsBomApiImportAiKit = async ( options?: RequestInit): Promise<appsBomApiImportAiKitResponse> => {

  return customFetch<appsBomApiImportAiKitResponse>(getAppsBomApiImportAiKitUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsBomApiImportAiKitQueryKey = () => {
    return [
    `/api/bom-imports/ai-kit`
    ] as const;
    }


export const getAppsBomApiImportAiKitQueryOptions = <TData = Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError = AppsBomApiImportAiKit403>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsBomApiImportAiKitQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsBomApiImportAiKit>>> = ({ signal }) => appsBomApiImportAiKit({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsBomApiImportAiKitQueryResult = NonNullable<Awaited<ReturnType<typeof appsBomApiImportAiKit>>>
export type AppsBomApiImportAiKitQueryError = AppsBomApiImportAiKit403


export function useAppsBomApiImportAiKit<TData = Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError = AppsBomApiImportAiKit403>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiImportAiKit>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiImportAiKit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiImportAiKit<TData = Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError = AppsBomApiImportAiKit403>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsBomApiImportAiKit>>,
          TError,
          Awaited<ReturnType<typeof appsBomApiImportAiKit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsBomApiImportAiKit<TData = Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError = AppsBomApiImportAiKit403>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ai Kit
 */

export function useAppsBomApiImportAiKit<TData = Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError = AppsBomApiImportAiKit403>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsBomApiImportAiKit>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsBomApiImportAiKitQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Parse, reconcile and diff — without writing anything.
 * @summary Preview Import
 */
export type appsBomApiImportPreviewImportResponse200 = {
  data: PreviewOut
  status: 200
}

export type appsBomApiImportPreviewImportResponse400 = {
  data: AppsBomApiImportPreviewImport400
  status: 400
}

export type appsBomApiImportPreviewImportResponse404 = {
  data: AppsBomApiImportPreviewImport404
  status: 404
}

export type appsBomApiImportPreviewImportResponse409 = {
  data: AppsBomApiImportPreviewImport409
  status: 409
}

export type appsBomApiImportPreviewImportResponseSuccess = (appsBomApiImportPreviewImportResponse200) & {
  headers: Headers;
};
export type appsBomApiImportPreviewImportResponseError = (appsBomApiImportPreviewImportResponse400 | appsBomApiImportPreviewImportResponse404 | appsBomApiImportPreviewImportResponse409) & {
  headers: Headers;
};

export type appsBomApiImportPreviewImportResponse = (appsBomApiImportPreviewImportResponseSuccess | appsBomApiImportPreviewImportResponseError)

export const getAppsBomApiImportPreviewImportUrl = () => {




  return `/api/bom-imports/preview`
}

export const appsBomApiImportPreviewImport = async (importRequest: ImportRequest, options?: RequestInit): Promise<appsBomApiImportPreviewImportResponse> => {

  return customFetch<appsBomApiImportPreviewImportResponse>(getAppsBomApiImportPreviewImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importRequest,)
  }
);}




export const getAppsBomApiImportPreviewImportMutationOptions = <TError = AppsBomApiImportPreviewImport400 | AppsBomApiImportPreviewImport404 | AppsBomApiImportPreviewImport409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>, TError,{data: ImportRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>, TError,{data: ImportRequest}, TContext> => {

const mutationKey = ['appsBomApiImportPreviewImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>, {data: ImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  appsBomApiImportPreviewImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiImportPreviewImportMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>>
    export type AppsBomApiImportPreviewImportMutationBody = ImportRequest
    export type AppsBomApiImportPreviewImportMutationError = AppsBomApiImportPreviewImport400 | AppsBomApiImportPreviewImport404 | AppsBomApiImportPreviewImport409

    /**
 * @summary Preview Import
 */
export const useAppsBomApiImportPreviewImport = <TError = AppsBomApiImportPreviewImport400 | AppsBomApiImportPreviewImport404 | AppsBomApiImportPreviewImport409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>, TError,{data: ImportRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiImportPreviewImport>>,
        TError,
        {data: ImportRequest},
        TContext
      > => {
      return useMutation(getAppsBomApiImportPreviewImportMutationOptions(options), queryClient);
    }

/**
 * Create or extend the project, then report what the whole project now says.

Blocking errors stop the write unless the operator gives a reason to accept
them; the reason is kept with the import and in the project notes.
 * @summary Commit Import
 */
export type appsBomApiImportCommitImportResponse201 = {
  data: CommitOut
  status: 201
}

export type appsBomApiImportCommitImportResponse400 = {
  data: AppsBomApiImportCommitImport400
  status: 400
}

export type appsBomApiImportCommitImportResponse404 = {
  data: AppsBomApiImportCommitImport404
  status: 404
}

export type appsBomApiImportCommitImportResponse409 = {
  data: AppsBomApiImportCommitImport409
  status: 409
}

export type appsBomApiImportCommitImportResponseSuccess = (appsBomApiImportCommitImportResponse201) & {
  headers: Headers;
};
export type appsBomApiImportCommitImportResponseError = (appsBomApiImportCommitImportResponse400 | appsBomApiImportCommitImportResponse404 | appsBomApiImportCommitImportResponse409) & {
  headers: Headers;
};

export type appsBomApiImportCommitImportResponse = (appsBomApiImportCommitImportResponseSuccess | appsBomApiImportCommitImportResponseError)

export const getAppsBomApiImportCommitImportUrl = () => {




  return `/api/bom-imports/commit`
}

export const appsBomApiImportCommitImport = async (importRequest: ImportRequest, options?: RequestInit): Promise<appsBomApiImportCommitImportResponse> => {

  return customFetch<appsBomApiImportCommitImportResponse>(getAppsBomApiImportCommitImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importRequest,)
  }
);}




export const getAppsBomApiImportCommitImportMutationOptions = <TError = AppsBomApiImportCommitImport400 | AppsBomApiImportCommitImport404 | AppsBomApiImportCommitImport409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportCommitImport>>, TError,{data: ImportRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportCommitImport>>, TError,{data: ImportRequest}, TContext> => {

const mutationKey = ['appsBomApiImportCommitImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsBomApiImportCommitImport>>, {data: ImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  appsBomApiImportCommitImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsBomApiImportCommitImportMutationResult = NonNullable<Awaited<ReturnType<typeof appsBomApiImportCommitImport>>>
    export type AppsBomApiImportCommitImportMutationBody = ImportRequest
    export type AppsBomApiImportCommitImportMutationError = AppsBomApiImportCommitImport400 | AppsBomApiImportCommitImport404 | AppsBomApiImportCommitImport409

    /**
 * @summary Commit Import
 */
export const useAppsBomApiImportCommitImport = <TError = AppsBomApiImportCommitImport400 | AppsBomApiImportCommitImport404 | AppsBomApiImportCommitImport409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsBomApiImportCommitImport>>, TError,{data: ImportRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsBomApiImportCommitImport>>,
        TError,
        {data: ImportRequest},
        TContext
      > => {
      return useMutation(getAppsBomApiImportCommitImportMutationOptions(options), queryClient);
    }

/**
 * @summary List Materials
 */
export type appsCatalogApiListMaterialsResponse200 = {
  data: MaterialOut[]
  status: 200
}

export type appsCatalogApiListMaterialsResponseSuccess = (appsCatalogApiListMaterialsResponse200) & {
  headers: Headers;
};
;

export type appsCatalogApiListMaterialsResponse = (appsCatalogApiListMaterialsResponseSuccess)

export const getAppsCatalogApiListMaterialsUrl = (params?: AppsCatalogApiListMaterialsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/materials?${stringifiedParams}` : `/api/catalog/materials`
}

export const appsCatalogApiListMaterials = async (params?: AppsCatalogApiListMaterialsParams, options?: RequestInit): Promise<appsCatalogApiListMaterialsResponse> => {

  return customFetch<appsCatalogApiListMaterialsResponse>(getAppsCatalogApiListMaterialsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCatalogApiListMaterialsQueryKey = (params?: AppsCatalogApiListMaterialsParams,) => {
    return [
    `/api/catalog/materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsCatalogApiListMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError = unknown>(params?: AppsCatalogApiListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCatalogApiListMaterialsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>> = ({ signal }) => appsCatalogApiListMaterials(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCatalogApiListMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>>
export type AppsCatalogApiListMaterialsQueryError = unknown


export function useAppsCatalogApiListMaterials<TData = Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError = unknown>(
 params: undefined |  AppsCatalogApiListMaterialsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCatalogApiListMaterials>>,
          TError,
          Awaited<ReturnType<typeof appsCatalogApiListMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCatalogApiListMaterials<TData = Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError = unknown>(
 params?: AppsCatalogApiListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCatalogApiListMaterials>>,
          TError,
          Awaited<ReturnType<typeof appsCatalogApiListMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCatalogApiListMaterials<TData = Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError = unknown>(
 params?: AppsCatalogApiListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Materials
 */

export function useAppsCatalogApiListMaterials<TData = Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError = unknown>(
 params?: AppsCatalogApiListMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiListMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCatalogApiListMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Material
 */
export type appsCatalogApiCreateMaterialResponse200 = {
  data: MaterialOut
  status: 200
}

export type appsCatalogApiCreateMaterialResponseSuccess = (appsCatalogApiCreateMaterialResponse200) & {
  headers: Headers;
};
;

export type appsCatalogApiCreateMaterialResponse = (appsCatalogApiCreateMaterialResponseSuccess)

export const getAppsCatalogApiCreateMaterialUrl = () => {




  return `/api/catalog/materials`
}

export const appsCatalogApiCreateMaterial = async (materialCreate: MaterialCreate, options?: RequestInit): Promise<appsCatalogApiCreateMaterialResponse> => {

  return customFetch<appsCatalogApiCreateMaterialResponse>(getAppsCatalogApiCreateMaterialUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialCreate,)
  }
);}




export const getAppsCatalogApiCreateMaterialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>, TError,{data: MaterialCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>, TError,{data: MaterialCreate}, TContext> => {

const mutationKey = ['appsCatalogApiCreateMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>, {data: MaterialCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsCatalogApiCreateMaterial(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCatalogApiCreateMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>>
    export type AppsCatalogApiCreateMaterialMutationBody = MaterialCreate
    export type AppsCatalogApiCreateMaterialMutationError = unknown

    /**
 * @summary Create Material
 */
export const useAppsCatalogApiCreateMaterial = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>, TError,{data: MaterialCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCatalogApiCreateMaterial>>,
        TError,
        {data: MaterialCreate},
        TContext
      > => {
      return useMutation(getAppsCatalogApiCreateMaterialMutationOptions(options), queryClient);
    }

/**
 * @summary Get Material
 */
export type appsCatalogApiGetMaterialResponse200 = {
  data: MaterialOut
  status: 200
}

export type appsCatalogApiGetMaterialResponseSuccess = (appsCatalogApiGetMaterialResponse200) & {
  headers: Headers;
};
;

export type appsCatalogApiGetMaterialResponse = (appsCatalogApiGetMaterialResponseSuccess)

export const getAppsCatalogApiGetMaterialUrl = (materialId: number,) => {




  return `/api/catalog/materials/${materialId}`
}

export const appsCatalogApiGetMaterial = async (materialId: number, options?: RequestInit): Promise<appsCatalogApiGetMaterialResponse> => {

  return customFetch<appsCatalogApiGetMaterialResponse>(getAppsCatalogApiGetMaterialUrl(materialId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsCatalogApiGetMaterialQueryKey = (materialId: number,) => {
    return [
    `/api/catalog/materials/${materialId}`
    ] as const;
    }


export const getAppsCatalogApiGetMaterialQueryOptions = <TData = Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError = unknown>(materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsCatalogApiGetMaterialQueryKey(materialId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>> = ({ signal }) => appsCatalogApiGetMaterial(materialId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(materialId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsCatalogApiGetMaterialQueryResult = NonNullable<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>>
export type AppsCatalogApiGetMaterialQueryError = unknown


export function useAppsCatalogApiGetMaterial<TData = Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError = unknown>(
 materialId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>,
          TError,
          Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCatalogApiGetMaterial<TData = Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError = unknown>(
 materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>,
          TError,
          Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsCatalogApiGetMaterial<TData = Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError = unknown>(
 materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Material
 */

export function useAppsCatalogApiGetMaterial<TData = Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError = unknown>(
 materialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsCatalogApiGetMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsCatalogApiGetMaterialQueryOptions(materialId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Material
 */
export type appsCatalogApiUpdateMaterialResponse200 = {
  data: MaterialOut
  status: 200
}

export type appsCatalogApiUpdateMaterialResponseSuccess = (appsCatalogApiUpdateMaterialResponse200) & {
  headers: Headers;
};
;

export type appsCatalogApiUpdateMaterialResponse = (appsCatalogApiUpdateMaterialResponseSuccess)

export const getAppsCatalogApiUpdateMaterialUrl = (materialId: number,) => {




  return `/api/catalog/materials/${materialId}`
}

export const appsCatalogApiUpdateMaterial = async (materialId: number,
    materialUpdate: MaterialUpdate, options?: RequestInit): Promise<appsCatalogApiUpdateMaterialResponse> => {

  return customFetch<appsCatalogApiUpdateMaterialResponse>(getAppsCatalogApiUpdateMaterialUrl(materialId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialUpdate,)
  }
);}




export const getAppsCatalogApiUpdateMaterialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>, TError,{materialId: number;data: MaterialUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>, TError,{materialId: number;data: MaterialUpdate}, TContext> => {

const mutationKey = ['appsCatalogApiUpdateMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>, {materialId: number;data: MaterialUpdate}> = (props) => {
          const {materialId,data} = props ?? {};

          return  appsCatalogApiUpdateMaterial(materialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCatalogApiUpdateMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>>
    export type AppsCatalogApiUpdateMaterialMutationBody = MaterialUpdate
    export type AppsCatalogApiUpdateMaterialMutationError = unknown

    /**
 * @summary Update Material
 */
export const useAppsCatalogApiUpdateMaterial = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>, TError,{materialId: number;data: MaterialUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCatalogApiUpdateMaterial>>,
        TError,
        {materialId: number;data: MaterialUpdate},
        TContext
      > => {
      return useMutation(getAppsCatalogApiUpdateMaterialMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Material
 */
export type appsCatalogApiDeleteMaterialResponse204 = {
  data: void
  status: 204
}

export type appsCatalogApiDeleteMaterialResponse409 = {
  data: AppsCatalogApiDeleteMaterial409
  status: 409
}

export type appsCatalogApiDeleteMaterialResponseSuccess = (appsCatalogApiDeleteMaterialResponse204) & {
  headers: Headers;
};
export type appsCatalogApiDeleteMaterialResponseError = (appsCatalogApiDeleteMaterialResponse409) & {
  headers: Headers;
};

export type appsCatalogApiDeleteMaterialResponse = (appsCatalogApiDeleteMaterialResponseSuccess | appsCatalogApiDeleteMaterialResponseError)

export const getAppsCatalogApiDeleteMaterialUrl = (materialId: number,) => {




  return `/api/catalog/materials/${materialId}`
}

export const appsCatalogApiDeleteMaterial = async (materialId: number, options?: RequestInit): Promise<appsCatalogApiDeleteMaterialResponse> => {

  return customFetch<appsCatalogApiDeleteMaterialResponse>(getAppsCatalogApiDeleteMaterialUrl(materialId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsCatalogApiDeleteMaterialMutationOptions = <TError = AppsCatalogApiDeleteMaterial409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>, TError,{materialId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>, TError,{materialId: number}, TContext> => {

const mutationKey = ['appsCatalogApiDeleteMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>, {materialId: number}> = (props) => {
          const {materialId} = props ?? {};

          return  appsCatalogApiDeleteMaterial(materialId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsCatalogApiDeleteMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>>

    export type AppsCatalogApiDeleteMaterialMutationError = AppsCatalogApiDeleteMaterial409

    /**
 * @summary Delete Material
 */
export const useAppsCatalogApiDeleteMaterial = <TError = AppsCatalogApiDeleteMaterial409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>, TError,{materialId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsCatalogApiDeleteMaterial>>,
        TError,
        {materialId: number},
        TContext
      > => {
      return useMutation(getAppsCatalogApiDeleteMaterialMutationOptions(options), queryClient);
    }

/**
 * Глобальний K1-агрегований stock listing з summary KPIs.

Групує за `(code, warehouse_id, size_mm)`. Фільтри:
- `warehouse_id` (multi): обмежити лише цими складами;
- `item_type` (multi): material / remnant / part / assembly;
- `search`: підрядок у code/name (case-insensitive).

Sort: `sort_by` ∈ {warehouse, code, name, quantity, size}, `sort_dir` ∈ {asc, desc}.
 * @summary List Stock
 */
export type appsInventoryApiListStockResponse200 = {
  data: StockListResponse
  status: 200
}

export type appsInventoryApiListStockResponseSuccess = (appsInventoryApiListStockResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiListStockResponse = (appsInventoryApiListStockResponseSuccess)

export const getAppsInventoryApiListStockUrl = (params?: AppsInventoryApiListStockParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stock?${stringifiedParams}` : `/api/stock`
}

export const appsInventoryApiListStock = async (params?: AppsInventoryApiListStockParams, options?: RequestInit): Promise<appsInventoryApiListStockResponse> => {

  return customFetch<appsInventoryApiListStockResponse>(getAppsInventoryApiListStockUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiListStockQueryKey = (params?: AppsInventoryApiListStockParams,) => {
    return [
    `/api/stock`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiListStockQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError = unknown>(params?: AppsInventoryApiListStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiListStockQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiListStock>>> = ({ signal }) => appsInventoryApiListStock(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiListStockQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiListStock>>>
export type AppsInventoryApiListStockQueryError = unknown


export function useAppsInventoryApiListStock<TData = Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError = unknown>(
 params: undefined |  AppsInventoryApiListStockParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListStock>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListStock<TData = Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError = unknown>(
 params?: AppsInventoryApiListStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListStock>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListStock<TData = Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError = unknown>(
 params?: AppsInventoryApiListStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Stock
 */

export function useAppsInventoryApiListStock<TData = Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError = unknown>(
 params?: AppsInventoryApiListStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListStock>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiListStockQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Drill-down breakdown за джерелами для агрегованого ключа.
 * @summary Get Stock Origins
 */
export type appsInventoryApiGetStockOriginsResponse200 = {
  data: StockOriginsResponse
  status: 200
}

export type appsInventoryApiGetStockOriginsResponseSuccess = (appsInventoryApiGetStockOriginsResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiGetStockOriginsResponse = (appsInventoryApiGetStockOriginsResponseSuccess)

export const getAppsInventoryApiGetStockOriginsUrl = (params: AppsInventoryApiGetStockOriginsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stock/origins?${stringifiedParams}` : `/api/stock/origins`
}

export const appsInventoryApiGetStockOrigins = async (params: AppsInventoryApiGetStockOriginsParams, options?: RequestInit): Promise<appsInventoryApiGetStockOriginsResponse> => {

  return customFetch<appsInventoryApiGetStockOriginsResponse>(getAppsInventoryApiGetStockOriginsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiGetStockOriginsQueryKey = (params?: AppsInventoryApiGetStockOriginsParams,) => {
    return [
    `/api/stock/origins`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiGetStockOriginsQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError = unknown>(params: AppsInventoryApiGetStockOriginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiGetStockOriginsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>> = ({ signal }) => appsInventoryApiGetStockOrigins(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiGetStockOriginsQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>>
export type AppsInventoryApiGetStockOriginsQueryError = unknown


export function useAppsInventoryApiGetStockOrigins<TData = Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError = unknown>(
 params: AppsInventoryApiGetStockOriginsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiGetStockOrigins<TData = Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError = unknown>(
 params: AppsInventoryApiGetStockOriginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiGetStockOrigins<TData = Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError = unknown>(
 params: AppsInventoryApiGetStockOriginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Stock Origins
 */

export function useAppsInventoryApiGetStockOrigins<TData = Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError = unknown>(
 params: AppsInventoryApiGetStockOriginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetStockOrigins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiGetStockOriginsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Cross-project StockReceipt list for the global «Прибуткові накладні» sidebar entry (ADR-0003 Iter 2 frontend).
 * @summary List Receipts Global
 */
export type appsInventoryApiListReceiptsGlobalResponse200 = {
  data: StockReceiptOut[]
  status: 200
}

export type appsInventoryApiListReceiptsGlobalResponseSuccess = (appsInventoryApiListReceiptsGlobalResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiListReceiptsGlobalResponse = (appsInventoryApiListReceiptsGlobalResponseSuccess)

export const getAppsInventoryApiListReceiptsGlobalUrl = (params?: AppsInventoryApiListReceiptsGlobalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stock-receipts?${stringifiedParams}` : `/api/stock-receipts`
}

export const appsInventoryApiListReceiptsGlobal = async (params?: AppsInventoryApiListReceiptsGlobalParams, options?: RequestInit): Promise<appsInventoryApiListReceiptsGlobalResponse> => {

  return customFetch<appsInventoryApiListReceiptsGlobalResponse>(getAppsInventoryApiListReceiptsGlobalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiListReceiptsGlobalQueryKey = (params?: AppsInventoryApiListReceiptsGlobalParams,) => {
    return [
    `/api/stock-receipts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiListReceiptsGlobalQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError = unknown>(params?: AppsInventoryApiListReceiptsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiListReceiptsGlobalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>> = ({ signal }) => appsInventoryApiListReceiptsGlobal(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiListReceiptsGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>>
export type AppsInventoryApiListReceiptsGlobalQueryError = unknown


export function useAppsInventoryApiListReceiptsGlobal<TData = Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError = unknown>(
 params: undefined |  AppsInventoryApiListReceiptsGlobalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListReceiptsGlobal<TData = Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError = unknown>(
 params?: AppsInventoryApiListReceiptsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListReceiptsGlobal<TData = Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError = unknown>(
 params?: AppsInventoryApiListReceiptsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Receipts Global
 */

export function useAppsInventoryApiListReceiptsGlobal<TData = Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError = unknown>(
 params?: AppsInventoryApiListReceiptsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListReceiptsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiListReceiptsGlobalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Receipt
 */
export type appsInventoryApiGetReceiptResponse200 = {
  data: StockReceiptOut
  status: 200
}

export type appsInventoryApiGetReceiptResponseSuccess = (appsInventoryApiGetReceiptResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiGetReceiptResponse = (appsInventoryApiGetReceiptResponseSuccess)

export const getAppsInventoryApiGetReceiptUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}`
}

export const appsInventoryApiGetReceipt = async (stockReceiptId: number, options?: RequestInit): Promise<appsInventoryApiGetReceiptResponse> => {

  return customFetch<appsInventoryApiGetReceiptResponse>(getAppsInventoryApiGetReceiptUrl(stockReceiptId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiGetReceiptQueryKey = (stockReceiptId: number,) => {
    return [
    `/api/stock-receipts/${stockReceiptId}`
    ] as const;
    }


export const getAppsInventoryApiGetReceiptQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError = unknown>(stockReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiGetReceiptQueryKey(stockReceiptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>> = ({ signal }) => appsInventoryApiGetReceipt(stockReceiptId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(stockReceiptId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiGetReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>>
export type AppsInventoryApiGetReceiptQueryError = unknown


export function useAppsInventoryApiGetReceipt<TData = Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError = unknown>(
 stockReceiptId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiGetReceipt<TData = Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError = unknown>(
 stockReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiGetReceipt<TData = Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError = unknown>(
 stockReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Receipt
 */

export function useAppsInventoryApiGetReceipt<TData = Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError = unknown>(
 stockReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiGetReceiptQueryOptions(stockReceiptId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Receipt
 */
export type appsInventoryApiUpdateReceiptResponse200 = {
  data: StockReceiptOut
  status: 200
}

export type appsInventoryApiUpdateReceiptResponseSuccess = (appsInventoryApiUpdateReceiptResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiUpdateReceiptResponse = (appsInventoryApiUpdateReceiptResponseSuccess)

export const getAppsInventoryApiUpdateReceiptUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}`
}

export const appsInventoryApiUpdateReceipt = async (stockReceiptId: number,
    stockReceiptUpdate: StockReceiptUpdate, options?: RequestInit): Promise<appsInventoryApiUpdateReceiptResponse> => {

  return customFetch<appsInventoryApiUpdateReceiptResponse>(getAppsInventoryApiUpdateReceiptUrl(stockReceiptId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockReceiptUpdate,)
  }
);}




export const getAppsInventoryApiUpdateReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>, TError,{stockReceiptId: number;data: StockReceiptUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>, TError,{stockReceiptId: number;data: StockReceiptUpdate}, TContext> => {

const mutationKey = ['appsInventoryApiUpdateReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>, {stockReceiptId: number;data: StockReceiptUpdate}> = (props) => {
          const {stockReceiptId,data} = props ?? {};

          return  appsInventoryApiUpdateReceipt(stockReceiptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiUpdateReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>>
    export type AppsInventoryApiUpdateReceiptMutationBody = StockReceiptUpdate
    export type AppsInventoryApiUpdateReceiptMutationError = unknown

    /**
 * @summary Update Receipt
 */
export const useAppsInventoryApiUpdateReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>, TError,{stockReceiptId: number;data: StockReceiptUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiUpdateReceipt>>,
        TError,
        {stockReceiptId: number;data: StockReceiptUpdate},
        TContext
      > => {
      return useMutation(getAppsInventoryApiUpdateReceiptMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Receipt
 */
export type appsInventoryApiDeleteReceiptResponse204 = {
  data: void
  status: 204
}

export type appsInventoryApiDeleteReceiptResponse409 = {
  data: AppsInventoryApiDeleteReceipt409
  status: 409
}

export type appsInventoryApiDeleteReceiptResponseSuccess = (appsInventoryApiDeleteReceiptResponse204) & {
  headers: Headers;
};
export type appsInventoryApiDeleteReceiptResponseError = (appsInventoryApiDeleteReceiptResponse409) & {
  headers: Headers;
};

export type appsInventoryApiDeleteReceiptResponse = (appsInventoryApiDeleteReceiptResponseSuccess | appsInventoryApiDeleteReceiptResponseError)

export const getAppsInventoryApiDeleteReceiptUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}`
}

export const appsInventoryApiDeleteReceipt = async (stockReceiptId: number, options?: RequestInit): Promise<appsInventoryApiDeleteReceiptResponse> => {

  return customFetch<appsInventoryApiDeleteReceiptResponse>(getAppsInventoryApiDeleteReceiptUrl(stockReceiptId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsInventoryApiDeleteReceiptMutationOptions = <TError = AppsInventoryApiDeleteReceipt409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>, TError,{stockReceiptId: number}, TContext> => {

const mutationKey = ['appsInventoryApiDeleteReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>, {stockReceiptId: number}> = (props) => {
          const {stockReceiptId} = props ?? {};

          return  appsInventoryApiDeleteReceipt(stockReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiDeleteReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>>

    export type AppsInventoryApiDeleteReceiptMutationError = AppsInventoryApiDeleteReceipt409

    /**
 * @summary Delete Receipt
 */
export const useAppsInventoryApiDeleteReceipt = <TError = AppsInventoryApiDeleteReceipt409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiDeleteReceipt>>,
        TError,
        {stockReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsInventoryApiDeleteReceiptMutationOptions(options), queryClient);
    }

/**
 * Створює порожній SR draft із дефолтами: project=None, title='', notes='',
created_by=current_user. Editor заповнить решту через PUT.
Project обов'язковий тільки якщо у накладній є part/assembly lines
(validated на `post()`).
 * @summary Create Receipt Empty Draft
 */
export type appsInventoryApiCreateReceiptEmptyDraftResponse201 = {
  data: StockReceiptOut
  status: 201
}

export type appsInventoryApiCreateReceiptEmptyDraftResponseSuccess = (appsInventoryApiCreateReceiptEmptyDraftResponse201) & {
  headers: Headers;
};
;

export type appsInventoryApiCreateReceiptEmptyDraftResponse = (appsInventoryApiCreateReceiptEmptyDraftResponseSuccess)

export const getAppsInventoryApiCreateReceiptEmptyDraftUrl = () => {




  return `/api/stock-receipts/drafts/`
}

export const appsInventoryApiCreateReceiptEmptyDraft = async ( options?: RequestInit): Promise<appsInventoryApiCreateReceiptEmptyDraftResponse> => {

  return customFetch<appsInventoryApiCreateReceiptEmptyDraftResponse>(getAppsInventoryApiCreateReceiptEmptyDraftUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsInventoryApiCreateReceiptEmptyDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>, TError,void, TContext> => {

const mutationKey = ['appsInventoryApiCreateReceiptEmptyDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>, void> = () => {


          return  appsInventoryApiCreateReceiptEmptyDraft(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiCreateReceiptEmptyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>>

    export type AppsInventoryApiCreateReceiptEmptyDraftMutationError = unknown

    /**
 * @summary Create Receipt Empty Draft
 */
export const useAppsInventoryApiCreateReceiptEmptyDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiCreateReceiptEmptyDraft>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAppsInventoryApiCreateReceiptEmptyDraftMutationOptions(options), queryClient);
    }

/**
 * @summary Post Receipt Endpoint
 */
export type appsInventoryApiPostReceiptEndpointResponse200 = {
  data: StockReceiptOut
  status: 200
}

export type appsInventoryApiPostReceiptEndpointResponseSuccess = (appsInventoryApiPostReceiptEndpointResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiPostReceiptEndpointResponse = (appsInventoryApiPostReceiptEndpointResponseSuccess)

export const getAppsInventoryApiPostReceiptEndpointUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}/post`
}

export const appsInventoryApiPostReceiptEndpoint = async (stockReceiptId: number, options?: RequestInit): Promise<appsInventoryApiPostReceiptEndpointResponse> => {

  return customFetch<appsInventoryApiPostReceiptEndpointResponse>(getAppsInventoryApiPostReceiptEndpointUrl(stockReceiptId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsInventoryApiPostReceiptEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext> => {

const mutationKey = ['appsInventoryApiPostReceiptEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>, {stockReceiptId: number}> = (props) => {
          const {stockReceiptId} = props ?? {};

          return  appsInventoryApiPostReceiptEndpoint(stockReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiPostReceiptEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>>

    export type AppsInventoryApiPostReceiptEndpointMutationError = unknown

    /**
 * @summary Post Receipt Endpoint
 */
export const useAppsInventoryApiPostReceiptEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiPostReceiptEndpoint>>,
        TError,
        {stockReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsInventoryApiPostReceiptEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Receipt Endpoint
 */
export type appsInventoryApiUnpostReceiptEndpointResponse200 = {
  data: StockReceiptOut
  status: 200
}

export type appsInventoryApiUnpostReceiptEndpointResponse409 = {
  data: AppsInventoryApiUnpostReceiptEndpoint409
  status: 409
}

export type appsInventoryApiUnpostReceiptEndpointResponseSuccess = (appsInventoryApiUnpostReceiptEndpointResponse200) & {
  headers: Headers;
};
export type appsInventoryApiUnpostReceiptEndpointResponseError = (appsInventoryApiUnpostReceiptEndpointResponse409) & {
  headers: Headers;
};

export type appsInventoryApiUnpostReceiptEndpointResponse = (appsInventoryApiUnpostReceiptEndpointResponseSuccess | appsInventoryApiUnpostReceiptEndpointResponseError)

export const getAppsInventoryApiUnpostReceiptEndpointUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}/unpost`
}

export const appsInventoryApiUnpostReceiptEndpoint = async (stockReceiptId: number, options?: RequestInit): Promise<appsInventoryApiUnpostReceiptEndpointResponse> => {

  return customFetch<appsInventoryApiUnpostReceiptEndpointResponse>(getAppsInventoryApiUnpostReceiptEndpointUrl(stockReceiptId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsInventoryApiUnpostReceiptEndpointMutationOptions = <TError = AppsInventoryApiUnpostReceiptEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext> => {

const mutationKey = ['appsInventoryApiUnpostReceiptEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>, {stockReceiptId: number}> = (props) => {
          const {stockReceiptId} = props ?? {};

          return  appsInventoryApiUnpostReceiptEndpoint(stockReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiUnpostReceiptEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>>

    export type AppsInventoryApiUnpostReceiptEndpointMutationError = AppsInventoryApiUnpostReceiptEndpoint409

    /**
 * @summary Unpost Receipt Endpoint
 */
export const useAppsInventoryApiUnpostReceiptEndpoint = <TError = AppsInventoryApiUnpostReceiptEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>, TError,{stockReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiUnpostReceiptEndpoint>>,
        TError,
        {stockReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsInventoryApiUnpostReceiptEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Add Line
 */
export type appsInventoryApiAddLineResponse200 = {
  data: StockReceiptLineOut
  status: 200
}

export type appsInventoryApiAddLineResponseSuccess = (appsInventoryApiAddLineResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiAddLineResponse = (appsInventoryApiAddLineResponseSuccess)

export const getAppsInventoryApiAddLineUrl = (stockReceiptId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}/lines`
}

export const appsInventoryApiAddLine = async (stockReceiptId: number,
    stockReceiptLineCreate: StockReceiptLineCreate, options?: RequestInit): Promise<appsInventoryApiAddLineResponse> => {

  return customFetch<appsInventoryApiAddLineResponse>(getAppsInventoryApiAddLineUrl(stockReceiptId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockReceiptLineCreate,)
  }
);}




export const getAppsInventoryApiAddLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiAddLine>>, TError,{stockReceiptId: number;data: StockReceiptLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiAddLine>>, TError,{stockReceiptId: number;data: StockReceiptLineCreate}, TContext> => {

const mutationKey = ['appsInventoryApiAddLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiAddLine>>, {stockReceiptId: number;data: StockReceiptLineCreate}> = (props) => {
          const {stockReceiptId,data} = props ?? {};

          return  appsInventoryApiAddLine(stockReceiptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiAddLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiAddLine>>>
    export type AppsInventoryApiAddLineMutationBody = StockReceiptLineCreate
    export type AppsInventoryApiAddLineMutationError = unknown

    /**
 * @summary Add Line
 */
export const useAppsInventoryApiAddLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiAddLine>>, TError,{stockReceiptId: number;data: StockReceiptLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiAddLine>>,
        TError,
        {stockReceiptId: number;data: StockReceiptLineCreate},
        TContext
      > => {
      return useMutation(getAppsInventoryApiAddLineMutationOptions(options), queryClient);
    }

/**
 * @summary Update Line
 */
export type appsInventoryApiUpdateLineResponse200 = {
  data: StockReceiptLineOut
  status: 200
}

export type appsInventoryApiUpdateLineResponseSuccess = (appsInventoryApiUpdateLineResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiUpdateLineResponse = (appsInventoryApiUpdateLineResponseSuccess)

export const getAppsInventoryApiUpdateLineUrl = (stockReceiptId: number,
    lineId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}/lines/${lineId}`
}

export const appsInventoryApiUpdateLine = async (stockReceiptId: number,
    lineId: number,
    stockReceiptLineUpdate: StockReceiptLineUpdate, options?: RequestInit): Promise<appsInventoryApiUpdateLineResponse> => {

  return customFetch<appsInventoryApiUpdateLineResponse>(getAppsInventoryApiUpdateLineUrl(stockReceiptId,lineId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockReceiptLineUpdate,)
  }
);}




export const getAppsInventoryApiUpdateLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>, TError,{stockReceiptId: number;lineId: number;data: StockReceiptLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>, TError,{stockReceiptId: number;lineId: number;data: StockReceiptLineUpdate}, TContext> => {

const mutationKey = ['appsInventoryApiUpdateLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>, {stockReceiptId: number;lineId: number;data: StockReceiptLineUpdate}> = (props) => {
          const {stockReceiptId,lineId,data} = props ?? {};

          return  appsInventoryApiUpdateLine(stockReceiptId,lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiUpdateLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>>
    export type AppsInventoryApiUpdateLineMutationBody = StockReceiptLineUpdate
    export type AppsInventoryApiUpdateLineMutationError = unknown

    /**
 * @summary Update Line
 */
export const useAppsInventoryApiUpdateLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>, TError,{stockReceiptId: number;lineId: number;data: StockReceiptLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiUpdateLine>>,
        TError,
        {stockReceiptId: number;lineId: number;data: StockReceiptLineUpdate},
        TContext
      > => {
      return useMutation(getAppsInventoryApiUpdateLineMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Line
 */
export type appsInventoryApiDeleteLineResponse204 = {
  data: void
  status: 204
}

export type appsInventoryApiDeleteLineResponseSuccess = (appsInventoryApiDeleteLineResponse204) & {
  headers: Headers;
};
;

export type appsInventoryApiDeleteLineResponse = (appsInventoryApiDeleteLineResponseSuccess)

export const getAppsInventoryApiDeleteLineUrl = (stockReceiptId: number,
    lineId: number,) => {




  return `/api/stock-receipts/${stockReceiptId}/lines/${lineId}`
}

export const appsInventoryApiDeleteLine = async (stockReceiptId: number,
    lineId: number, options?: RequestInit): Promise<appsInventoryApiDeleteLineResponse> => {

  return customFetch<appsInventoryApiDeleteLineResponse>(getAppsInventoryApiDeleteLineUrl(stockReceiptId,lineId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsInventoryApiDeleteLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>, TError,{stockReceiptId: number;lineId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>, TError,{stockReceiptId: number;lineId: number}, TContext> => {

const mutationKey = ['appsInventoryApiDeleteLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>, {stockReceiptId: number;lineId: number}> = (props) => {
          const {stockReceiptId,lineId} = props ?? {};

          return  appsInventoryApiDeleteLine(stockReceiptId,lineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsInventoryApiDeleteLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>>

    export type AppsInventoryApiDeleteLineMutationError = unknown

    /**
 * @summary Delete Line
 */
export const useAppsInventoryApiDeleteLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>, TError,{stockReceiptId: number;lineId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsInventoryApiDeleteLine>>,
        TError,
        {stockReceiptId: number;lineId: number},
        TContext
      > => {
      return useMutation(getAppsInventoryApiDeleteLineMutationOptions(options), queryClient);
    }

/**
 * List remnant MSIs (post-Phase 11.5: all MSIs are remnants).

`include_cross_project_warehouses=true` (T11 parity) — пропускає фільтр
`lot.project_id`; повертає MSI на основі `warehouse_id` (та інших фільтрів).
Use for warehouse-centric flows (Transfer line picker для global warehouse).
Path `project_id` лишається валідатором (любий існуючий проект).
 * @summary List Msi
 */
export type appsInventoryApiListMsiResponse200 = {
  data: PaginatedMaterialStockItems
  status: 200
}

export type appsInventoryApiListMsiResponseSuccess = (appsInventoryApiListMsiResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiListMsiResponse = (appsInventoryApiListMsiResponseSuccess)

export const getAppsInventoryApiListMsiUrl = (projectId: number,
    params?: AppsInventoryApiListMsiParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/material-stock-items?${stringifiedParams}` : `/api/projects/${projectId}/material-stock-items`
}

export const appsInventoryApiListMsi = async (projectId: number,
    params?: AppsInventoryApiListMsiParams, options?: RequestInit): Promise<appsInventoryApiListMsiResponse> => {

  return customFetch<appsInventoryApiListMsiResponse>(getAppsInventoryApiListMsiUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiListMsiQueryKey = (projectId: number,
    params?: AppsInventoryApiListMsiParams,) => {
    return [
    `/api/projects/${projectId}/material-stock-items`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiListMsiQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError = unknown>(projectId: number,
    params?: AppsInventoryApiListMsiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiListMsiQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiListMsi>>> = ({ signal }) => appsInventoryApiListMsi(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiListMsiQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiListMsi>>>
export type AppsInventoryApiListMsiQueryError = unknown


export function useAppsInventoryApiListMsi<TData = Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsInventoryApiListMsiParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListMsi>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListMsi>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListMsi<TData = Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMsiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListMsi>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListMsi>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListMsi<TData = Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMsiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Msi
 */

export function useAppsInventoryApiListMsi<TData = Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMsiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMsi>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiListMsiQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * List raw material lots for a project. Default hides soft-deleted.

`include_cross_project_warehouses=true` widens the filter for the cutter
material auto-fill UX: instead of filtering by `lot.project_id` only, the
endpoint returns every lot of the material regardless of owner (own project,
нічийний, foreign). The path's `project_id` becomes a reference point only —
used to compute `requires_transfer` per lot (`True` when `lot.project_id`
differs from this project, ADR-0006). Legacy callers (default `false`) keep
the strict ownership filter.
 * @summary List Material Stock Lots
 */
export type appsInventoryApiListMaterialStockLotsResponse200 = {
  data: PaginatedMaterialStockLots
  status: 200
}

export type appsInventoryApiListMaterialStockLotsResponseSuccess = (appsInventoryApiListMaterialStockLotsResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiListMaterialStockLotsResponse = (appsInventoryApiListMaterialStockLotsResponseSuccess)

export const getAppsInventoryApiListMaterialStockLotsUrl = (projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/material-stock-lots?${stringifiedParams}` : `/api/projects/${projectId}/material-stock-lots`
}

export const appsInventoryApiListMaterialStockLots = async (projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams, options?: RequestInit): Promise<appsInventoryApiListMaterialStockLotsResponse> => {

  return customFetch<appsInventoryApiListMaterialStockLotsResponse>(getAppsInventoryApiListMaterialStockLotsUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiListMaterialStockLotsQueryKey = (projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams,) => {
    return [
    `/api/projects/${projectId}/material-stock-lots`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiListMaterialStockLotsQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError = unknown>(projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiListMaterialStockLotsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>> = ({ signal }) => appsInventoryApiListMaterialStockLots(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiListMaterialStockLotsQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>>
export type AppsInventoryApiListMaterialStockLotsQueryError = unknown


export function useAppsInventoryApiListMaterialStockLots<TData = Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsInventoryApiListMaterialStockLotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListMaterialStockLots<TData = Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListMaterialStockLots<TData = Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Material Stock Lots
 */

export function useAppsInventoryApiListMaterialStockLots<TData = Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListMaterialStockLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListMaterialStockLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiListMaterialStockLotsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * List per-piece StockItem rows for a project.

URL retains legacy `stock-lots` name; underlying model is `StockItem`
(1 row = 1 фізична штука). Filters enable drill-down: e.g.
`?item_kind=part&part_id=X&status=available` → all live AVAILABLE pieces
of part X.
 * @summary List Lots
 */
export type appsInventoryApiListLotsResponse200 = {
  data: PaginatedStockLots
  status: 200
}

export type appsInventoryApiListLotsResponseSuccess = (appsInventoryApiListLotsResponse200) & {
  headers: Headers;
};
;

export type appsInventoryApiListLotsResponse = (appsInventoryApiListLotsResponseSuccess)

export const getAppsInventoryApiListLotsUrl = (projectId: number,
    params?: AppsInventoryApiListLotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/stock-lots?${stringifiedParams}` : `/api/projects/${projectId}/stock-lots`
}

export const appsInventoryApiListLots = async (projectId: number,
    params?: AppsInventoryApiListLotsParams, options?: RequestInit): Promise<appsInventoryApiListLotsResponse> => {

  return customFetch<appsInventoryApiListLotsResponse>(getAppsInventoryApiListLotsUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsInventoryApiListLotsQueryKey = (projectId: number,
    params?: AppsInventoryApiListLotsParams,) => {
    return [
    `/api/projects/${projectId}/stock-lots`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsInventoryApiListLotsQueryOptions = <TData = Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError = unknown>(projectId: number,
    params?: AppsInventoryApiListLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsInventoryApiListLotsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsInventoryApiListLots>>> = ({ signal }) => appsInventoryApiListLots(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsInventoryApiListLotsQueryResult = NonNullable<Awaited<ReturnType<typeof appsInventoryApiListLots>>>
export type AppsInventoryApiListLotsQueryError = unknown


export function useAppsInventoryApiListLots<TData = Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError = unknown>(
 projectId: number,
    params: undefined |  AppsInventoryApiListLotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListLots>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListLots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListLots<TData = Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsInventoryApiListLots>>,
          TError,
          Awaited<ReturnType<typeof appsInventoryApiListLots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsInventoryApiListLots<TData = Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Lots
 */

export function useAppsInventoryApiListLots<TData = Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError = unknown>(
 projectId: number,
    params?: AppsInventoryApiListLotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsInventoryApiListLots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsInventoryApiListLotsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Project Deficits
 */
export type appsDeficitsApiGetProjectDeficitsResponse200 = {
  data: DeficitsResponse
  status: 200
}

export type appsDeficitsApiGetProjectDeficitsResponseSuccess = (appsDeficitsApiGetProjectDeficitsResponse200) & {
  headers: Headers;
};
;

export type appsDeficitsApiGetProjectDeficitsResponse = (appsDeficitsApiGetProjectDeficitsResponseSuccess)

export const getAppsDeficitsApiGetProjectDeficitsUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/deficits`
}

export const appsDeficitsApiGetProjectDeficits = async (projectId: number, options?: RequestInit): Promise<appsDeficitsApiGetProjectDeficitsResponse> => {

  return customFetch<appsDeficitsApiGetProjectDeficitsResponse>(getAppsDeficitsApiGetProjectDeficitsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsDeficitsApiGetProjectDeficitsQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/deficits`
    ] as const;
    }


export const getAppsDeficitsApiGetProjectDeficitsQueryOptions = <TData = Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError = unknown>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsDeficitsApiGetProjectDeficitsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>> = ({ signal }) => appsDeficitsApiGetProjectDeficits(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsDeficitsApiGetProjectDeficitsQueryResult = NonNullable<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>>
export type AppsDeficitsApiGetProjectDeficitsQueryError = unknown


export function useAppsDeficitsApiGetProjectDeficits<TData = Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError = unknown>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>,
          TError,
          Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsDeficitsApiGetProjectDeficits<TData = Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>,
          TError,
          Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsDeficitsApiGetProjectDeficits<TData = Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Project Deficits
 */

export function useAppsDeficitsApiGetProjectDeficits<TData = Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError = unknown>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsDeficitsApiGetProjectDeficits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsDeficitsApiGetProjectDeficitsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Work Order
 */
export type appsWorkordersApiCreateWorkOrderResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type appsWorkordersApiCreateWorkOrderResponseSuccess = (appsWorkordersApiCreateWorkOrderResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiCreateWorkOrderResponse = (appsWorkordersApiCreateWorkOrderResponseSuccess)

export const getAppsWorkordersApiCreateWorkOrderUrl = () => {




  return `/api/work-orders`
}

export const appsWorkordersApiCreateWorkOrder = async (workOrderCreate: WorkOrderCreate, options?: RequestInit): Promise<appsWorkordersApiCreateWorkOrderResponse> => {

  return customFetch<appsWorkordersApiCreateWorkOrderResponse>(getAppsWorkordersApiCreateWorkOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrderCreate,)
  }
);}




export const getAppsWorkordersApiCreateWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>, TError,{data: WorkOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>, TError,{data: WorkOrderCreate}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>, {data: WorkOrderCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsWorkordersApiCreateWorkOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>>
    export type AppsWorkordersApiCreateWorkOrderMutationBody = WorkOrderCreate
    export type AppsWorkordersApiCreateWorkOrderMutationError = unknown

    /**
 * @summary Create Work Order
 */
export const useAppsWorkordersApiCreateWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>, TError,{data: WorkOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateWorkOrder>>,
        TError,
        {data: WorkOrderCreate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateWorkOrderMutationOptions(options), queryClient);
    }

/**
 * @summary List Work Orders
 */
export type appsWorkordersApiListWorkOrdersResponse200 = {
  data: PaginatedWorkOrders
  status: 200
}

export type appsWorkordersApiListWorkOrdersResponseSuccess = (appsWorkordersApiListWorkOrdersResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListWorkOrdersResponse = (appsWorkordersApiListWorkOrdersResponseSuccess)

export const getAppsWorkordersApiListWorkOrdersUrl = (params?: AppsWorkordersApiListWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/work-orders?${stringifiedParams}` : `/api/work-orders`
}

export const appsWorkordersApiListWorkOrders = async (params?: AppsWorkordersApiListWorkOrdersParams, options?: RequestInit): Promise<appsWorkordersApiListWorkOrdersResponse> => {

  return customFetch<appsWorkordersApiListWorkOrdersResponse>(getAppsWorkordersApiListWorkOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListWorkOrdersQueryKey = (params?: AppsWorkordersApiListWorkOrdersParams,) => {
    return [
    `/api/work-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWorkordersApiListWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError = unknown>(params?: AppsWorkordersApiListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>> = ({ signal }) => appsWorkordersApiListWorkOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>>
export type AppsWorkordersApiListWorkOrdersQueryError = unknown


export function useAppsWorkordersApiListWorkOrders<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError = unknown>(
 params: undefined |  AppsWorkordersApiListWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListWorkOrders<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError = unknown>(
 params?: AppsWorkordersApiListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListWorkOrders<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError = unknown>(
 params?: AppsWorkordersApiListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Work Orders
 */

export function useAppsWorkordersApiListWorkOrders<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError = unknown>(
 params?: AppsWorkordersApiListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Work Order
 */
export type appsWorkordersApiGetWorkOrderResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type appsWorkordersApiGetWorkOrderResponseSuccess = (appsWorkordersApiGetWorkOrderResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiGetWorkOrderResponse = (appsWorkordersApiGetWorkOrderResponseSuccess)

export const getAppsWorkordersApiGetWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

export const appsWorkordersApiGetWorkOrder = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiGetWorkOrderResponse> => {

  return customFetch<appsWorkordersApiGetWorkOrderResponse>(getAppsWorkordersApiGetWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiGetWorkOrderQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}`
    ] as const;
    }


export const getAppsWorkordersApiGetWorkOrderQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiGetWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>> = ({ signal }) => appsWorkordersApiGetWorkOrder(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiGetWorkOrderQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>>
export type AppsWorkordersApiGetWorkOrderQueryError = unknown


export function useAppsWorkordersApiGetWorkOrder<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetWorkOrder<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetWorkOrder<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Work Order
 */

export function useAppsWorkordersApiGetWorkOrder<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiGetWorkOrderQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Work Order
 */
export type appsWorkordersApiUpdateWorkOrderResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type appsWorkordersApiUpdateWorkOrderResponseSuccess = (appsWorkordersApiUpdateWorkOrderResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateWorkOrderResponse = (appsWorkordersApiUpdateWorkOrderResponseSuccess)

export const getAppsWorkordersApiUpdateWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

export const appsWorkordersApiUpdateWorkOrder = async (workOrderId: number,
    workOrderUpdate: WorkOrderUpdate, options?: RequestInit): Promise<appsWorkordersApiUpdateWorkOrderResponse> => {

  return customFetch<appsWorkordersApiUpdateWorkOrderResponse>(getAppsWorkordersApiUpdateWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrderUpdate,)
  }
);}




export const getAppsWorkordersApiUpdateWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>, TError,{workOrderId: number;data: WorkOrderUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>, TError,{workOrderId: number;data: WorkOrderUpdate}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>, {workOrderId: number;data: WorkOrderUpdate}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiUpdateWorkOrder(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>>
    export type AppsWorkordersApiUpdateWorkOrderMutationBody = WorkOrderUpdate
    export type AppsWorkordersApiUpdateWorkOrderMutationError = unknown

    /**
 * @summary Update Work Order
 */
export const useAppsWorkordersApiUpdateWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>, TError,{workOrderId: number;data: WorkOrderUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateWorkOrder>>,
        TError,
        {workOrderId: number;data: WorkOrderUpdate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateWorkOrderMutationOptions(options), queryClient);
    }

/**
 * Видалити DRAFT WO разом з task_lines / issue_lines / output_lines / cut plan.

Блокують лише субординатні документи (MIN / PR / GR) — це окремі business
documents. Внутрішня структура WO (завдання, план розкрою, placements)
видаляється атомарно: спочатку placements (через PROTECT-FK на task_line),
потім CASCADE прибирає решту через ``WorkOrder.delete()``.
 * @summary Delete Work Order
 */
export type appsWorkordersApiDeleteWorkOrderResponse204 = {
  data: void
  status: 204
}

export type appsWorkordersApiDeleteWorkOrderResponse409 = {
  data: AppsWorkordersApiDeleteWorkOrder409
  status: 409
}

export type appsWorkordersApiDeleteWorkOrderResponseSuccess = (appsWorkordersApiDeleteWorkOrderResponse204) & {
  headers: Headers;
};
export type appsWorkordersApiDeleteWorkOrderResponseError = (appsWorkordersApiDeleteWorkOrderResponse409) & {
  headers: Headers;
};

export type appsWorkordersApiDeleteWorkOrderResponse = (appsWorkordersApiDeleteWorkOrderResponseSuccess | appsWorkordersApiDeleteWorkOrderResponseError)

export const getAppsWorkordersApiDeleteWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

export const appsWorkordersApiDeleteWorkOrder = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiDeleteWorkOrderResponse> => {

  return customFetch<appsWorkordersApiDeleteWorkOrderResponse>(getAppsWorkordersApiDeleteWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWorkordersApiDeleteWorkOrderMutationOptions = <TError = AppsWorkordersApiDeleteWorkOrder409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>, TError,{workOrderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>, TError,{workOrderId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiDeleteWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>, {workOrderId: number}> = (props) => {
          const {workOrderId} = props ?? {};

          return  appsWorkordersApiDeleteWorkOrder(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiDeleteWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>>

    export type AppsWorkordersApiDeleteWorkOrderMutationError = AppsWorkordersApiDeleteWorkOrder409

    /**
 * @summary Delete Work Order
 */
export const useAppsWorkordersApiDeleteWorkOrder = <TError = AppsWorkordersApiDeleteWorkOrder409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>, TError,{workOrderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiDeleteWorkOrder>>,
        TError,
        {workOrderId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiDeleteWorkOrderMutationOptions(options), queryClient);
    }

/**
 * Що ще лишилось по наряду — крок «Далі» на сторінці наряду.
 * @summary Get Work Order Progress
 */
export type appsWorkordersApiGetWorkOrderProgressResponse200 = {
  data: WorkOrderProgressOut
  status: 200
}

export type appsWorkordersApiGetWorkOrderProgressResponseSuccess = (appsWorkordersApiGetWorkOrderProgressResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiGetWorkOrderProgressResponse = (appsWorkordersApiGetWorkOrderProgressResponseSuccess)

export const getAppsWorkordersApiGetWorkOrderProgressUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/progress/`
}

export const appsWorkordersApiGetWorkOrderProgress = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiGetWorkOrderProgressResponse> => {

  return customFetch<appsWorkordersApiGetWorkOrderProgressResponse>(getAppsWorkordersApiGetWorkOrderProgressUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiGetWorkOrderProgressQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/progress/`
    ] as const;
    }


export const getAppsWorkordersApiGetWorkOrderProgressQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiGetWorkOrderProgressQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>> = ({ signal }) => appsWorkordersApiGetWorkOrderProgress(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiGetWorkOrderProgressQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>>
export type AppsWorkordersApiGetWorkOrderProgressQueryError = unknown


export function useAppsWorkordersApiGetWorkOrderProgress<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetWorkOrderProgress<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetWorkOrderProgress<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Work Order Progress
 */

export function useAppsWorkordersApiGetWorkOrderProgress<TData = Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiGetWorkOrderProgressQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Read-only pre-flight check: returns whether a DRAFT WO can be deleted and what blocks it.
 * @summary Delete Preflight
 */
export type appsWorkordersApiDeletePreflightResponse200 = {
  data: DeletePreflightOut
  status: 200
}

export type appsWorkordersApiDeletePreflightResponseSuccess = (appsWorkordersApiDeletePreflightResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiDeletePreflightResponse = (appsWorkordersApiDeletePreflightResponseSuccess)

export const getAppsWorkordersApiDeletePreflightUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/delete-preflight/`
}

export const appsWorkordersApiDeletePreflight = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiDeletePreflightResponse> => {

  return customFetch<appsWorkordersApiDeletePreflightResponse>(getAppsWorkordersApiDeletePreflightUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiDeletePreflightQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/delete-preflight/`
    ] as const;
    }


export const getAppsWorkordersApiDeletePreflightQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiDeletePreflightQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>> = ({ signal }) => appsWorkordersApiDeletePreflight(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiDeletePreflightQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>>
export type AppsWorkordersApiDeletePreflightQueryError = unknown


export function useAppsWorkordersApiDeletePreflight<TData = Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiDeletePreflight<TData = Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiDeletePreflight<TData = Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Preflight
 */

export function useAppsWorkordersApiDeletePreflight<TData = Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiDeletePreflight>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiDeletePreflightQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Optimize Work Order Endpoint
 */
export type appsWorkordersApiOptimizeWorkOrderEndpointResponse200 = {
  data: void
  status: 200
}

export type appsWorkordersApiOptimizeWorkOrderEndpointResponseSuccess = (appsWorkordersApiOptimizeWorkOrderEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiOptimizeWorkOrderEndpointResponse = (appsWorkordersApiOptimizeWorkOrderEndpointResponseSuccess)

export const getAppsWorkordersApiOptimizeWorkOrderEndpointUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/optimize`
}

export const appsWorkordersApiOptimizeWorkOrderEndpoint = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiOptimizeWorkOrderEndpointResponse> => {

  return customFetch<appsWorkordersApiOptimizeWorkOrderEndpointResponse>(getAppsWorkordersApiOptimizeWorkOrderEndpointUrl(workOrderId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWorkordersApiOptimizeWorkOrderEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>, TError,{workOrderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>, TError,{workOrderId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiOptimizeWorkOrderEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>, {workOrderId: number}> = (props) => {
          const {workOrderId} = props ?? {};

          return  appsWorkordersApiOptimizeWorkOrderEndpoint(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiOptimizeWorkOrderEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>>

    export type AppsWorkordersApiOptimizeWorkOrderEndpointMutationError = unknown

    /**
 * @summary Optimize Work Order Endpoint
 */
export const useAppsWorkordersApiOptimizeWorkOrderEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>, TError,{workOrderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiOptimizeWorkOrderEndpoint>>,
        TError,
        {workOrderId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiOptimizeWorkOrderEndpointMutationOptions(options), queryClient);
    }

/**
 * Atomic replace WO's cut plan з user-supplied payload. Wipe-and-replace.

State/kind guards return 409 via `_assert_*` helpers. Payload-level
`ValidationError` raised inside the service falls through to the global
`handle_django_validation_error` handler → 400 з `{"errors": {...}}`.
 * @summary Replace Cut Plan Endpoint
 */
export type appsWorkordersApiReplaceCutPlanEndpointResponse200 = {
  data: CutPlanReplaceResult
  status: 200
}

export type appsWorkordersApiReplaceCutPlanEndpointResponseSuccess = (appsWorkordersApiReplaceCutPlanEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiReplaceCutPlanEndpointResponse = (appsWorkordersApiReplaceCutPlanEndpointResponseSuccess)

export const getAppsWorkordersApiReplaceCutPlanEndpointUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/cut-plan/replace`
}

export const appsWorkordersApiReplaceCutPlanEndpoint = async (workOrderId: number,
    cutPlanReplaceIn: CutPlanReplaceIn, options?: RequestInit): Promise<appsWorkordersApiReplaceCutPlanEndpointResponse> => {

  return customFetch<appsWorkordersApiReplaceCutPlanEndpointResponse>(getAppsWorkordersApiReplaceCutPlanEndpointUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cutPlanReplaceIn,)
  }
);}




export const getAppsWorkordersApiReplaceCutPlanEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>, TError,{workOrderId: number;data: CutPlanReplaceIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>, TError,{workOrderId: number;data: CutPlanReplaceIn}, TContext> => {

const mutationKey = ['appsWorkordersApiReplaceCutPlanEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>, {workOrderId: number;data: CutPlanReplaceIn}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiReplaceCutPlanEndpoint(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiReplaceCutPlanEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>>
    export type AppsWorkordersApiReplaceCutPlanEndpointMutationBody = CutPlanReplaceIn
    export type AppsWorkordersApiReplaceCutPlanEndpointMutationError = unknown

    /**
 * @summary Replace Cut Plan Endpoint
 */
export const useAppsWorkordersApiReplaceCutPlanEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>, TError,{workOrderId: number;data: CutPlanReplaceIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiReplaceCutPlanEndpoint>>,
        TError,
        {workOrderId: number;data: CutPlanReplaceIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiReplaceCutPlanEndpointMutationOptions(options), queryClient);
    }

/**
 * Picker options для «Додати джерело» у cut-plan editor.

Returns flat list of (kind, source_id, material, length_mm, available) для
всіх материалів, які фігурують у task_lines цього WO. Доступне у DRAFT only —
у POSTED edit заблокований (та й picker не рендериться).
 * @summary List Cut Plan Sources
 */
export type appsWorkordersApiListCutPlanSourcesResponse200 = {
  data: AppsWorkordersApiListCutPlanSources200Item[]
  status: 200
}

export type appsWorkordersApiListCutPlanSourcesResponseSuccess = (appsWorkordersApiListCutPlanSourcesResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListCutPlanSourcesResponse = (appsWorkordersApiListCutPlanSourcesResponseSuccess)

export const getAppsWorkordersApiListCutPlanSourcesUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/cut-plan/sources`
}

export const appsWorkordersApiListCutPlanSources = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListCutPlanSourcesResponse> => {

  return customFetch<appsWorkordersApiListCutPlanSourcesResponse>(getAppsWorkordersApiListCutPlanSourcesUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListCutPlanSourcesQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/cut-plan/sources`
    ] as const;
    }


export const getAppsWorkordersApiListCutPlanSourcesQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListCutPlanSourcesQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>> = ({ signal }) => appsWorkordersApiListCutPlanSources(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListCutPlanSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>>
export type AppsWorkordersApiListCutPlanSourcesQueryError = unknown


export function useAppsWorkordersApiListCutPlanSources<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanSources<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanSources<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Cut Plan Sources
 */

export function useAppsWorkordersApiListCutPlanSources<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanSources>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListCutPlanSourcesQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Post Work Order Endpoint
 */
export type appsWorkordersApiPostWorkOrderEndpointResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type appsWorkordersApiPostWorkOrderEndpointResponseSuccess = (appsWorkordersApiPostWorkOrderEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiPostWorkOrderEndpointResponse = (appsWorkordersApiPostWorkOrderEndpointResponseSuccess)

export const getAppsWorkordersApiPostWorkOrderEndpointUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/post`
}

export const appsWorkordersApiPostWorkOrderEndpoint = async (workOrderId: number,
    postInNull?: PostIn | null, options?: RequestInit): Promise<appsWorkordersApiPostWorkOrderEndpointResponse> => {

  return customFetch<appsWorkordersApiPostWorkOrderEndpointResponse>(getAppsWorkordersApiPostWorkOrderEndpointUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postInNull,)
  }
);}




export const getAppsWorkordersApiPostWorkOrderEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>, TError,{workOrderId: number;data?: PostIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>, TError,{workOrderId: number;data?: PostIn | null}, TContext> => {

const mutationKey = ['appsWorkordersApiPostWorkOrderEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>, {workOrderId: number;data?: PostIn | null}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiPostWorkOrderEndpoint(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiPostWorkOrderEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>>
    export type AppsWorkordersApiPostWorkOrderEndpointMutationBody = PostIn | null | undefined
    export type AppsWorkordersApiPostWorkOrderEndpointMutationError = unknown

    /**
 * @summary Post Work Order Endpoint
 */
export const useAppsWorkordersApiPostWorkOrderEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>, TError,{workOrderId: number;data?: PostIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiPostWorkOrderEndpoint>>,
        TError,
        {workOrderId: number;data?: PostIn | null},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiPostWorkOrderEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Work Order Endpoint
 */
export type appsWorkordersApiUnpostWorkOrderEndpointResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type appsWorkordersApiUnpostWorkOrderEndpointResponseSuccess = (appsWorkordersApiUnpostWorkOrderEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUnpostWorkOrderEndpointResponse = (appsWorkordersApiUnpostWorkOrderEndpointResponseSuccess)

export const getAppsWorkordersApiUnpostWorkOrderEndpointUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/unpost`
}

export const appsWorkordersApiUnpostWorkOrderEndpoint = async (workOrderId: number,
    unpostIn: UnpostIn, options?: RequestInit): Promise<appsWorkordersApiUnpostWorkOrderEndpointResponse> => {

  return customFetch<appsWorkordersApiUnpostWorkOrderEndpointResponse>(getAppsWorkordersApiUnpostWorkOrderEndpointUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unpostIn,)
  }
);}




export const getAppsWorkordersApiUnpostWorkOrderEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>, TError,{workOrderId: number;data: UnpostIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>, TError,{workOrderId: number;data: UnpostIn}, TContext> => {

const mutationKey = ['appsWorkordersApiUnpostWorkOrderEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>, {workOrderId: number;data: UnpostIn}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiUnpostWorkOrderEndpoint(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUnpostWorkOrderEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>>
    export type AppsWorkordersApiUnpostWorkOrderEndpointMutationBody = UnpostIn
    export type AppsWorkordersApiUnpostWorkOrderEndpointMutationError = unknown

    /**
 * @summary Unpost Work Order Endpoint
 */
export const useAppsWorkordersApiUnpostWorkOrderEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>, TError,{workOrderId: number;data: UnpostIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUnpostWorkOrderEndpoint>>,
        TError,
        {workOrderId: number;data: UnpostIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUnpostWorkOrderEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Operations
 */
export type appsWorkordersApiListOperationsResponse200 = {
  data: OperationOut[]
  status: 200
}

export type appsWorkordersApiListOperationsResponseSuccess = (appsWorkordersApiListOperationsResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListOperationsResponse = (appsWorkordersApiListOperationsResponseSuccess)

export const getAppsWorkordersApiListOperationsUrl = (params?: AppsWorkordersApiListOperationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/operations?${stringifiedParams}` : `/api/operations`
}

export const appsWorkordersApiListOperations = async (params?: AppsWorkordersApiListOperationsParams, options?: RequestInit): Promise<appsWorkordersApiListOperationsResponse> => {

  return customFetch<appsWorkordersApiListOperationsResponse>(getAppsWorkordersApiListOperationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListOperationsQueryKey = (params?: AppsWorkordersApiListOperationsParams,) => {
    return [
    `/api/operations`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWorkordersApiListOperationsQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError = unknown>(params?: AppsWorkordersApiListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListOperationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>> = ({ signal }) => appsWorkordersApiListOperations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>>
export type AppsWorkordersApiListOperationsQueryError = unknown


export function useAppsWorkordersApiListOperations<TData = Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError = unknown>(
 params: undefined |  AppsWorkordersApiListOperationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListOperations>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListOperations<TData = Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError = unknown>(
 params?: AppsWorkordersApiListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListOperations>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListOperations<TData = Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError = unknown>(
 params?: AppsWorkordersApiListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Operations
 */

export function useAppsWorkordersApiListOperations<TData = Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError = unknown>(
 params?: AppsWorkordersApiListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListOperationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Operation Endpoint
 */
export type appsWorkordersApiCreateOperationEndpointResponse200 = {
  data: OperationOut
  status: 200
}

export type appsWorkordersApiCreateOperationEndpointResponse400 = {
  data: AppsWorkordersApiCreateOperationEndpoint400
  status: 400
}

export type appsWorkordersApiCreateOperationEndpointResponse409 = {
  data: AppsWorkordersApiCreateOperationEndpoint409
  status: 409
}

export type appsWorkordersApiCreateOperationEndpointResponseSuccess = (appsWorkordersApiCreateOperationEndpointResponse200) & {
  headers: Headers;
};
export type appsWorkordersApiCreateOperationEndpointResponseError = (appsWorkordersApiCreateOperationEndpointResponse400 | appsWorkordersApiCreateOperationEndpointResponse409) & {
  headers: Headers;
};

export type appsWorkordersApiCreateOperationEndpointResponse = (appsWorkordersApiCreateOperationEndpointResponseSuccess | appsWorkordersApiCreateOperationEndpointResponseError)

export const getAppsWorkordersApiCreateOperationEndpointUrl = () => {




  return `/api/operations`
}

export const appsWorkordersApiCreateOperationEndpoint = async (operationCreate: OperationCreate, options?: RequestInit): Promise<appsWorkordersApiCreateOperationEndpointResponse> => {

  return customFetch<appsWorkordersApiCreateOperationEndpointResponse>(getAppsWorkordersApiCreateOperationEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationCreate,)
  }
);}




export const getAppsWorkordersApiCreateOperationEndpointMutationOptions = <TError = AppsWorkordersApiCreateOperationEndpoint400 | AppsWorkordersApiCreateOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>, TError,{data: OperationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>, TError,{data: OperationCreate}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateOperationEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>, {data: OperationCreate}> = (props) => {
          const {data} = props ?? {};

          return  appsWorkordersApiCreateOperationEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateOperationEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>>
    export type AppsWorkordersApiCreateOperationEndpointMutationBody = OperationCreate
    export type AppsWorkordersApiCreateOperationEndpointMutationError = AppsWorkordersApiCreateOperationEndpoint400 | AppsWorkordersApiCreateOperationEndpoint409

    /**
 * @summary Create Operation Endpoint
 */
export const useAppsWorkordersApiCreateOperationEndpoint = <TError = AppsWorkordersApiCreateOperationEndpoint400 | AppsWorkordersApiCreateOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>, TError,{data: OperationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateOperationEndpoint>>,
        TError,
        {data: OperationCreate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateOperationEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update Operation Endpoint
 */
export type appsWorkordersApiUpdateOperationEndpointResponse200 = {
  data: OperationOut
  status: 200
}

export type appsWorkordersApiUpdateOperationEndpointResponse400 = {
  data: AppsWorkordersApiUpdateOperationEndpoint400
  status: 400
}

export type appsWorkordersApiUpdateOperationEndpointResponse409 = {
  data: AppsWorkordersApiUpdateOperationEndpoint409
  status: 409
}

export type appsWorkordersApiUpdateOperationEndpointResponseSuccess = (appsWorkordersApiUpdateOperationEndpointResponse200) & {
  headers: Headers;
};
export type appsWorkordersApiUpdateOperationEndpointResponseError = (appsWorkordersApiUpdateOperationEndpointResponse400 | appsWorkordersApiUpdateOperationEndpointResponse409) & {
  headers: Headers;
};

export type appsWorkordersApiUpdateOperationEndpointResponse = (appsWorkordersApiUpdateOperationEndpointResponseSuccess | appsWorkordersApiUpdateOperationEndpointResponseError)

export const getAppsWorkordersApiUpdateOperationEndpointUrl = (operationId: number,) => {




  return `/api/operations/${operationId}`
}

export const appsWorkordersApiUpdateOperationEndpoint = async (operationId: number,
    operationUpdate: OperationUpdate, options?: RequestInit): Promise<appsWorkordersApiUpdateOperationEndpointResponse> => {

  return customFetch<appsWorkordersApiUpdateOperationEndpointResponse>(getAppsWorkordersApiUpdateOperationEndpointUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationUpdate,)
  }
);}




export const getAppsWorkordersApiUpdateOperationEndpointMutationOptions = <TError = AppsWorkordersApiUpdateOperationEndpoint400 | AppsWorkordersApiUpdateOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>, TError,{operationId: number;data: OperationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>, TError,{operationId: number;data: OperationUpdate}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateOperationEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>, {operationId: number;data: OperationUpdate}> = (props) => {
          const {operationId,data} = props ?? {};

          return  appsWorkordersApiUpdateOperationEndpoint(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateOperationEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>>
    export type AppsWorkordersApiUpdateOperationEndpointMutationBody = OperationUpdate
    export type AppsWorkordersApiUpdateOperationEndpointMutationError = AppsWorkordersApiUpdateOperationEndpoint400 | AppsWorkordersApiUpdateOperationEndpoint409

    /**
 * @summary Update Operation Endpoint
 */
export const useAppsWorkordersApiUpdateOperationEndpoint = <TError = AppsWorkordersApiUpdateOperationEndpoint400 | AppsWorkordersApiUpdateOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>, TError,{operationId: number;data: OperationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateOperationEndpoint>>,
        TError,
        {operationId: number;data: OperationUpdate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateOperationEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Operation Endpoint
 */
export type appsWorkordersApiDeleteOperationEndpointResponse204 = {
  data: void
  status: 204
}

export type appsWorkordersApiDeleteOperationEndpointResponse409 = {
  data: AppsWorkordersApiDeleteOperationEndpoint409
  status: 409
}

export type appsWorkordersApiDeleteOperationEndpointResponseSuccess = (appsWorkordersApiDeleteOperationEndpointResponse204) & {
  headers: Headers;
};
export type appsWorkordersApiDeleteOperationEndpointResponseError = (appsWorkordersApiDeleteOperationEndpointResponse409) & {
  headers: Headers;
};

export type appsWorkordersApiDeleteOperationEndpointResponse = (appsWorkordersApiDeleteOperationEndpointResponseSuccess | appsWorkordersApiDeleteOperationEndpointResponseError)

export const getAppsWorkordersApiDeleteOperationEndpointUrl = (operationId: number,) => {




  return `/api/operations/${operationId}`
}

export const appsWorkordersApiDeleteOperationEndpoint = async (operationId: number, options?: RequestInit): Promise<appsWorkordersApiDeleteOperationEndpointResponse> => {

  return customFetch<appsWorkordersApiDeleteOperationEndpointResponse>(getAppsWorkordersApiDeleteOperationEndpointUrl(operationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWorkordersApiDeleteOperationEndpointMutationOptions = <TError = AppsWorkordersApiDeleteOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>, TError,{operationId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>, TError,{operationId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiDeleteOperationEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>, {operationId: number}> = (props) => {
          const {operationId} = props ?? {};

          return  appsWorkordersApiDeleteOperationEndpoint(operationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiDeleteOperationEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>>

    export type AppsWorkordersApiDeleteOperationEndpointMutationError = AppsWorkordersApiDeleteOperationEndpoint409

    /**
 * @summary Delete Operation Endpoint
 */
export const useAppsWorkordersApiDeleteOperationEndpoint = <TError = AppsWorkordersApiDeleteOperationEndpoint409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>, TError,{operationId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiDeleteOperationEndpoint>>,
        TError,
        {operationId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiDeleteOperationEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Task Lines
 */
export type appsWorkordersApiListTaskLinesResponse200 = {
  data: TaskLineOut[]
  status: 200
}

export type appsWorkordersApiListTaskLinesResponseSuccess = (appsWorkordersApiListTaskLinesResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListTaskLinesResponse = (appsWorkordersApiListTaskLinesResponseSuccess)

export const getAppsWorkordersApiListTaskLinesUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/task-lines`
}

export const appsWorkordersApiListTaskLines = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListTaskLinesResponse> => {

  return customFetch<appsWorkordersApiListTaskLinesResponse>(getAppsWorkordersApiListTaskLinesUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListTaskLinesQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/task-lines`
    ] as const;
    }


export const getAppsWorkordersApiListTaskLinesQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListTaskLinesQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>> = ({ signal }) => appsWorkordersApiListTaskLines(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListTaskLinesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>>
export type AppsWorkordersApiListTaskLinesQueryError = unknown


export function useAppsWorkordersApiListTaskLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListTaskLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListTaskLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Task Lines
 */

export function useAppsWorkordersApiListTaskLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListTaskLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListTaskLinesQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Task Line
 */
export type appsWorkordersApiCreateTaskLineResponse200 = {
  data: TaskLineOut
  status: 200
}

export type appsWorkordersApiCreateTaskLineResponseSuccess = (appsWorkordersApiCreateTaskLineResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiCreateTaskLineResponse = (appsWorkordersApiCreateTaskLineResponseSuccess)

export const getAppsWorkordersApiCreateTaskLineUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/task-lines`
}

export const appsWorkordersApiCreateTaskLine = async (workOrderId: number,
    taskLineCreate: TaskLineCreate, options?: RequestInit): Promise<appsWorkordersApiCreateTaskLineResponse> => {

  return customFetch<appsWorkordersApiCreateTaskLineResponse>(getAppsWorkordersApiCreateTaskLineUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskLineCreate,)
  }
);}




export const getAppsWorkordersApiCreateTaskLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>, TError,{workOrderId: number;data: TaskLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>, TError,{workOrderId: number;data: TaskLineCreate}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateTaskLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>, {workOrderId: number;data: TaskLineCreate}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiCreateTaskLine(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateTaskLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>>
    export type AppsWorkordersApiCreateTaskLineMutationBody = TaskLineCreate
    export type AppsWorkordersApiCreateTaskLineMutationError = unknown

    /**
 * @summary Create Task Line
 */
export const useAppsWorkordersApiCreateTaskLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>, TError,{workOrderId: number;data: TaskLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateTaskLine>>,
        TError,
        {workOrderId: number;data: TaskLineCreate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateTaskLineMutationOptions(options), queryClient);
    }

/**
 * Заповнити task lines усіма деталями з обраного матеріалу.

Frontend = source-of-truth для preview (deficit-driven qty); endpoint валідує
Part/material приналежність і пропускає Parts, які вже у task_lines цього WO.
Все в одній транзакції (`db_transaction.atomic`); часткові коміти неможливі.
 * @summary Bulk Create Task Lines From Material
 */
export type appsWorkordersApiBulkCreateTaskLinesFromMaterialResponse200 = {
  data: TaskLineBulkFromMaterialOut
  status: 200
}

export type appsWorkordersApiBulkCreateTaskLinesFromMaterialResponseSuccess = (appsWorkordersApiBulkCreateTaskLinesFromMaterialResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiBulkCreateTaskLinesFromMaterialResponse = (appsWorkordersApiBulkCreateTaskLinesFromMaterialResponseSuccess)

export const getAppsWorkordersApiBulkCreateTaskLinesFromMaterialUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/task-lines/bulk-from-material`
}

export const appsWorkordersApiBulkCreateTaskLinesFromMaterial = async (workOrderId: number,
    taskLineBulkFromMaterialIn: TaskLineBulkFromMaterialIn, options?: RequestInit): Promise<appsWorkordersApiBulkCreateTaskLinesFromMaterialResponse> => {

  return customFetch<appsWorkordersApiBulkCreateTaskLinesFromMaterialResponse>(getAppsWorkordersApiBulkCreateTaskLinesFromMaterialUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskLineBulkFromMaterialIn,)
  }
);}




export const getAppsWorkordersApiBulkCreateTaskLinesFromMaterialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>, TError,{workOrderId: number;data: TaskLineBulkFromMaterialIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>, TError,{workOrderId: number;data: TaskLineBulkFromMaterialIn}, TContext> => {

const mutationKey = ['appsWorkordersApiBulkCreateTaskLinesFromMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>, {workOrderId: number;data: TaskLineBulkFromMaterialIn}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiBulkCreateTaskLinesFromMaterial(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiBulkCreateTaskLinesFromMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>>
    export type AppsWorkordersApiBulkCreateTaskLinesFromMaterialMutationBody = TaskLineBulkFromMaterialIn
    export type AppsWorkordersApiBulkCreateTaskLinesFromMaterialMutationError = unknown

    /**
 * @summary Bulk Create Task Lines From Material
 */
export const useAppsWorkordersApiBulkCreateTaskLinesFromMaterial = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>, TError,{workOrderId: number;data: TaskLineBulkFromMaterialIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiBulkCreateTaskLinesFromMaterial>>,
        TError,
        {workOrderId: number;data: TaskLineBulkFromMaterialIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiBulkCreateTaskLinesFromMaterialMutationOptions(options), queryClient);
    }

/**
 * «Заповнити з вузлів» для наряду зварювальника (full-replace).

Перебудовує завдання (по 1 рядку на вузол) + видачу (деталі з BOM,
згруповані по спільних деталях). State/kind guards → 409; payload-проблеми
(вузол не з проєкту, під-вузол у складі, нема операції) → 400.
 * @summary Fill From Assemblies Endpoint
 */
export type appsWorkordersApiFillFromAssembliesEndpointResponse200 = {
  data: FillFromAssembliesOut
  status: 200
}

export type appsWorkordersApiFillFromAssembliesEndpointResponseSuccess = (appsWorkordersApiFillFromAssembliesEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiFillFromAssembliesEndpointResponse = (appsWorkordersApiFillFromAssembliesEndpointResponseSuccess)

export const getAppsWorkordersApiFillFromAssembliesEndpointUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/fill-from-assemblies`
}

export const appsWorkordersApiFillFromAssembliesEndpoint = async (workOrderId: number,
    fillFromAssembliesIn: FillFromAssembliesIn, options?: RequestInit): Promise<appsWorkordersApiFillFromAssembliesEndpointResponse> => {

  return customFetch<appsWorkordersApiFillFromAssembliesEndpointResponse>(getAppsWorkordersApiFillFromAssembliesEndpointUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      fillFromAssembliesIn,)
  }
);}




export const getAppsWorkordersApiFillFromAssembliesEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>, TError,{workOrderId: number;data: FillFromAssembliesIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>, TError,{workOrderId: number;data: FillFromAssembliesIn}, TContext> => {

const mutationKey = ['appsWorkordersApiFillFromAssembliesEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>, {workOrderId: number;data: FillFromAssembliesIn}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiFillFromAssembliesEndpoint(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiFillFromAssembliesEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>>
    export type AppsWorkordersApiFillFromAssembliesEndpointMutationBody = FillFromAssembliesIn
    export type AppsWorkordersApiFillFromAssembliesEndpointMutationError = unknown

    /**
 * @summary Fill From Assemblies Endpoint
 */
export const useAppsWorkordersApiFillFromAssembliesEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>, TError,{workOrderId: number;data: FillFromAssembliesIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiFillFromAssembliesEndpoint>>,
        TError,
        {workOrderId: number;data: FillFromAssembliesIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiFillFromAssembliesEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Update Task Line
 */
export type appsWorkordersApiUpdateTaskLineResponse200 = {
  data: TaskLineOut
  status: 200
}

export type appsWorkordersApiUpdateTaskLineResponseSuccess = (appsWorkordersApiUpdateTaskLineResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateTaskLineResponse = (appsWorkordersApiUpdateTaskLineResponseSuccess)

export const getAppsWorkordersApiUpdateTaskLineUrl = (lineId: number,) => {




  return `/api/task-lines/${lineId}`
}

export const appsWorkordersApiUpdateTaskLine = async (lineId: number,
    taskLineUpdate: TaskLineUpdate, options?: RequestInit): Promise<appsWorkordersApiUpdateTaskLineResponse> => {

  return customFetch<appsWorkordersApiUpdateTaskLineResponse>(getAppsWorkordersApiUpdateTaskLineUrl(lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskLineUpdate,)
  }
);}




export const getAppsWorkordersApiUpdateTaskLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>, TError,{lineId: number;data: TaskLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>, TError,{lineId: number;data: TaskLineUpdate}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateTaskLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>, {lineId: number;data: TaskLineUpdate}> = (props) => {
          const {lineId,data} = props ?? {};

          return  appsWorkordersApiUpdateTaskLine(lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateTaskLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>>
    export type AppsWorkordersApiUpdateTaskLineMutationBody = TaskLineUpdate
    export type AppsWorkordersApiUpdateTaskLineMutationError = unknown

    /**
 * @summary Update Task Line
 */
export const useAppsWorkordersApiUpdateTaskLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>, TError,{lineId: number;data: TaskLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateTaskLine>>,
        TError,
        {lineId: number;data: TaskLineUpdate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateTaskLineMutationOptions(options), queryClient);
    }

/**
 * Видалити task line з DRAFT WO разом з cut-plan rows які на неї посилаються.

Cut plan — це поточна optimizer-proposal у DRAFT-стані; видалення task line
логічно мусить очистити пов'язані cut_plan_lines + placements (інакше
PROTECT FK блокує). Re-optimize створить новий план з решти tasks.
 * @summary Delete Task Line
 */
export type appsWorkordersApiDeleteTaskLineResponse204 = {
  data: void
  status: 204
}

export type appsWorkordersApiDeleteTaskLineResponseSuccess = (appsWorkordersApiDeleteTaskLineResponse204) & {
  headers: Headers;
};
;

export type appsWorkordersApiDeleteTaskLineResponse = (appsWorkordersApiDeleteTaskLineResponseSuccess)

export const getAppsWorkordersApiDeleteTaskLineUrl = (lineId: number,) => {




  return `/api/task-lines/${lineId}`
}

export const appsWorkordersApiDeleteTaskLine = async (lineId: number, options?: RequestInit): Promise<appsWorkordersApiDeleteTaskLineResponse> => {

  return customFetch<appsWorkordersApiDeleteTaskLineResponse>(getAppsWorkordersApiDeleteTaskLineUrl(lineId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWorkordersApiDeleteTaskLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>, TError,{lineId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>, TError,{lineId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiDeleteTaskLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>, {lineId: number}> = (props) => {
          const {lineId} = props ?? {};

          return  appsWorkordersApiDeleteTaskLine(lineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiDeleteTaskLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>>

    export type AppsWorkordersApiDeleteTaskLineMutationError = unknown

    /**
 * @summary Delete Task Line
 */
export const useAppsWorkordersApiDeleteTaskLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>, TError,{lineId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiDeleteTaskLine>>,
        TError,
        {lineId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiDeleteTaskLineMutationOptions(options), queryClient);
    }

/**
 * @summary List Issue Lines
 */
export type appsWorkordersApiListIssueLinesResponse200 = {
  data: IssueLineOut[]
  status: 200
}

export type appsWorkordersApiListIssueLinesResponseSuccess = (appsWorkordersApiListIssueLinesResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListIssueLinesResponse = (appsWorkordersApiListIssueLinesResponseSuccess)

export const getAppsWorkordersApiListIssueLinesUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/issue-lines`
}

export const appsWorkordersApiListIssueLines = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListIssueLinesResponse> => {

  return customFetch<appsWorkordersApiListIssueLinesResponse>(getAppsWorkordersApiListIssueLinesUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListIssueLinesQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/issue-lines`
    ] as const;
    }


export const getAppsWorkordersApiListIssueLinesQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListIssueLinesQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>> = ({ signal }) => appsWorkordersApiListIssueLines(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListIssueLinesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>>
export type AppsWorkordersApiListIssueLinesQueryError = unknown


export function useAppsWorkordersApiListIssueLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListIssueLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListIssueLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Issue Lines
 */

export function useAppsWorkordersApiListIssueLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListIssueLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListIssueLinesQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * State-aware PATCH:

- DRAFT WO: edit `quantity`, `notes`.
- POSTED WO: edit `actual_quantity` (+ required `reason` → audit history).
 * @summary Update Issue Line
 */
export type appsWorkordersApiUpdateIssueLineResponse200 = {
  data: IssueLineOut
  status: 200
}

export type appsWorkordersApiUpdateIssueLineResponseSuccess = (appsWorkordersApiUpdateIssueLineResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateIssueLineResponse = (appsWorkordersApiUpdateIssueLineResponseSuccess)

export const getAppsWorkordersApiUpdateIssueLineUrl = (lineId: number,) => {




  return `/api/issue-lines/${lineId}`
}

export const appsWorkordersApiUpdateIssueLine = async (lineId: number,
    issueLineUpdate: IssueLineUpdate, options?: RequestInit): Promise<appsWorkordersApiUpdateIssueLineResponse> => {

  return customFetch<appsWorkordersApiUpdateIssueLineResponse>(getAppsWorkordersApiUpdateIssueLineUrl(lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      issueLineUpdate,)
  }
);}




export const getAppsWorkordersApiUpdateIssueLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>, TError,{lineId: number;data: IssueLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>, TError,{lineId: number;data: IssueLineUpdate}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateIssueLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>, {lineId: number;data: IssueLineUpdate}> = (props) => {
          const {lineId,data} = props ?? {};

          return  appsWorkordersApiUpdateIssueLine(lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateIssueLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>>
    export type AppsWorkordersApiUpdateIssueLineMutationBody = IssueLineUpdate
    export type AppsWorkordersApiUpdateIssueLineMutationError = unknown

    /**
 * @summary Update Issue Line
 */
export const useAppsWorkordersApiUpdateIssueLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>, TError,{lineId: number;data: IssueLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateIssueLine>>,
        TError,
        {lineId: number;data: IssueLineUpdate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateIssueLineMutationOptions(options), queryClient);
    }

/**
 * @summary List Output Lines
 */
export type appsWorkordersApiListOutputLinesResponse200 = {
  data: OutputLineOut[]
  status: 200
}

export type appsWorkordersApiListOutputLinesResponseSuccess = (appsWorkordersApiListOutputLinesResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListOutputLinesResponse = (appsWorkordersApiListOutputLinesResponseSuccess)

export const getAppsWorkordersApiListOutputLinesUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/output-lines`
}

export const appsWorkordersApiListOutputLines = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListOutputLinesResponse> => {

  return customFetch<appsWorkordersApiListOutputLinesResponse>(getAppsWorkordersApiListOutputLinesUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListOutputLinesQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/output-lines`
    ] as const;
    }


export const getAppsWorkordersApiListOutputLinesQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListOutputLinesQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>> = ({ signal }) => appsWorkordersApiListOutputLines(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListOutputLinesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>>
export type AppsWorkordersApiListOutputLinesQueryError = unknown


export function useAppsWorkordersApiListOutputLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListOutputLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListOutputLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Output Lines
 */

export function useAppsWorkordersApiListOutputLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListOutputLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListOutputLinesQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Output Line
 */
export type appsWorkordersApiCreateOutputLineResponse200 = {
  data: OutputLineOut
  status: 200
}

export type appsWorkordersApiCreateOutputLineResponseSuccess = (appsWorkordersApiCreateOutputLineResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiCreateOutputLineResponse = (appsWorkordersApiCreateOutputLineResponseSuccess)

export const getAppsWorkordersApiCreateOutputLineUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/output-lines`
}

export const appsWorkordersApiCreateOutputLine = async (workOrderId: number,
    outputLineCreate: OutputLineCreate, options?: RequestInit): Promise<appsWorkordersApiCreateOutputLineResponse> => {

  return customFetch<appsWorkordersApiCreateOutputLineResponse>(getAppsWorkordersApiCreateOutputLineUrl(workOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outputLineCreate,)
  }
);}




export const getAppsWorkordersApiCreateOutputLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>, TError,{workOrderId: number;data: OutputLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>, TError,{workOrderId: number;data: OutputLineCreate}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateOutputLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>, {workOrderId: number;data: OutputLineCreate}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  appsWorkordersApiCreateOutputLine(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateOutputLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>>
    export type AppsWorkordersApiCreateOutputLineMutationBody = OutputLineCreate
    export type AppsWorkordersApiCreateOutputLineMutationError = unknown

    /**
 * @summary Create Output Line
 */
export const useAppsWorkordersApiCreateOutputLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>, TError,{workOrderId: number;data: OutputLineCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateOutputLine>>,
        TError,
        {workOrderId: number;data: OutputLineCreate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateOutputLineMutationOptions(options), queryClient);
    }

/**
 * State-aware PATCH:

- DRAFT WO: edit plan fields (part_id/assembly_id/storekeeper_id/quantity/notes).
- POSTED WO: edit `actual_quantity` (+ required `reason` → audit history).
 * @summary Update Output Line
 */
export type appsWorkordersApiUpdateOutputLineResponse200 = {
  data: OutputLineOut
  status: 200
}

export type appsWorkordersApiUpdateOutputLineResponseSuccess = (appsWorkordersApiUpdateOutputLineResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateOutputLineResponse = (appsWorkordersApiUpdateOutputLineResponseSuccess)

export const getAppsWorkordersApiUpdateOutputLineUrl = (lineId: number,) => {




  return `/api/output-lines/${lineId}`
}

export const appsWorkordersApiUpdateOutputLine = async (lineId: number,
    outputLineUpdate: OutputLineUpdate, options?: RequestInit): Promise<appsWorkordersApiUpdateOutputLineResponse> => {

  return customFetch<appsWorkordersApiUpdateOutputLineResponse>(getAppsWorkordersApiUpdateOutputLineUrl(lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outputLineUpdate,)
  }
);}




export const getAppsWorkordersApiUpdateOutputLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>, TError,{lineId: number;data: OutputLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>, TError,{lineId: number;data: OutputLineUpdate}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateOutputLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>, {lineId: number;data: OutputLineUpdate}> = (props) => {
          const {lineId,data} = props ?? {};

          return  appsWorkordersApiUpdateOutputLine(lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateOutputLineMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>>
    export type AppsWorkordersApiUpdateOutputLineMutationBody = OutputLineUpdate
    export type AppsWorkordersApiUpdateOutputLineMutationError = unknown

    /**
 * @summary Update Output Line
 */
export const useAppsWorkordersApiUpdateOutputLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>, TError,{lineId: number;data: OutputLineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateOutputLine>>,
        TError,
        {lineId: number;data: OutputLineUpdate},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateOutputLineMutationOptions(options), queryClient);
    }

/**
 * @summary List Cut Plan Lines
 */
export type appsWorkordersApiListCutPlanLinesResponse200 = {
  data: CutPlanLineOut[]
  status: 200
}

export type appsWorkordersApiListCutPlanLinesResponseSuccess = (appsWorkordersApiListCutPlanLinesResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListCutPlanLinesResponse = (appsWorkordersApiListCutPlanLinesResponseSuccess)

export const getAppsWorkordersApiListCutPlanLinesUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/cut-plan-lines`
}

export const appsWorkordersApiListCutPlanLines = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListCutPlanLinesResponse> => {

  return customFetch<appsWorkordersApiListCutPlanLinesResponse>(getAppsWorkordersApiListCutPlanLinesUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListCutPlanLinesQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/cut-plan-lines`
    ] as const;
    }


export const getAppsWorkordersApiListCutPlanLinesQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListCutPlanLinesQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>> = ({ signal }) => appsWorkordersApiListCutPlanLines(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListCutPlanLinesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>>
export type AppsWorkordersApiListCutPlanLinesQueryError = unknown


export function useAppsWorkordersApiListCutPlanLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Cut Plan Lines
 */

export function useAppsWorkordersApiListCutPlanLines<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanLines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListCutPlanLinesQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Усі розміщення плану розкрою наряду одним запитом (замість запиту на рядок).
 * @summary List Work Order Cut Plan Placements
 */
export type appsWorkordersApiListWorkOrderCutPlanPlacementsResponse200 = {
  data: CutPlanPlacementOut[]
  status: 200
}

export type appsWorkordersApiListWorkOrderCutPlanPlacementsResponseSuccess = (appsWorkordersApiListWorkOrderCutPlanPlacementsResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListWorkOrderCutPlanPlacementsResponse = (appsWorkordersApiListWorkOrderCutPlanPlacementsResponseSuccess)

export const getAppsWorkordersApiListWorkOrderCutPlanPlacementsUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}/cut-plan-placements`
}

export const appsWorkordersApiListWorkOrderCutPlanPlacements = async (workOrderId: number, options?: RequestInit): Promise<appsWorkordersApiListWorkOrderCutPlanPlacementsResponse> => {

  return customFetch<appsWorkordersApiListWorkOrderCutPlanPlacementsResponse>(getAppsWorkordersApiListWorkOrderCutPlanPlacementsUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListWorkOrderCutPlanPlacementsQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}/cut-plan-placements`
    ] as const;
    }


export const getAppsWorkordersApiListWorkOrderCutPlanPlacementsQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError = unknown>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListWorkOrderCutPlanPlacementsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>> = ({ signal }) => appsWorkordersApiListWorkOrderCutPlanPlacements(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListWorkOrderCutPlanPlacementsQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>>
export type AppsWorkordersApiListWorkOrderCutPlanPlacementsQueryError = unknown


export function useAppsWorkordersApiListWorkOrderCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError = unknown>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListWorkOrderCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListWorkOrderCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Work Order Cut Plan Placements
 */

export function useAppsWorkordersApiListWorkOrderCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError = unknown>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListWorkOrderCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListWorkOrderCutPlanPlacementsQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Cut Plan Placements
 */
export type appsWorkordersApiListCutPlanPlacementsResponse200 = {
  data: CutPlanPlacementOut[]
  status: 200
}

export type appsWorkordersApiListCutPlanPlacementsResponseSuccess = (appsWorkordersApiListCutPlanPlacementsResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListCutPlanPlacementsResponse = (appsWorkordersApiListCutPlanPlacementsResponseSuccess)

export const getAppsWorkordersApiListCutPlanPlacementsUrl = (cutPlanLineId: number,) => {




  return `/api/cut-plan-lines/${cutPlanLineId}/placements`
}

export const appsWorkordersApiListCutPlanPlacements = async (cutPlanLineId: number, options?: RequestInit): Promise<appsWorkordersApiListCutPlanPlacementsResponse> => {

  return customFetch<appsWorkordersApiListCutPlanPlacementsResponse>(getAppsWorkordersApiListCutPlanPlacementsUrl(cutPlanLineId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListCutPlanPlacementsQueryKey = (cutPlanLineId: number,) => {
    return [
    `/api/cut-plan-lines/${cutPlanLineId}/placements`
    ] as const;
    }


export const getAppsWorkordersApiListCutPlanPlacementsQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError = unknown>(cutPlanLineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListCutPlanPlacementsQueryKey(cutPlanLineId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>> = ({ signal }) => appsWorkordersApiListCutPlanPlacements(cutPlanLineId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cutPlanLineId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListCutPlanPlacementsQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>>
export type AppsWorkordersApiListCutPlanPlacementsQueryError = unknown


export function useAppsWorkordersApiListCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError = unknown>(
 cutPlanLineId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError = unknown>(
 cutPlanLineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError = unknown>(
 cutPlanLineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Cut Plan Placements
 */

export function useAppsWorkordersApiListCutPlanPlacements<TData = Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError = unknown>(
 cutPlanLineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListCutPlanPlacements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListCutPlanPlacementsQueryOptions(cutPlanLineId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Cross-WO MaterialIssueNote list for the global «Видачі в цех» entry (ADR-0005).

`project_id` фільтр використовує прямий FK документа — у вибірку
потрапляють MIN зі standalone-flow (без `work_order`, але з `project`).
 * @summary List Material Issues Global
 */
export type appsWorkordersApiListMaterialIssuesGlobalResponse200 = {
  data: MaterialIssueOut[]
  status: 200
}

export type appsWorkordersApiListMaterialIssuesGlobalResponseSuccess = (appsWorkordersApiListMaterialIssuesGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListMaterialIssuesGlobalResponse = (appsWorkordersApiListMaterialIssuesGlobalResponseSuccess)

export const getAppsWorkordersApiListMaterialIssuesGlobalUrl = (params?: AppsWorkordersApiListMaterialIssuesGlobalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/material-issues?${stringifiedParams}` : `/api/material-issues`
}

export const appsWorkordersApiListMaterialIssuesGlobal = async (params?: AppsWorkordersApiListMaterialIssuesGlobalParams, options?: RequestInit): Promise<appsWorkordersApiListMaterialIssuesGlobalResponse> => {

  return customFetch<appsWorkordersApiListMaterialIssuesGlobalResponse>(getAppsWorkordersApiListMaterialIssuesGlobalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListMaterialIssuesGlobalQueryKey = (params?: AppsWorkordersApiListMaterialIssuesGlobalParams,) => {
    return [
    `/api/material-issues`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWorkordersApiListMaterialIssuesGlobalQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError = unknown>(params?: AppsWorkordersApiListMaterialIssuesGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListMaterialIssuesGlobalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>> = ({ signal }) => appsWorkordersApiListMaterialIssuesGlobal(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListMaterialIssuesGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>>
export type AppsWorkordersApiListMaterialIssuesGlobalQueryError = unknown


export function useAppsWorkordersApiListMaterialIssuesGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError = unknown>(
 params: undefined |  AppsWorkordersApiListMaterialIssuesGlobalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListMaterialIssuesGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListMaterialIssuesGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListMaterialIssuesGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListMaterialIssuesGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Material Issues Global
 */

export function useAppsWorkordersApiListMaterialIssuesGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListMaterialIssuesGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListMaterialIssuesGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListMaterialIssuesGlobalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Створює MIN draft. Без body — пустий draft (legacy). З `work_order_id`
+ `autofill_from_wo=True` — лінії автозаповнюються з WO.issue_lines мінус
вже видане.
 * @summary Create Material Issue Empty Draft
 */
export type appsWorkordersApiCreateMaterialIssueEmptyDraftResponse201 = {
  data: MaterialIssueOut
  status: 201
}

export type appsWorkordersApiCreateMaterialIssueEmptyDraftResponseSuccess = (appsWorkordersApiCreateMaterialIssueEmptyDraftResponse201) & {
  headers: Headers;
};
;

export type appsWorkordersApiCreateMaterialIssueEmptyDraftResponse = (appsWorkordersApiCreateMaterialIssueEmptyDraftResponseSuccess)

export const getAppsWorkordersApiCreateMaterialIssueEmptyDraftUrl = () => {




  return `/api/material-issues/drafts/`
}

export const appsWorkordersApiCreateMaterialIssueEmptyDraft = async (materialIssueDraftCreateInNull?: MaterialIssueDraftCreateIn | null, options?: RequestInit): Promise<appsWorkordersApiCreateMaterialIssueEmptyDraftResponse> => {

  return customFetch<appsWorkordersApiCreateMaterialIssueEmptyDraftResponse>(getAppsWorkordersApiCreateMaterialIssueEmptyDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialIssueDraftCreateInNull,)
  }
);}




export const getAppsWorkordersApiCreateMaterialIssueEmptyDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>, TError,{data?: MaterialIssueDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>, TError,{data?: MaterialIssueDraftCreateIn | null}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateMaterialIssueEmptyDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>, {data?: MaterialIssueDraftCreateIn | null}> = (props) => {
          const {data} = props ?? {};

          return  appsWorkordersApiCreateMaterialIssueEmptyDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateMaterialIssueEmptyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>>
    export type AppsWorkordersApiCreateMaterialIssueEmptyDraftMutationBody = MaterialIssueDraftCreateIn | null | undefined
    export type AppsWorkordersApiCreateMaterialIssueEmptyDraftMutationError = unknown

    /**
 * @summary Create Material Issue Empty Draft
 */
export const useAppsWorkordersApiCreateMaterialIssueEmptyDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>, TError,{data?: MaterialIssueDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateMaterialIssueEmptyDraft>>,
        TError,
        {data?: MaterialIssueDraftCreateIn | null},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateMaterialIssueEmptyDraftMutationOptions(options), queryClient);
    }

/**
 * Cross-WO PATCH — приймає project_id / work_order_id / recipient_id /
storekeeper_id / issue_date / notes / lines patches. Sentinel-семантика:
ключ не у payload (`__fields_set__`) → не чіпати; явний `null` → очистити FK.
 * @summary Update Material Issue Global
 */
export type appsWorkordersApiUpdateMaterialIssueGlobalResponse200 = {
  data: MaterialIssueOut
  status: 200
}

export type appsWorkordersApiUpdateMaterialIssueGlobalResponseSuccess = (appsWorkordersApiUpdateMaterialIssueGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateMaterialIssueGlobalResponse = (appsWorkordersApiUpdateMaterialIssueGlobalResponseSuccess)

export const getAppsWorkordersApiUpdateMaterialIssueGlobalUrl = (materialIssueId: number,) => {




  return `/api/material-issues/${materialIssueId}/`
}

export const appsWorkordersApiUpdateMaterialIssueGlobal = async (materialIssueId: number,
    materialIssueUpdateIn: MaterialIssueUpdateIn, options?: RequestInit): Promise<appsWorkordersApiUpdateMaterialIssueGlobalResponse> => {

  return customFetch<appsWorkordersApiUpdateMaterialIssueGlobalResponse>(getAppsWorkordersApiUpdateMaterialIssueGlobalUrl(materialIssueId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialIssueUpdateIn,)
  }
);}




export const getAppsWorkordersApiUpdateMaterialIssueGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>, TError,{materialIssueId: number;data: MaterialIssueUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>, TError,{materialIssueId: number;data: MaterialIssueUpdateIn}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateMaterialIssueGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>, {materialIssueId: number;data: MaterialIssueUpdateIn}> = (props) => {
          const {materialIssueId,data} = props ?? {};

          return  appsWorkordersApiUpdateMaterialIssueGlobal(materialIssueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateMaterialIssueGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>>
    export type AppsWorkordersApiUpdateMaterialIssueGlobalMutationBody = MaterialIssueUpdateIn
    export type AppsWorkordersApiUpdateMaterialIssueGlobalMutationError = unknown

    /**
 * @summary Update Material Issue Global
 */
export const useAppsWorkordersApiUpdateMaterialIssueGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>, TError,{materialIssueId: number;data: MaterialIssueUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateMaterialIssueGlobal>>,
        TError,
        {materialIssueId: number;data: MaterialIssueUpdateIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateMaterialIssueGlobalMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Material Issue Global
 */
export type appsWorkordersApiDeleteMaterialIssueGlobalResponse204 = {
  data: void
  status: 204
}

export type appsWorkordersApiDeleteMaterialIssueGlobalResponseSuccess = (appsWorkordersApiDeleteMaterialIssueGlobalResponse204) & {
  headers: Headers;
};
;

export type appsWorkordersApiDeleteMaterialIssueGlobalResponse = (appsWorkordersApiDeleteMaterialIssueGlobalResponseSuccess)

export const getAppsWorkordersApiDeleteMaterialIssueGlobalUrl = (materialIssueId: number,) => {




  return `/api/material-issues/${materialIssueId}/`
}

export const appsWorkordersApiDeleteMaterialIssueGlobal = async (materialIssueId: number, options?: RequestInit): Promise<appsWorkordersApiDeleteMaterialIssueGlobalResponse> => {

  return customFetch<appsWorkordersApiDeleteMaterialIssueGlobalResponse>(getAppsWorkordersApiDeleteMaterialIssueGlobalUrl(materialIssueId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWorkordersApiDeleteMaterialIssueGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiDeleteMaterialIssueGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>, {materialIssueId: number}> = (props) => {
          const {materialIssueId} = props ?? {};

          return  appsWorkordersApiDeleteMaterialIssueGlobal(materialIssueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiDeleteMaterialIssueGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>>

    export type AppsWorkordersApiDeleteMaterialIssueGlobalMutationError = unknown

    /**
 * @summary Delete Material Issue Global
 */
export const useAppsWorkordersApiDeleteMaterialIssueGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiDeleteMaterialIssueGlobal>>,
        TError,
        {materialIssueId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiDeleteMaterialIssueGlobalMutationOptions(options), queryClient);
    }

/**
 * Cross-WO MaterialIssueNote getter — powers the standalone
`/material-issues/{id}` editor (Phase 13 / ADR-0003 Iter 2 frontend).

Must be registered AFTER the static drafts/post/unpost/ paths so
Django-Ninja URL resolution matches them correctly.
 * @summary Get Material Issue Global
 */
export type appsWorkordersApiGetMaterialIssueGlobalResponse200 = {
  data: MaterialIssueOut
  status: 200
}

export type appsWorkordersApiGetMaterialIssueGlobalResponseSuccess = (appsWorkordersApiGetMaterialIssueGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiGetMaterialIssueGlobalResponse = (appsWorkordersApiGetMaterialIssueGlobalResponseSuccess)

export const getAppsWorkordersApiGetMaterialIssueGlobalUrl = (materialIssueId: number,) => {




  return `/api/material-issues/${materialIssueId}/`
}

export const appsWorkordersApiGetMaterialIssueGlobal = async (materialIssueId: number, options?: RequestInit): Promise<appsWorkordersApiGetMaterialIssueGlobalResponse> => {

  return customFetch<appsWorkordersApiGetMaterialIssueGlobalResponse>(getAppsWorkordersApiGetMaterialIssueGlobalUrl(materialIssueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiGetMaterialIssueGlobalQueryKey = (materialIssueId: number,) => {
    return [
    `/api/material-issues/${materialIssueId}/`
    ] as const;
    }


export const getAppsWorkordersApiGetMaterialIssueGlobalQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError = unknown>(materialIssueId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiGetMaterialIssueGlobalQueryKey(materialIssueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>> = ({ signal }) => appsWorkordersApiGetMaterialIssueGlobal(materialIssueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(materialIssueId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiGetMaterialIssueGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>>
export type AppsWorkordersApiGetMaterialIssueGlobalQueryError = unknown


export function useAppsWorkordersApiGetMaterialIssueGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError = unknown>(
 materialIssueId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetMaterialIssueGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError = unknown>(
 materialIssueId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetMaterialIssueGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError = unknown>(
 materialIssueId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Material Issue Global
 */

export function useAppsWorkordersApiGetMaterialIssueGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError = unknown>(
 materialIssueId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetMaterialIssueGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiGetMaterialIssueGlobalQueryOptions(materialIssueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Post Material Issue Global
 */
export type appsWorkordersApiPostMaterialIssueGlobalResponse200 = {
  data: MaterialIssueOut
  status: 200
}

export type appsWorkordersApiPostMaterialIssueGlobalResponse400 = {
  data: AppsWorkordersApiPostMaterialIssueGlobal400
  status: 400
}

export type appsWorkordersApiPostMaterialIssueGlobalResponseSuccess = (appsWorkordersApiPostMaterialIssueGlobalResponse200) & {
  headers: Headers;
};
export type appsWorkordersApiPostMaterialIssueGlobalResponseError = (appsWorkordersApiPostMaterialIssueGlobalResponse400) & {
  headers: Headers;
};

export type appsWorkordersApiPostMaterialIssueGlobalResponse = (appsWorkordersApiPostMaterialIssueGlobalResponseSuccess | appsWorkordersApiPostMaterialIssueGlobalResponseError)

export const getAppsWorkordersApiPostMaterialIssueGlobalUrl = (materialIssueId: number,) => {




  return `/api/material-issues/${materialIssueId}/post/`
}

export const appsWorkordersApiPostMaterialIssueGlobal = async (materialIssueId: number, options?: RequestInit): Promise<appsWorkordersApiPostMaterialIssueGlobalResponse> => {

  return customFetch<appsWorkordersApiPostMaterialIssueGlobalResponse>(getAppsWorkordersApiPostMaterialIssueGlobalUrl(materialIssueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWorkordersApiPostMaterialIssueGlobalMutationOptions = <TError = AppsWorkordersApiPostMaterialIssueGlobal400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiPostMaterialIssueGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>, {materialIssueId: number}> = (props) => {
          const {materialIssueId} = props ?? {};

          return  appsWorkordersApiPostMaterialIssueGlobal(materialIssueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiPostMaterialIssueGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>>

    export type AppsWorkordersApiPostMaterialIssueGlobalMutationError = AppsWorkordersApiPostMaterialIssueGlobal400

    /**
 * @summary Post Material Issue Global
 */
export const useAppsWorkordersApiPostMaterialIssueGlobal = <TError = AppsWorkordersApiPostMaterialIssueGlobal400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiPostMaterialIssueGlobal>>,
        TError,
        {materialIssueId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiPostMaterialIssueGlobalMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Material Issue Global
 */
export type appsWorkordersApiUnpostMaterialIssueGlobalResponse200 = {
  data: MaterialIssueOut
  status: 200
}

export type appsWorkordersApiUnpostMaterialIssueGlobalResponseSuccess = (appsWorkordersApiUnpostMaterialIssueGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUnpostMaterialIssueGlobalResponse = (appsWorkordersApiUnpostMaterialIssueGlobalResponseSuccess)

export const getAppsWorkordersApiUnpostMaterialIssueGlobalUrl = (materialIssueId: number,) => {




  return `/api/material-issues/${materialIssueId}/unpost/`
}

export const appsWorkordersApiUnpostMaterialIssueGlobal = async (materialIssueId: number, options?: RequestInit): Promise<appsWorkordersApiUnpostMaterialIssueGlobalResponse> => {

  return customFetch<appsWorkordersApiUnpostMaterialIssueGlobalResponse>(getAppsWorkordersApiUnpostMaterialIssueGlobalUrl(materialIssueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWorkordersApiUnpostMaterialIssueGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiUnpostMaterialIssueGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>, {materialIssueId: number}> = (props) => {
          const {materialIssueId} = props ?? {};

          return  appsWorkordersApiUnpostMaterialIssueGlobal(materialIssueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUnpostMaterialIssueGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>>

    export type AppsWorkordersApiUnpostMaterialIssueGlobalMutationError = unknown

    /**
 * @summary Unpost Material Issue Global
 */
export const useAppsWorkordersApiUnpostMaterialIssueGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>, TError,{materialIssueId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUnpostMaterialIssueGlobal>>,
        TError,
        {materialIssueId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUnpostMaterialIssueGlobalMutationOptions(options), queryClient);
    }

/**
 * Cross-WO ProductionReport list for the global «Звіти працівників» entry (ADR-0005).

`project_id` фільтр — прямий FK документа: PRs без WO але з project_id
потрапляють у вибірку.
 * @summary List Production Reports Global
 */
export type appsWorkordersApiListProductionReportsGlobalResponse200 = {
  data: ProductionReportOut[]
  status: 200
}

export type appsWorkordersApiListProductionReportsGlobalResponseSuccess = (appsWorkordersApiListProductionReportsGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiListProductionReportsGlobalResponse = (appsWorkordersApiListProductionReportsGlobalResponseSuccess)

export const getAppsWorkordersApiListProductionReportsGlobalUrl = (params?: AppsWorkordersApiListProductionReportsGlobalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/production-reports?${stringifiedParams}` : `/api/production-reports`
}

export const appsWorkordersApiListProductionReportsGlobal = async (params?: AppsWorkordersApiListProductionReportsGlobalParams, options?: RequestInit): Promise<appsWorkordersApiListProductionReportsGlobalResponse> => {

  return customFetch<appsWorkordersApiListProductionReportsGlobalResponse>(getAppsWorkordersApiListProductionReportsGlobalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiListProductionReportsGlobalQueryKey = (params?: AppsWorkordersApiListProductionReportsGlobalParams,) => {
    return [
    `/api/production-reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWorkordersApiListProductionReportsGlobalQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError = unknown>(params?: AppsWorkordersApiListProductionReportsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiListProductionReportsGlobalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>> = ({ signal }) => appsWorkordersApiListProductionReportsGlobal(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiListProductionReportsGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>>
export type AppsWorkordersApiListProductionReportsGlobalQueryError = unknown


export function useAppsWorkordersApiListProductionReportsGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError = unknown>(
 params: undefined |  AppsWorkordersApiListProductionReportsGlobalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListProductionReportsGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListProductionReportsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiListProductionReportsGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListProductionReportsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Production Reports Global
 */

export function useAppsWorkordersApiListProductionReportsGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError = unknown>(
 params?: AppsWorkordersApiListProductionReportsGlobalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiListProductionReportsGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiListProductionReportsGlobalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Створює PR draft. Без body — пустий (legacy). З `work_order_id` +
`autofill_from_wo=True` — рядки автозаповнюються per task_line, qty=0.
 * @summary Create Production Report Empty Draft
 */
export type appsWorkordersApiCreateProductionReportEmptyDraftResponse201 = {
  data: ProductionReportOut
  status: 201
}

export type appsWorkordersApiCreateProductionReportEmptyDraftResponseSuccess = (appsWorkordersApiCreateProductionReportEmptyDraftResponse201) & {
  headers: Headers;
};
;

export type appsWorkordersApiCreateProductionReportEmptyDraftResponse = (appsWorkordersApiCreateProductionReportEmptyDraftResponseSuccess)

export const getAppsWorkordersApiCreateProductionReportEmptyDraftUrl = () => {




  return `/api/production-reports/drafts/`
}

export const appsWorkordersApiCreateProductionReportEmptyDraft = async (productionReportDraftCreateInNull?: ProductionReportDraftCreateIn | null, options?: RequestInit): Promise<appsWorkordersApiCreateProductionReportEmptyDraftResponse> => {

  return customFetch<appsWorkordersApiCreateProductionReportEmptyDraftResponse>(getAppsWorkordersApiCreateProductionReportEmptyDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productionReportDraftCreateInNull,)
  }
);}




export const getAppsWorkordersApiCreateProductionReportEmptyDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>, TError,{data?: ProductionReportDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>, TError,{data?: ProductionReportDraftCreateIn | null}, TContext> => {

const mutationKey = ['appsWorkordersApiCreateProductionReportEmptyDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>, {data?: ProductionReportDraftCreateIn | null}> = (props) => {
          const {data} = props ?? {};

          return  appsWorkordersApiCreateProductionReportEmptyDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiCreateProductionReportEmptyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>>
    export type AppsWorkordersApiCreateProductionReportEmptyDraftMutationBody = ProductionReportDraftCreateIn | null | undefined
    export type AppsWorkordersApiCreateProductionReportEmptyDraftMutationError = unknown

    /**
 * @summary Create Production Report Empty Draft
 */
export const useAppsWorkordersApiCreateProductionReportEmptyDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>, TError,{data?: ProductionReportDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiCreateProductionReportEmptyDraft>>,
        TError,
        {data?: ProductionReportDraftCreateIn | null},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiCreateProductionReportEmptyDraftMutationOptions(options), queryClient);
    }

/**
 * @summary Update Production Report Global
 */
export type appsWorkordersApiUpdateProductionReportGlobalResponse200 = {
  data: ProductionReportOut
  status: 200
}

export type appsWorkordersApiUpdateProductionReportGlobalResponseSuccess = (appsWorkordersApiUpdateProductionReportGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUpdateProductionReportGlobalResponse = (appsWorkordersApiUpdateProductionReportGlobalResponseSuccess)

export const getAppsWorkordersApiUpdateProductionReportGlobalUrl = (productionReportId: number,) => {




  return `/api/production-reports/${productionReportId}/`
}

export const appsWorkordersApiUpdateProductionReportGlobal = async (productionReportId: number,
    productionReportUpdateIn: ProductionReportUpdateIn, options?: RequestInit): Promise<appsWorkordersApiUpdateProductionReportGlobalResponse> => {

  return customFetch<appsWorkordersApiUpdateProductionReportGlobalResponse>(getAppsWorkordersApiUpdateProductionReportGlobalUrl(productionReportId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productionReportUpdateIn,)
  }
);}




export const getAppsWorkordersApiUpdateProductionReportGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>, TError,{productionReportId: number;data: ProductionReportUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>, TError,{productionReportId: number;data: ProductionReportUpdateIn}, TContext> => {

const mutationKey = ['appsWorkordersApiUpdateProductionReportGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>, {productionReportId: number;data: ProductionReportUpdateIn}> = (props) => {
          const {productionReportId,data} = props ?? {};

          return  appsWorkordersApiUpdateProductionReportGlobal(productionReportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUpdateProductionReportGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>>
    export type AppsWorkordersApiUpdateProductionReportGlobalMutationBody = ProductionReportUpdateIn
    export type AppsWorkordersApiUpdateProductionReportGlobalMutationError = unknown

    /**
 * @summary Update Production Report Global
 */
export const useAppsWorkordersApiUpdateProductionReportGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>, TError,{productionReportId: number;data: ProductionReportUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUpdateProductionReportGlobal>>,
        TError,
        {productionReportId: number;data: ProductionReportUpdateIn},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUpdateProductionReportGlobalMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Production Report Global
 */
export type appsWorkordersApiDeleteProductionReportGlobalResponse204 = {
  data: void
  status: 204
}

export type appsWorkordersApiDeleteProductionReportGlobalResponseSuccess = (appsWorkordersApiDeleteProductionReportGlobalResponse204) & {
  headers: Headers;
};
;

export type appsWorkordersApiDeleteProductionReportGlobalResponse = (appsWorkordersApiDeleteProductionReportGlobalResponseSuccess)

export const getAppsWorkordersApiDeleteProductionReportGlobalUrl = (productionReportId: number,) => {




  return `/api/production-reports/${productionReportId}/`
}

export const appsWorkordersApiDeleteProductionReportGlobal = async (productionReportId: number, options?: RequestInit): Promise<appsWorkordersApiDeleteProductionReportGlobalResponse> => {

  return customFetch<appsWorkordersApiDeleteProductionReportGlobalResponse>(getAppsWorkordersApiDeleteProductionReportGlobalUrl(productionReportId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWorkordersApiDeleteProductionReportGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>, TError,{productionReportId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiDeleteProductionReportGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>, {productionReportId: number}> = (props) => {
          const {productionReportId} = props ?? {};

          return  appsWorkordersApiDeleteProductionReportGlobal(productionReportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiDeleteProductionReportGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>>

    export type AppsWorkordersApiDeleteProductionReportGlobalMutationError = unknown

    /**
 * @summary Delete Production Report Global
 */
export const useAppsWorkordersApiDeleteProductionReportGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiDeleteProductionReportGlobal>>,
        TError,
        {productionReportId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiDeleteProductionReportGlobalMutationOptions(options), queryClient);
    }

/**
 * Cross-WO ProductionReport getter — must come after static drafts/
so Ninja URL-matching dispatches correctly.
 * @summary Get Production Report Global
 */
export type appsWorkordersApiGetProductionReportGlobalResponse200 = {
  data: ProductionReportOut
  status: 200
}

export type appsWorkordersApiGetProductionReportGlobalResponseSuccess = (appsWorkordersApiGetProductionReportGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiGetProductionReportGlobalResponse = (appsWorkordersApiGetProductionReportGlobalResponseSuccess)

export const getAppsWorkordersApiGetProductionReportGlobalUrl = (productionReportId: number,) => {




  return `/api/production-reports/${productionReportId}/`
}

export const appsWorkordersApiGetProductionReportGlobal = async (productionReportId: number, options?: RequestInit): Promise<appsWorkordersApiGetProductionReportGlobalResponse> => {

  return customFetch<appsWorkordersApiGetProductionReportGlobalResponse>(getAppsWorkordersApiGetProductionReportGlobalUrl(productionReportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiGetProductionReportGlobalQueryKey = (productionReportId: number,) => {
    return [
    `/api/production-reports/${productionReportId}/`
    ] as const;
    }


export const getAppsWorkordersApiGetProductionReportGlobalQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError = unknown>(productionReportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiGetProductionReportGlobalQueryKey(productionReportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>> = ({ signal }) => appsWorkordersApiGetProductionReportGlobal(productionReportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(productionReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiGetProductionReportGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>>
export type AppsWorkordersApiGetProductionReportGlobalQueryError = unknown


export function useAppsWorkordersApiGetProductionReportGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError = unknown>(
 productionReportId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetProductionReportGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError = unknown>(
 productionReportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiGetProductionReportGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError = unknown>(
 productionReportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Production Report Global
 */

export function useAppsWorkordersApiGetProductionReportGlobal<TData = Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError = unknown>(
 productionReportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiGetProductionReportGlobal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiGetProductionReportGlobalQueryOptions(productionReportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Post Production Report Global
 */
export type appsWorkordersApiPostProductionReportGlobalResponse200 = {
  data: ProductionReportOut
  status: 200
}

export type appsWorkordersApiPostProductionReportGlobalResponseSuccess = (appsWorkordersApiPostProductionReportGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiPostProductionReportGlobalResponse = (appsWorkordersApiPostProductionReportGlobalResponseSuccess)

export const getAppsWorkordersApiPostProductionReportGlobalUrl = (productionReportId: number,) => {




  return `/api/production-reports/${productionReportId}/post/`
}

export const appsWorkordersApiPostProductionReportGlobal = async (productionReportId: number, options?: RequestInit): Promise<appsWorkordersApiPostProductionReportGlobalResponse> => {

  return customFetch<appsWorkordersApiPostProductionReportGlobalResponse>(getAppsWorkordersApiPostProductionReportGlobalUrl(productionReportId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWorkordersApiPostProductionReportGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>, TError,{productionReportId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiPostProductionReportGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>, {productionReportId: number}> = (props) => {
          const {productionReportId} = props ?? {};

          return  appsWorkordersApiPostProductionReportGlobal(productionReportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiPostProductionReportGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>>

    export type AppsWorkordersApiPostProductionReportGlobalMutationError = unknown

    /**
 * @summary Post Production Report Global
 */
export const useAppsWorkordersApiPostProductionReportGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiPostProductionReportGlobal>>,
        TError,
        {productionReportId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiPostProductionReportGlobalMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Production Report Global
 */
export type appsWorkordersApiUnpostProductionReportGlobalResponse200 = {
  data: ProductionReportOut
  status: 200
}

export type appsWorkordersApiUnpostProductionReportGlobalResponseSuccess = (appsWorkordersApiUnpostProductionReportGlobalResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiUnpostProductionReportGlobalResponse = (appsWorkordersApiUnpostProductionReportGlobalResponseSuccess)

export const getAppsWorkordersApiUnpostProductionReportGlobalUrl = (productionReportId: number,) => {




  return `/api/production-reports/${productionReportId}/unpost/`
}

export const appsWorkordersApiUnpostProductionReportGlobal = async (productionReportId: number, options?: RequestInit): Promise<appsWorkordersApiUnpostProductionReportGlobalResponse> => {

  return customFetch<appsWorkordersApiUnpostProductionReportGlobalResponse>(getAppsWorkordersApiUnpostProductionReportGlobalUrl(productionReportId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWorkordersApiUnpostProductionReportGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>, TError,{productionReportId: number}, TContext> => {

const mutationKey = ['appsWorkordersApiUnpostProductionReportGlobal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>, {productionReportId: number}> = (props) => {
          const {productionReportId} = props ?? {};

          return  appsWorkordersApiUnpostProductionReportGlobal(productionReportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWorkordersApiUnpostProductionReportGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>>

    export type AppsWorkordersApiUnpostProductionReportGlobalMutationError = unknown

    /**
 * @summary Unpost Production Report Global
 */
export const useAppsWorkordersApiUnpostProductionReportGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>, TError,{productionReportId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWorkordersApiUnpostProductionReportGlobal>>,
        TError,
        {productionReportId: number},
        TContext
      > => {
      return useMutation(getAppsWorkordersApiUnpostProductionReportGlobalMutationOptions(options), queryClient);
    }

/**
 * Проведені наряди, у яких ще є невидане з плану видачі.

Залишок рахується по рядках плану (`left_to_issue_by_line`); наряд у черзі,
якщо сума > 0.
 * @summary Storekeeping Pending
 */
export type appsWorkordersApiStorekeepingPendingResponse200 = {
  data: PendingWOOut[]
  status: 200
}

export type appsWorkordersApiStorekeepingPendingResponseSuccess = (appsWorkordersApiStorekeepingPendingResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiStorekeepingPendingResponse = (appsWorkordersApiStorekeepingPendingResponseSuccess)

export const getAppsWorkordersApiStorekeepingPendingUrl = () => {




  return `/api/storekeeping/pending/`
}

export const appsWorkordersApiStorekeepingPending = async ( options?: RequestInit): Promise<appsWorkordersApiStorekeepingPendingResponse> => {

  return customFetch<appsWorkordersApiStorekeepingPendingResponse>(getAppsWorkordersApiStorekeepingPendingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiStorekeepingPendingQueryKey = () => {
    return [
    `/api/storekeeping/pending/`
    ] as const;
    }


export const getAppsWorkordersApiStorekeepingPendingQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiStorekeepingPendingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>> = ({ signal }) => appsWorkordersApiStorekeepingPending({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiStorekeepingPendingQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>>
export type AppsWorkordersApiStorekeepingPendingQueryError = unknown


export function useAppsWorkordersApiStorekeepingPending<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiStorekeepingPending<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiStorekeepingPending<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Storekeeping Pending
 */

export function useAppsWorkordersApiStorekeepingPending<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingPending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiStorekeepingPendingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Storekeeping Today
 */
export type appsWorkordersApiStorekeepingTodayResponse200 = {
  data: MaterialIssueOut[]
  status: 200
}

export type appsWorkordersApiStorekeepingTodayResponseSuccess = (appsWorkordersApiStorekeepingTodayResponse200) & {
  headers: Headers;
};
;

export type appsWorkordersApiStorekeepingTodayResponse = (appsWorkordersApiStorekeepingTodayResponseSuccess)

export const getAppsWorkordersApiStorekeepingTodayUrl = () => {




  return `/api/storekeeping/today/`
}

export const appsWorkordersApiStorekeepingToday = async ( options?: RequestInit): Promise<appsWorkordersApiStorekeepingTodayResponse> => {

  return customFetch<appsWorkordersApiStorekeepingTodayResponse>(getAppsWorkordersApiStorekeepingTodayUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWorkordersApiStorekeepingTodayQueryKey = () => {
    return [
    `/api/storekeeping/today/`
    ] as const;
    }


export const getAppsWorkordersApiStorekeepingTodayQueryOptions = <TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWorkordersApiStorekeepingTodayQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>> = ({ signal }) => appsWorkordersApiStorekeepingToday({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWorkordersApiStorekeepingTodayQueryResult = NonNullable<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>>
export type AppsWorkordersApiStorekeepingTodayQueryError = unknown


export function useAppsWorkordersApiStorekeepingToday<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiStorekeepingToday<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>,
          TError,
          Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWorkordersApiStorekeepingToday<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Storekeeping Today
 */

export function useAppsWorkordersApiStorekeepingToday<TData = Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWorkordersApiStorekeepingToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWorkordersApiStorekeepingTodayQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Warehouses
 */
export type appsWarehouseApiListWarehousesResponse200 = {
  data: WarehouseOut[]
  status: 200
}

export type appsWarehouseApiListWarehousesResponseSuccess = (appsWarehouseApiListWarehousesResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiListWarehousesResponse = (appsWarehouseApiListWarehousesResponseSuccess)

export const getAppsWarehouseApiListWarehousesUrl = (params?: AppsWarehouseApiListWarehousesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/warehouses?${stringifiedParams}` : `/api/catalog/warehouses`
}

export const appsWarehouseApiListWarehouses = async (params?: AppsWarehouseApiListWarehousesParams, options?: RequestInit): Promise<appsWarehouseApiListWarehousesResponse> => {

  return customFetch<appsWarehouseApiListWarehousesResponse>(getAppsWarehouseApiListWarehousesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiListWarehousesQueryKey = (params?: AppsWarehouseApiListWarehousesParams,) => {
    return [
    `/api/catalog/warehouses`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWarehouseApiListWarehousesQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError = unknown>(params?: AppsWarehouseApiListWarehousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiListWarehousesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>> = ({ signal }) => appsWarehouseApiListWarehouses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiListWarehousesQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>>
export type AppsWarehouseApiListWarehousesQueryError = unknown


export function useAppsWarehouseApiListWarehouses<TData = Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError = unknown>(
 params: undefined |  AppsWarehouseApiListWarehousesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListWarehouses<TData = Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError = unknown>(
 params?: AppsWarehouseApiListWarehousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListWarehouses<TData = Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError = unknown>(
 params?: AppsWarehouseApiListWarehousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Warehouses
 */

export function useAppsWarehouseApiListWarehouses<TData = Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError = unknown>(
 params?: AppsWarehouseApiListWarehousesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListWarehouses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiListWarehousesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Warehouse Endpoint
 */
export type appsWarehouseApiCreateWarehouseEndpointResponse201 = {
  data: WarehouseOut
  status: 201
}

export type appsWarehouseApiCreateWarehouseEndpointResponseSuccess = (appsWarehouseApiCreateWarehouseEndpointResponse201) & {
  headers: Headers;
};
;

export type appsWarehouseApiCreateWarehouseEndpointResponse = (appsWarehouseApiCreateWarehouseEndpointResponseSuccess)

export const getAppsWarehouseApiCreateWarehouseEndpointUrl = () => {




  return `/api/catalog/warehouses`
}

export const appsWarehouseApiCreateWarehouseEndpoint = async (warehouseIn: WarehouseIn, options?: RequestInit): Promise<appsWarehouseApiCreateWarehouseEndpointResponse> => {

  return customFetch<appsWarehouseApiCreateWarehouseEndpointResponse>(getAppsWarehouseApiCreateWarehouseEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      warehouseIn,)
  }
);}




export const getAppsWarehouseApiCreateWarehouseEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>, TError,{data: WarehouseIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>, TError,{data: WarehouseIn}, TContext> => {

const mutationKey = ['appsWarehouseApiCreateWarehouseEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>, {data: WarehouseIn}> = (props) => {
          const {data} = props ?? {};

          return  appsWarehouseApiCreateWarehouseEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiCreateWarehouseEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>>
    export type AppsWarehouseApiCreateWarehouseEndpointMutationBody = WarehouseIn
    export type AppsWarehouseApiCreateWarehouseEndpointMutationError = unknown

    /**
 * @summary Create Warehouse Endpoint
 */
export const useAppsWarehouseApiCreateWarehouseEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>, TError,{data: WarehouseIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiCreateWarehouseEndpoint>>,
        TError,
        {data: WarehouseIn},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiCreateWarehouseEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Get Warehouse
 */
export type appsWarehouseApiGetWarehouseResponse200 = {
  data: WarehouseOut
  status: 200
}

export type appsWarehouseApiGetWarehouseResponseSuccess = (appsWarehouseApiGetWarehouseResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiGetWarehouseResponse = (appsWarehouseApiGetWarehouseResponseSuccess)

export const getAppsWarehouseApiGetWarehouseUrl = (warehouseId: number,) => {




  return `/api/catalog/warehouses/${warehouseId}`
}

export const appsWarehouseApiGetWarehouse = async (warehouseId: number, options?: RequestInit): Promise<appsWarehouseApiGetWarehouseResponse> => {

  return customFetch<appsWarehouseApiGetWarehouseResponse>(getAppsWarehouseApiGetWarehouseUrl(warehouseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiGetWarehouseQueryKey = (warehouseId: number,) => {
    return [
    `/api/catalog/warehouses/${warehouseId}`
    ] as const;
    }


export const getAppsWarehouseApiGetWarehouseQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError = unknown>(warehouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiGetWarehouseQueryKey(warehouseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>> = ({ signal }) => appsWarehouseApiGetWarehouse(warehouseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(warehouseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiGetWarehouseQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>>
export type AppsWarehouseApiGetWarehouseQueryError = unknown


export function useAppsWarehouseApiGetWarehouse<TData = Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError = unknown>(
 warehouseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetWarehouse<TData = Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError = unknown>(
 warehouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetWarehouse<TData = Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError = unknown>(
 warehouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Warehouse
 */

export function useAppsWarehouseApiGetWarehouse<TData = Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError = unknown>(
 warehouseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetWarehouse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiGetWarehouseQueryOptions(warehouseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Patch Warehouse
 */
export type appsWarehouseApiPatchWarehouseResponse200 = {
  data: WarehouseOut
  status: 200
}

export type appsWarehouseApiPatchWarehouseResponseSuccess = (appsWarehouseApiPatchWarehouseResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiPatchWarehouseResponse = (appsWarehouseApiPatchWarehouseResponseSuccess)

export const getAppsWarehouseApiPatchWarehouseUrl = (warehouseId: number,) => {




  return `/api/catalog/warehouses/${warehouseId}`
}

export const appsWarehouseApiPatchWarehouse = async (warehouseId: number,
    warehousePatch: WarehousePatch, options?: RequestInit): Promise<appsWarehouseApiPatchWarehouseResponse> => {

  return customFetch<appsWarehouseApiPatchWarehouseResponse>(getAppsWarehouseApiPatchWarehouseUrl(warehouseId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      warehousePatch,)
  }
);}




export const getAppsWarehouseApiPatchWarehouseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>, TError,{warehouseId: number;data: WarehousePatch}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>, TError,{warehouseId: number;data: WarehousePatch}, TContext> => {

const mutationKey = ['appsWarehouseApiPatchWarehouse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>, {warehouseId: number;data: WarehousePatch}> = (props) => {
          const {warehouseId,data} = props ?? {};

          return  appsWarehouseApiPatchWarehouse(warehouseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiPatchWarehouseMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>>
    export type AppsWarehouseApiPatchWarehouseMutationBody = WarehousePatch
    export type AppsWarehouseApiPatchWarehouseMutationError = unknown

    /**
 * @summary Patch Warehouse
 */
export const useAppsWarehouseApiPatchWarehouse = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>, TError,{warehouseId: number;data: WarehousePatch}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiPatchWarehouse>>,
        TError,
        {warehouseId: number;data: WarehousePatch},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiPatchWarehouseMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Warehouse Endpoint
 */
export type appsWarehouseApiDeleteWarehouseEndpointResponse204 = {
  data: void
  status: 204
}

export type appsWarehouseApiDeleteWarehouseEndpointResponseSuccess = (appsWarehouseApiDeleteWarehouseEndpointResponse204) & {
  headers: Headers;
};
;

export type appsWarehouseApiDeleteWarehouseEndpointResponse = (appsWarehouseApiDeleteWarehouseEndpointResponseSuccess)

export const getAppsWarehouseApiDeleteWarehouseEndpointUrl = (warehouseId: number,) => {




  return `/api/catalog/warehouses/${warehouseId}`
}

export const appsWarehouseApiDeleteWarehouseEndpoint = async (warehouseId: number, options?: RequestInit): Promise<appsWarehouseApiDeleteWarehouseEndpointResponse> => {

  return customFetch<appsWarehouseApiDeleteWarehouseEndpointResponse>(getAppsWarehouseApiDeleteWarehouseEndpointUrl(warehouseId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWarehouseApiDeleteWarehouseEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>, TError,{warehouseId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>, TError,{warehouseId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiDeleteWarehouseEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>, {warehouseId: number}> = (props) => {
          const {warehouseId} = props ?? {};

          return  appsWarehouseApiDeleteWarehouseEndpoint(warehouseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiDeleteWarehouseEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>>

    export type AppsWarehouseApiDeleteWarehouseEndpointMutationError = unknown

    /**
 * @summary Delete Warehouse Endpoint
 */
export const useAppsWarehouseApiDeleteWarehouseEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>, TError,{warehouseId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiDeleteWarehouseEndpoint>>,
        TError,
        {warehouseId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiDeleteWarehouseEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary List Goods Receipts
 */
export type appsWarehouseApiListGoodsReceiptsResponse200 = {
  data: GoodsReceiptOut[]
  status: 200
}

export type appsWarehouseApiListGoodsReceiptsResponseSuccess = (appsWarehouseApiListGoodsReceiptsResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiListGoodsReceiptsResponse = (appsWarehouseApiListGoodsReceiptsResponseSuccess)

export const getAppsWarehouseApiListGoodsReceiptsUrl = (params?: AppsWarehouseApiListGoodsReceiptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/warehouse/goods-receipts/?${stringifiedParams}` : `/api/warehouse/goods-receipts/`
}

export const appsWarehouseApiListGoodsReceipts = async (params?: AppsWarehouseApiListGoodsReceiptsParams, options?: RequestInit): Promise<appsWarehouseApiListGoodsReceiptsResponse> => {

  return customFetch<appsWarehouseApiListGoodsReceiptsResponse>(getAppsWarehouseApiListGoodsReceiptsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiListGoodsReceiptsQueryKey = (params?: AppsWarehouseApiListGoodsReceiptsParams,) => {
    return [
    `/api/warehouse/goods-receipts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWarehouseApiListGoodsReceiptsQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError = unknown>(params?: AppsWarehouseApiListGoodsReceiptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiListGoodsReceiptsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>> = ({ signal }) => appsWarehouseApiListGoodsReceipts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiListGoodsReceiptsQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>>
export type AppsWarehouseApiListGoodsReceiptsQueryError = unknown


export function useAppsWarehouseApiListGoodsReceipts<TData = Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError = unknown>(
 params: undefined |  AppsWarehouseApiListGoodsReceiptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListGoodsReceipts<TData = Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError = unknown>(
 params?: AppsWarehouseApiListGoodsReceiptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListGoodsReceipts<TData = Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError = unknown>(
 params?: AppsWarehouseApiListGoodsReceiptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Goods Receipts
 */

export function useAppsWarehouseApiListGoodsReceipts<TData = Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError = unknown>(
 params?: AppsWarehouseApiListGoodsReceiptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListGoodsReceipts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiListGoodsReceiptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Goods Receipt
 */
export type appsWarehouseApiCreateGoodsReceiptResponse201 = {
  data: GoodsReceiptOut
  status: 201
}

export type appsWarehouseApiCreateGoodsReceiptResponseSuccess = (appsWarehouseApiCreateGoodsReceiptResponse201) & {
  headers: Headers;
};
;

export type appsWarehouseApiCreateGoodsReceiptResponse = (appsWarehouseApiCreateGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiCreateGoodsReceiptUrl = () => {




  return `/api/warehouse/goods-receipts/`
}

export const appsWarehouseApiCreateGoodsReceipt = async (goodsReceiptCreateIn: GoodsReceiptCreateIn, options?: RequestInit): Promise<appsWarehouseApiCreateGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiCreateGoodsReceiptResponse>(getAppsWarehouseApiCreateGoodsReceiptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      goodsReceiptCreateIn,)
  }
);}




export const getAppsWarehouseApiCreateGoodsReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>, TError,{data: GoodsReceiptCreateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>, TError,{data: GoodsReceiptCreateIn}, TContext> => {

const mutationKey = ['appsWarehouseApiCreateGoodsReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>, {data: GoodsReceiptCreateIn}> = (props) => {
          const {data} = props ?? {};

          return  appsWarehouseApiCreateGoodsReceipt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiCreateGoodsReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>>
    export type AppsWarehouseApiCreateGoodsReceiptMutationBody = GoodsReceiptCreateIn
    export type AppsWarehouseApiCreateGoodsReceiptMutationError = unknown

    /**
 * @summary Create Goods Receipt
 */
export const useAppsWarehouseApiCreateGoodsReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>, TError,{data: GoodsReceiptCreateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceipt>>,
        TError,
        {data: GoodsReceiptCreateIn},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiCreateGoodsReceiptMutationOptions(options), queryClient);
    }

/**
 * Створює GR draft. Без body — порожній (legacy). З
`{production_report_id, autofill_from_pr:true}` — quick auto-fill з PR.

Має бути зареєстрований **перед** `/warehouse/goods-receipts/{goods_receipt_id}/`,
інакше Django-Ninja матчить `drafts` як `goods_receipt_id` і повертає 405.
 * @summary Create Goods Receipt Empty Draft
 */
export type appsWarehouseApiCreateGoodsReceiptEmptyDraftResponse201 = {
  data: GoodsReceiptOut
  status: 201
}

export type appsWarehouseApiCreateGoodsReceiptEmptyDraftResponseSuccess = (appsWarehouseApiCreateGoodsReceiptEmptyDraftResponse201) & {
  headers: Headers;
};
;

export type appsWarehouseApiCreateGoodsReceiptEmptyDraftResponse = (appsWarehouseApiCreateGoodsReceiptEmptyDraftResponseSuccess)

export const getAppsWarehouseApiCreateGoodsReceiptEmptyDraftUrl = () => {




  return `/api/warehouse/goods-receipts/drafts/`
}

export const appsWarehouseApiCreateGoodsReceiptEmptyDraft = async (goodsReceiptDraftCreateInNull?: GoodsReceiptDraftCreateIn | null, options?: RequestInit): Promise<appsWarehouseApiCreateGoodsReceiptEmptyDraftResponse> => {

  return customFetch<appsWarehouseApiCreateGoodsReceiptEmptyDraftResponse>(getAppsWarehouseApiCreateGoodsReceiptEmptyDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      goodsReceiptDraftCreateInNull,)
  }
);}




export const getAppsWarehouseApiCreateGoodsReceiptEmptyDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>, TError,{data?: GoodsReceiptDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>, TError,{data?: GoodsReceiptDraftCreateIn | null}, TContext> => {

const mutationKey = ['appsWarehouseApiCreateGoodsReceiptEmptyDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>, {data?: GoodsReceiptDraftCreateIn | null}> = (props) => {
          const {data} = props ?? {};

          return  appsWarehouseApiCreateGoodsReceiptEmptyDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiCreateGoodsReceiptEmptyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>>
    export type AppsWarehouseApiCreateGoodsReceiptEmptyDraftMutationBody = GoodsReceiptDraftCreateIn | null | undefined
    export type AppsWarehouseApiCreateGoodsReceiptEmptyDraftMutationError = unknown

    /**
 * @summary Create Goods Receipt Empty Draft
 */
export const useAppsWarehouseApiCreateGoodsReceiptEmptyDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>, TError,{data?: GoodsReceiptDraftCreateIn | null}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiCreateGoodsReceiptEmptyDraft>>,
        TError,
        {data?: GoodsReceiptDraftCreateIn | null},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiCreateGoodsReceiptEmptyDraftMutationOptions(options), queryClient);
    }

/**
 * @summary Get Goods Receipt
 */
export type appsWarehouseApiGetGoodsReceiptResponse200 = {
  data: GoodsReceiptOut
  status: 200
}

export type appsWarehouseApiGetGoodsReceiptResponseSuccess = (appsWarehouseApiGetGoodsReceiptResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiGetGoodsReceiptResponse = (appsWarehouseApiGetGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiGetGoodsReceiptUrl = (goodsReceiptId: number,) => {




  return `/api/warehouse/goods-receipts/${goodsReceiptId}/`
}

export const appsWarehouseApiGetGoodsReceipt = async (goodsReceiptId: number, options?: RequestInit): Promise<appsWarehouseApiGetGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiGetGoodsReceiptResponse>(getAppsWarehouseApiGetGoodsReceiptUrl(goodsReceiptId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiGetGoodsReceiptQueryKey = (goodsReceiptId: number,) => {
    return [
    `/api/warehouse/goods-receipts/${goodsReceiptId}/`
    ] as const;
    }


export const getAppsWarehouseApiGetGoodsReceiptQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError = unknown>(goodsReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiGetGoodsReceiptQueryKey(goodsReceiptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>> = ({ signal }) => appsWarehouseApiGetGoodsReceipt(goodsReceiptId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(goodsReceiptId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiGetGoodsReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>>
export type AppsWarehouseApiGetGoodsReceiptQueryError = unknown


export function useAppsWarehouseApiGetGoodsReceipt<TData = Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError = unknown>(
 goodsReceiptId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetGoodsReceipt<TData = Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError = unknown>(
 goodsReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetGoodsReceipt<TData = Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError = unknown>(
 goodsReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Goods Receipt
 */

export function useAppsWarehouseApiGetGoodsReceipt<TData = Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError = unknown>(
 goodsReceiptId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetGoodsReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiGetGoodsReceiptQueryOptions(goodsReceiptId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Goods Receipt
 */
export type appsWarehouseApiUpdateGoodsReceiptResponse200 = {
  data: GoodsReceiptOut
  status: 200
}

export type appsWarehouseApiUpdateGoodsReceiptResponseSuccess = (appsWarehouseApiUpdateGoodsReceiptResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiUpdateGoodsReceiptResponse = (appsWarehouseApiUpdateGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiUpdateGoodsReceiptUrl = (goodsReceiptId: number,) => {




  return `/api/warehouse/goods-receipts/${goodsReceiptId}/`
}

export const appsWarehouseApiUpdateGoodsReceipt = async (goodsReceiptId: number,
    goodsReceiptUpdateIn: GoodsReceiptUpdateIn, options?: RequestInit): Promise<appsWarehouseApiUpdateGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiUpdateGoodsReceiptResponse>(getAppsWarehouseApiUpdateGoodsReceiptUrl(goodsReceiptId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      goodsReceiptUpdateIn,)
  }
);}




export const getAppsWarehouseApiUpdateGoodsReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>, TError,{goodsReceiptId: number;data: GoodsReceiptUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>, TError,{goodsReceiptId: number;data: GoodsReceiptUpdateIn}, TContext> => {

const mutationKey = ['appsWarehouseApiUpdateGoodsReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>, {goodsReceiptId: number;data: GoodsReceiptUpdateIn}> = (props) => {
          const {goodsReceiptId,data} = props ?? {};

          return  appsWarehouseApiUpdateGoodsReceipt(goodsReceiptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiUpdateGoodsReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>>
    export type AppsWarehouseApiUpdateGoodsReceiptMutationBody = GoodsReceiptUpdateIn
    export type AppsWarehouseApiUpdateGoodsReceiptMutationError = unknown

    /**
 * @summary Update Goods Receipt
 */
export const useAppsWarehouseApiUpdateGoodsReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>, TError,{goodsReceiptId: number;data: GoodsReceiptUpdateIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiUpdateGoodsReceipt>>,
        TError,
        {goodsReceiptId: number;data: GoodsReceiptUpdateIn},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiUpdateGoodsReceiptMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Goods Receipt
 */
export type appsWarehouseApiDeleteGoodsReceiptResponse204 = {
  data: void
  status: 204
}

export type appsWarehouseApiDeleteGoodsReceiptResponseSuccess = (appsWarehouseApiDeleteGoodsReceiptResponse204) & {
  headers: Headers;
};
;

export type appsWarehouseApiDeleteGoodsReceiptResponse = (appsWarehouseApiDeleteGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiDeleteGoodsReceiptUrl = (goodsReceiptId: number,) => {




  return `/api/warehouse/goods-receipts/${goodsReceiptId}/`
}

export const appsWarehouseApiDeleteGoodsReceipt = async (goodsReceiptId: number, options?: RequestInit): Promise<appsWarehouseApiDeleteGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiDeleteGoodsReceiptResponse>(getAppsWarehouseApiDeleteGoodsReceiptUrl(goodsReceiptId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWarehouseApiDeleteGoodsReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiDeleteGoodsReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>, {goodsReceiptId: number}> = (props) => {
          const {goodsReceiptId} = props ?? {};

          return  appsWarehouseApiDeleteGoodsReceipt(goodsReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiDeleteGoodsReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>>

    export type AppsWarehouseApiDeleteGoodsReceiptMutationError = unknown

    /**
 * @summary Delete Goods Receipt
 */
export const useAppsWarehouseApiDeleteGoodsReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiDeleteGoodsReceipt>>,
        TError,
        {goodsReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiDeleteGoodsReceiptMutationOptions(options), queryClient);
    }

/**
 * @summary Post Goods Receipt
 */
export type appsWarehouseApiPostGoodsReceiptResponse200 = {
  data: GoodsReceiptOut
  status: 200
}

export type appsWarehouseApiPostGoodsReceiptResponseSuccess = (appsWarehouseApiPostGoodsReceiptResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiPostGoodsReceiptResponse = (appsWarehouseApiPostGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiPostGoodsReceiptUrl = (goodsReceiptId: number,) => {




  return `/api/warehouse/goods-receipts/${goodsReceiptId}/post/`
}

export const appsWarehouseApiPostGoodsReceipt = async (goodsReceiptId: number, options?: RequestInit): Promise<appsWarehouseApiPostGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiPostGoodsReceiptResponse>(getAppsWarehouseApiPostGoodsReceiptUrl(goodsReceiptId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWarehouseApiPostGoodsReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiPostGoodsReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>, {goodsReceiptId: number}> = (props) => {
          const {goodsReceiptId} = props ?? {};

          return  appsWarehouseApiPostGoodsReceipt(goodsReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiPostGoodsReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>>

    export type AppsWarehouseApiPostGoodsReceiptMutationError = unknown

    /**
 * @summary Post Goods Receipt
 */
export const useAppsWarehouseApiPostGoodsReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiPostGoodsReceipt>>,
        TError,
        {goodsReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiPostGoodsReceiptMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Goods Receipt
 */
export type appsWarehouseApiUnpostGoodsReceiptResponse200 = {
  data: GoodsReceiptOut
  status: 200
}

export type appsWarehouseApiUnpostGoodsReceiptResponseSuccess = (appsWarehouseApiUnpostGoodsReceiptResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiUnpostGoodsReceiptResponse = (appsWarehouseApiUnpostGoodsReceiptResponseSuccess)

export const getAppsWarehouseApiUnpostGoodsReceiptUrl = (goodsReceiptId: number,) => {




  return `/api/warehouse/goods-receipts/${goodsReceiptId}/unpost/`
}

export const appsWarehouseApiUnpostGoodsReceipt = async (goodsReceiptId: number, options?: RequestInit): Promise<appsWarehouseApiUnpostGoodsReceiptResponse> => {

  return customFetch<appsWarehouseApiUnpostGoodsReceiptResponse>(getAppsWarehouseApiUnpostGoodsReceiptUrl(goodsReceiptId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWarehouseApiUnpostGoodsReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiUnpostGoodsReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>, {goodsReceiptId: number}> = (props) => {
          const {goodsReceiptId} = props ?? {};

          return  appsWarehouseApiUnpostGoodsReceipt(goodsReceiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiUnpostGoodsReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>>

    export type AppsWarehouseApiUnpostGoodsReceiptMutationError = unknown

    /**
 * @summary Unpost Goods Receipt
 */
export const useAppsWarehouseApiUnpostGoodsReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>, TError,{goodsReceiptId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiUnpostGoodsReceipt>>,
        TError,
        {goodsReceiptId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiUnpostGoodsReceiptMutationOptions(options), queryClient);
    }

/**
 * Cross-warehouse Transfer list.

`project_id` фільтр — через ``target_project_id`` (ADR-0006: власність
несе сам stock / документ, не склад).
 * @summary List Transfers
 */
export type appsWarehouseApiListTransfersResponse200 = {
  data: TransferOut[]
  status: 200
}

export type appsWarehouseApiListTransfersResponseSuccess = (appsWarehouseApiListTransfersResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiListTransfersResponse = (appsWarehouseApiListTransfersResponseSuccess)

export const getAppsWarehouseApiListTransfersUrl = (params?: AppsWarehouseApiListTransfersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/transfers?${stringifiedParams}` : `/api/transfers`
}

export const appsWarehouseApiListTransfers = async (params?: AppsWarehouseApiListTransfersParams, options?: RequestInit): Promise<appsWarehouseApiListTransfersResponse> => {

  return customFetch<appsWarehouseApiListTransfersResponse>(getAppsWarehouseApiListTransfersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiListTransfersQueryKey = (params?: AppsWarehouseApiListTransfersParams,) => {
    return [
    `/api/transfers`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsWarehouseApiListTransfersQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError = unknown>(params?: AppsWarehouseApiListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiListTransfersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>> = ({ signal }) => appsWarehouseApiListTransfers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiListTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>>
export type AppsWarehouseApiListTransfersQueryError = unknown


export function useAppsWarehouseApiListTransfers<TData = Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError = unknown>(
 params: undefined |  AppsWarehouseApiListTransfersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListTransfers<TData = Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError = unknown>(
 params?: AppsWarehouseApiListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiListTransfers<TData = Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError = unknown>(
 params?: AppsWarehouseApiListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Transfers
 */

export function useAppsWarehouseApiListTransfers<TData = Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError = unknown>(
 params?: AppsWarehouseApiListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiListTransfers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiListTransfersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Transfer
 */
export type appsWarehouseApiCreateTransferResponse201 = {
  data: TransferOut
  status: 201
}

export type appsWarehouseApiCreateTransferResponseSuccess = (appsWarehouseApiCreateTransferResponse201) & {
  headers: Headers;
};
;

export type appsWarehouseApiCreateTransferResponse = (appsWarehouseApiCreateTransferResponseSuccess)

export const getAppsWarehouseApiCreateTransferUrl = () => {




  return `/api/transfers`
}

export const appsWarehouseApiCreateTransfer = async (transferIn: TransferIn, options?: RequestInit): Promise<appsWarehouseApiCreateTransferResponse> => {

  return customFetch<appsWarehouseApiCreateTransferResponse>(getAppsWarehouseApiCreateTransferUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferIn,)
  }
);}




export const getAppsWarehouseApiCreateTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>, TError,{data: TransferIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>, TError,{data: TransferIn}, TContext> => {

const mutationKey = ['appsWarehouseApiCreateTransfer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>, {data: TransferIn}> = (props) => {
          const {data} = props ?? {};

          return  appsWarehouseApiCreateTransfer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiCreateTransferMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>>
    export type AppsWarehouseApiCreateTransferMutationBody = TransferIn
    export type AppsWarehouseApiCreateTransferMutationError = unknown

    /**
 * @summary Create Transfer
 */
export const useAppsWarehouseApiCreateTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>, TError,{data: TransferIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiCreateTransfer>>,
        TError,
        {data: TransferIn},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiCreateTransferMutationOptions(options), queryClient);
    }

/**
 * Створює порожній DRAFT переміщення (одноекранний flow, як MIN/GR).

Склади/проєкт/рядки заповнюються у детальному редакторі. Реєструється
**перед** `/transfers/{transfer_id}` щоб `drafts` не матчилось як id.
 * @summary Create Transfer Empty Draft
 */
export type appsWarehouseApiCreateTransferEmptyDraftResponse201 = {
  data: TransferOut
  status: 201
}

export type appsWarehouseApiCreateTransferEmptyDraftResponseSuccess = (appsWarehouseApiCreateTransferEmptyDraftResponse201) & {
  headers: Headers;
};
;

export type appsWarehouseApiCreateTransferEmptyDraftResponse = (appsWarehouseApiCreateTransferEmptyDraftResponseSuccess)

export const getAppsWarehouseApiCreateTransferEmptyDraftUrl = () => {




  return `/api/transfers/drafts/`
}

export const appsWarehouseApiCreateTransferEmptyDraft = async ( options?: RequestInit): Promise<appsWarehouseApiCreateTransferEmptyDraftResponse> => {

  return customFetch<appsWarehouseApiCreateTransferEmptyDraftResponse>(getAppsWarehouseApiCreateTransferEmptyDraftUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWarehouseApiCreateTransferEmptyDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>, TError,void, TContext> => {

const mutationKey = ['appsWarehouseApiCreateTransferEmptyDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>, void> = () => {


          return  appsWarehouseApiCreateTransferEmptyDraft(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiCreateTransferEmptyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>>

    export type AppsWarehouseApiCreateTransferEmptyDraftMutationError = unknown

    /**
 * @summary Create Transfer Empty Draft
 */
export const useAppsWarehouseApiCreateTransferEmptyDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiCreateTransferEmptyDraft>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAppsWarehouseApiCreateTransferEmptyDraftMutationOptions(options), queryClient);
    }

/**
 * @summary Get Transfer
 */
export type appsWarehouseApiGetTransferResponse200 = {
  data: TransferOut
  status: 200
}

export type appsWarehouseApiGetTransferResponseSuccess = (appsWarehouseApiGetTransferResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiGetTransferResponse = (appsWarehouseApiGetTransferResponseSuccess)

export const getAppsWarehouseApiGetTransferUrl = (transferId: number,) => {




  return `/api/transfers/${transferId}`
}

export const appsWarehouseApiGetTransfer = async (transferId: number, options?: RequestInit): Promise<appsWarehouseApiGetTransferResponse> => {

  return customFetch<appsWarehouseApiGetTransferResponse>(getAppsWarehouseApiGetTransferUrl(transferId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsWarehouseApiGetTransferQueryKey = (transferId: number,) => {
    return [
    `/api/transfers/${transferId}`
    ] as const;
    }


export const getAppsWarehouseApiGetTransferQueryOptions = <TData = Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError = unknown>(transferId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsWarehouseApiGetTransferQueryKey(transferId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>> = ({ signal }) => appsWarehouseApiGetTransfer(transferId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(transferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsWarehouseApiGetTransferQueryResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>>
export type AppsWarehouseApiGetTransferQueryError = unknown


export function useAppsWarehouseApiGetTransfer<TData = Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError = unknown>(
 transferId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetTransfer<TData = Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError = unknown>(
 transferId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>,
          TError,
          Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsWarehouseApiGetTransfer<TData = Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError = unknown>(
 transferId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Transfer
 */

export function useAppsWarehouseApiGetTransfer<TData = Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError = unknown>(
 transferId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsWarehouseApiGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsWarehouseApiGetTransferQueryOptions(transferId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Patch Transfer
 */
export type appsWarehouseApiPatchTransferResponse200 = {
  data: TransferOut
  status: 200
}

export type appsWarehouseApiPatchTransferResponseSuccess = (appsWarehouseApiPatchTransferResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiPatchTransferResponse = (appsWarehouseApiPatchTransferResponseSuccess)

export const getAppsWarehouseApiPatchTransferUrl = (transferId: number,) => {




  return `/api/transfers/${transferId}`
}

export const appsWarehouseApiPatchTransfer = async (transferId: number,
    transferPatch: TransferPatch, options?: RequestInit): Promise<appsWarehouseApiPatchTransferResponse> => {

  return customFetch<appsWarehouseApiPatchTransferResponse>(getAppsWarehouseApiPatchTransferUrl(transferId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferPatch,)
  }
);}




export const getAppsWarehouseApiPatchTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>, TError,{transferId: number;data: TransferPatch}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>, TError,{transferId: number;data: TransferPatch}, TContext> => {

const mutationKey = ['appsWarehouseApiPatchTransfer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>, {transferId: number;data: TransferPatch}> = (props) => {
          const {transferId,data} = props ?? {};

          return  appsWarehouseApiPatchTransfer(transferId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiPatchTransferMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>>
    export type AppsWarehouseApiPatchTransferMutationBody = TransferPatch
    export type AppsWarehouseApiPatchTransferMutationError = unknown

    /**
 * @summary Patch Transfer
 */
export const useAppsWarehouseApiPatchTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>, TError,{transferId: number;data: TransferPatch}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiPatchTransfer>>,
        TError,
        {transferId: number;data: TransferPatch},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiPatchTransferMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Transfer
 */
export type appsWarehouseApiDeleteTransferResponse204 = {
  data: void
  status: 204
}

export type appsWarehouseApiDeleteTransferResponseSuccess = (appsWarehouseApiDeleteTransferResponse204) & {
  headers: Headers;
};
;

export type appsWarehouseApiDeleteTransferResponse = (appsWarehouseApiDeleteTransferResponseSuccess)

export const getAppsWarehouseApiDeleteTransferUrl = (transferId: number,) => {




  return `/api/transfers/${transferId}`
}

export const appsWarehouseApiDeleteTransfer = async (transferId: number, options?: RequestInit): Promise<appsWarehouseApiDeleteTransferResponse> => {

  return customFetch<appsWarehouseApiDeleteTransferResponse>(getAppsWarehouseApiDeleteTransferUrl(transferId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAppsWarehouseApiDeleteTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>, TError,{transferId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiDeleteTransfer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>, {transferId: number}> = (props) => {
          const {transferId} = props ?? {};

          return  appsWarehouseApiDeleteTransfer(transferId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiDeleteTransferMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>>

    export type AppsWarehouseApiDeleteTransferMutationError = unknown

    /**
 * @summary Delete Transfer
 */
export const useAppsWarehouseApiDeleteTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiDeleteTransfer>>,
        TError,
        {transferId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiDeleteTransferMutationOptions(options), queryClient);
    }

/**
 * @summary Post Transfer Endpoint
 */
export type appsWarehouseApiPostTransferEndpointResponse200 = {
  data: TransferOut
  status: 200
}

export type appsWarehouseApiPostTransferEndpointResponseSuccess = (appsWarehouseApiPostTransferEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiPostTransferEndpointResponse = (appsWarehouseApiPostTransferEndpointResponseSuccess)

export const getAppsWarehouseApiPostTransferEndpointUrl = (transferId: number,) => {




  return `/api/transfers/${transferId}/post`
}

export const appsWarehouseApiPostTransferEndpoint = async (transferId: number, options?: RequestInit): Promise<appsWarehouseApiPostTransferEndpointResponse> => {

  return customFetch<appsWarehouseApiPostTransferEndpointResponse>(getAppsWarehouseApiPostTransferEndpointUrl(transferId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWarehouseApiPostTransferEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>, TError,{transferId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiPostTransferEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>, {transferId: number}> = (props) => {
          const {transferId} = props ?? {};

          return  appsWarehouseApiPostTransferEndpoint(transferId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiPostTransferEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>>

    export type AppsWarehouseApiPostTransferEndpointMutationError = unknown

    /**
 * @summary Post Transfer Endpoint
 */
export const useAppsWarehouseApiPostTransferEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiPostTransferEndpoint>>,
        TError,
        {transferId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiPostTransferEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Unpost Transfer Endpoint
 */
export type appsWarehouseApiUnpostTransferEndpointResponse200 = {
  data: TransferOut
  status: 200
}

export type appsWarehouseApiUnpostTransferEndpointResponseSuccess = (appsWarehouseApiUnpostTransferEndpointResponse200) & {
  headers: Headers;
};
;

export type appsWarehouseApiUnpostTransferEndpointResponse = (appsWarehouseApiUnpostTransferEndpointResponseSuccess)

export const getAppsWarehouseApiUnpostTransferEndpointUrl = (transferId: number,) => {




  return `/api/transfers/${transferId}/unpost`
}

export const appsWarehouseApiUnpostTransferEndpoint = async (transferId: number, options?: RequestInit): Promise<appsWarehouseApiUnpostTransferEndpointResponse> => {

  return customFetch<appsWarehouseApiUnpostTransferEndpointResponse>(getAppsWarehouseApiUnpostTransferEndpointUrl(transferId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAppsWarehouseApiUnpostTransferEndpointMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>, TError,{transferId: number}, TContext> => {

const mutationKey = ['appsWarehouseApiUnpostTransferEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>, {transferId: number}> = (props) => {
          const {transferId} = props ?? {};

          return  appsWarehouseApiUnpostTransferEndpoint(transferId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppsWarehouseApiUnpostTransferEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>>

    export type AppsWarehouseApiUnpostTransferEndpointMutationError = unknown

    /**
 * @summary Unpost Transfer Endpoint
 */
export const useAppsWarehouseApiUnpostTransferEndpoint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>, TError,{transferId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appsWarehouseApiUnpostTransferEndpoint>>,
        TError,
        {transferId: number},
        TContext
      > => {
      return useMutation(getAppsWarehouseApiUnpostTransferEndpointMutationOptions(options), queryClient);
    }

/**
 * @summary Stock Movements
 */
export type appsReportsApiStockMovementsResponse200 = {
  data: StockMovementsReportOut
  status: 200
}

export type appsReportsApiStockMovementsResponseSuccess = (appsReportsApiStockMovementsResponse200) & {
  headers: Headers;
};
;

export type appsReportsApiStockMovementsResponse = (appsReportsApiStockMovementsResponseSuccess)

export const getAppsReportsApiStockMovementsUrl = (params: AppsReportsApiStockMovementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/stock-movements?${stringifiedParams}` : `/api/reports/stock-movements`
}

export const appsReportsApiStockMovements = async (params: AppsReportsApiStockMovementsParams, options?: RequestInit): Promise<appsReportsApiStockMovementsResponse> => {

  return customFetch<appsReportsApiStockMovementsResponse>(getAppsReportsApiStockMovementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppsReportsApiStockMovementsQueryKey = (params?: AppsReportsApiStockMovementsParams,) => {
    return [
    `/api/reports/stock-movements`, ...(params ? [params] : [])
    ] as const;
    }


export const getAppsReportsApiStockMovementsQueryOptions = <TData = Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError = unknown>(params: AppsReportsApiStockMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppsReportsApiStockMovementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appsReportsApiStockMovements>>> = ({ signal }) => appsReportsApiStockMovements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppsReportsApiStockMovementsQueryResult = NonNullable<Awaited<ReturnType<typeof appsReportsApiStockMovements>>>
export type AppsReportsApiStockMovementsQueryError = unknown


export function useAppsReportsApiStockMovements<TData = Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError = unknown>(
 params: AppsReportsApiStockMovementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsReportsApiStockMovements>>,
          TError,
          Awaited<ReturnType<typeof appsReportsApiStockMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsReportsApiStockMovements<TData = Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError = unknown>(
 params: AppsReportsApiStockMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appsReportsApiStockMovements>>,
          TError,
          Awaited<ReturnType<typeof appsReportsApiStockMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppsReportsApiStockMovements<TData = Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError = unknown>(
 params: AppsReportsApiStockMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stock Movements
 */

export function useAppsReportsApiStockMovements<TData = Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError = unknown>(
 params: AppsReportsApiStockMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appsReportsApiStockMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppsReportsApiStockMovementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
